function isSimple() {
    return document.querySelector("html").classList.contains("simple");
}

function reload(withQuerystring = false) {
    document.location = withQuerystring ? document.location.href : document.location.href.split('?')[0];
}

function forEach(arr, callback) {
    if (!arr) return;
    if (typeof arr === "string") arr = document.querySelectorAll(arr);
    Array.prototype.forEach.call(arr, callback);
};


function getValueFromNestedObject(obj, propPath) {
    let path = propPath.split('.');
    let current = obj;
    for (let prop of path) {
        if (current.hasOwnProperty(prop)) {
            current = current[prop];
        } else {
        }
    }
    return current;
}

function getNestedValue(obj, path) {
    const properties = path.split('.');
    let value = obj;

    for (let i = 0; i < properties.length; i++) {
        if (!value || !value.hasOwnProperty(properties[i])) {
            customLog(0, "Nothing found for propPath " + propPath);
            return undefined;
        }
        value = value[properties[i]];
    }

    return value;
}

function step(...params) {
    console.log(new Error().stack.match(/at (\S+)/g)[2]?.split(' ')[1] || 'unknown', ...params);
}
//function flattenObject(obj, parent, res = {}) {
//    for (let key in obj) {
//        let propName = parent ? parent + '.' + key : key;
//        if (typeof obj[key] == 'object') {
//            flattenObject(obj[key], propName, res);
//        } else {
//            res[propName] = obj[key];
//        }
//    }
//    return res;
//}

function localText(key, asLowercase, configId, fallbacks, pluralityAmount) {
    let keys = fallbacks ? [key].concat(fallbacks) : [key];
    let value = `MISSING: local.${key}.${localLanguage} fallbacks: ${fallbacks}`;
    if (!localLanguage) {
        localLanguage = document.querySelector("body").getAttribute("data-cc");
        if (!localLanguage) localLanguage = "da";
    }
    if (campaignConfigId !== undefined && configId === undefined) configId = campaignConfigId;
    for (let i = 0; i < keys.length; i++) {
        let base = keys[i] + ".";
        if (configId > 0) {
            let configKey = base + `cc${configId}.`;
            if (local[configKey + localLanguage]) {
                value = asLowercase ? local[configKey + localLanguage].toLowerCase() : local[configKey + localLanguage];
                break;
            }
            if (local[configKey + "da"]) {
                value = asLowercase ? local[configKey + "da"].toLowerCase() : local[configKey + "da"];
                break;
            }
        }
        if (local[base + localLanguage]) {
            value = asLowercase ? local[base + localLanguage].toLowerCase() : local[base + localLanguage];
            break;
        }
        if (local[base + "da"]) {
            value = asLowercase ? local[base + "da"].toLowerCase() : local[base + "da"];
            break;
        }
    }
    return (pluralityAmount == 1 && value.indexOf('|') > 0) ? value.split('|')[1] : value.split('|')[0];
}

function urlParam(name) {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results === null) {
        return null;
    }
    else {
        return decodeURIComponent(results[1]) || 0;
    }
}

function cleanEncodeURIComponent(s) {
    if (!!!s) return s;
    s = s.replace(/<br.*>/gmi, "").replace(/(\r\n|\n|\r)/gm, "");
    s = encodeURIComponent(s);
    return s;
}

async function loadInto(el, url, callback, mime) {
    console.log(url, mime);
    if (window.fetch) {
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': mime ? mime : 'text/html'
            }
        }).then(response => {
            if (response.ok) {
                return response.text();
            } else {
                throw new Error('Network response was not ok');
            }
        }).then(text => {
            el.innerHTML = text;
            if (callback) callback();
        }).catch(error => {
            customLog(2, 'Fetch Error: ', error);
        });
    } else {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                el.innerHTML = xhr.responseText;
                if (callback) callback();
            }
        };

        xhr.open("GET", url, true);
        xhr.setRequestHeader('Content-type', mime ? mime : 'text/html');
        xhr.send();
    }
}

addDomReadyEventListener(() => {
    document.body.addEventListener('keyup', function (e) {
        if (e.key === 'Tab') {
            let el = document.documentElement;
            el.classList.remove('nfo');
            el.classList.add('tab');
        }
    });

    addEvents(".jslink", "click", function (e) {
        let a = e.target.closest(".jslink");
        let href = a ? a.getAttribute("href") : undefined;
        if (href) {
            stopAll(e);
            document.location = href;
        }
    });

    forEach("form.cf.toggle", function (el) {
        forEach(el.payment, function (iel) {
            iel.addEventListener('change', function (e) {
                let form = iel.closest("form");
                let target = form.getAttribute("data-toggle").split(":");
                let toggle = form.querySelector(".toggle");
                let element = form.querySelector("input[name=" + target[0] + "]:checked");
                if (element && element.value === target[1]) {
                    removeClass(toggle, "hidden");
                    forEach(toggle.querySelectorAll("input"), function (inp) {
                        if (inp.getAttribute("data-toggle") === "required") inp.required = true;
                    });
                }
                else {
                    addClass(toggle, "hidden");
                    forEach(toggle.querySelectorAll("input"), function (inp) {
                        if (inp.getAttribute("data-toggle") === "required") inp.required = false;
                    });
                }
            });
        });
    });
});

function clone(o) {
    return o ? JSON.parse(JSON.stringify(o)) : o;
}

function selfHost() {
    return window.location.protocol + "//" + window.location.host;
}

let briefTimer;

function addBrief(msg, data, large, confetti) {
    if (!msg) return;
    if (data && data.messages && data.messages.length > 0) return;
    clearTimeout(briefTimer);
    briefTimer = setTimeout(function () {
        let brief = document.querySelector("body > .brief");
        brief.parentNode.removeChild(brief);
    }, 4500);
    let body = document.querySelector("body");
    let brief = document.querySelector("body > .brief");

    if (confetti) throwConfetti();
    if (!brief) {
        body.insertAdjacentHTML("beforeend", '<div class="brief"><div class="content"></div></div>');
        brief = document.querySelector("body > .brief");

        brief.addEventListener("click", function (e) {
            stopAll(e);
        });
    }
    large ? addClass(brief, "large") : removeClass(brief, "large");
    let content = brief.querySelector(".content");
    let text = brief.textContent;
    if (msg && text.indexOf(msg) < 0) {
        if (msg.indexOf("<") >= 0 && msg.indexOf(">") >= 0) {
            content.insertAdjacentHTML("afterbegin", msg);
        }
        else {
            content.insertAdjacentHTML("afterbegin", '<p>' + msg + '</p>');
        }
    }
}

function injectScript(url) {
    const script = document.createElement("script");
    script.src = url;
    document.head.appendChild(script);
}

function addOverlayMessage(msg, extra, confetti) {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    if (confetti) throwConfetti();
    if (!overlay) {
        addClass(body, "noscroll");
        body.insertAdjacentHTML("beforeend", '<div class="overlay"><div><div class="content"></div><a class="button close">OK</a></div></div>');
        overlay = document.querySelector("body > .overlay");

        overlay.addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.querySelector(".close").addEventListener("click", function (e) {
            hideMessageOverlay();
            stopAll(e);
        });

        overlay.firstChild.addEventListener("click", function (e) {
            stopAll(e);
        });
    }
    let content = overlay.querySelector(".content");
    let text = content.textContent;
    if (text.indexOf(msg) < 0) {
        if (msg.indexOf("<") >= 0 && msg.indexOf(">") >= 0) {
            content.insertAdjacentHTML("afterbegin", msg + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
        else {
            content.insertAdjacentHTML("afterbegin", '<p>' + msg + '</p>' + (extra ? '<span class="extra">' + extra + "<br>" + new Error().stack.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</span>' : ""));
        }
    }
}

function hideMessageOverlay() {
    let body = document.querySelector("body");
    let overlay = document.querySelector("body > .overlay");
    body.removeChild(overlay);
    removeClass("body", "noscroll");
}

function afToken() {
    return document.querySelector('input[name=__RequestVerificationToken');
}

function maxFromProperties(o, a) {
    let max = 0;
    if (!a || a.length === 0) return max;
    for (let i = 0; i < a.length; i++) {
        let k = a[i];
        if (o[k] && o[k] > max) max = o[k];
    }
    return max;
}

function scrollToElement(el) {
    let p = el.getBoundingClientRect().top + window.scrollY - 100;
    if (window.navigator.userAgent.indexOf("Edge") > 0) {
        document.body.scrollTop = p;
    }
    else {
        window.scrollTo({
            top: p,
            behavior: "smooth"
        });
    }
}

function isInt(value) {
    return !isNaN(value) &&
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10));
}

function isFloat(value) {
    return !isNaN(value) && Number(value) == value;
}

function isNullOrWhiteSpace(value) {
    return typeof value !== "string" || !value || !value.trim();
}

function getDomPath(el) {
    let nodeName = el.nodeName.toLowerCase();
    if (el === document.body) return 'body';
    if (el.id) nodeName += '#' + el.id;
    else if (el.classList.length)
        nodeName += '.' + [...el.classList].join('.');

    let i = 0;
    let elem = el;
    while (elem = elem.previousSibling) {
        if (elem.nodeType === 1) {
            i++;
        }
    }
    return getDomPath(el.parentNode) + ' ' + i + '-' + nodeName;
}

function singularE(s, v, format, pretty, em) {
    let n = (format ? toComma(v, pretty == true) : v);
    return (em ? `<em>${n}</em>` : n) + s + (v != 1 ? 'e' : '');
}

function hasClass(el, className) { if (el) return el.classList.contains(className); };
function addClass(el, className) {
    if (typeof el === "string") {
        forEach(document.querySelectorAll(el), function (iel) { addClass(iel, className); });
    }
    else {
        if (el) el.classList.add(className);
    }
}
function removeClass (el, className) {
    if (typeof el === "string") {
        forEach(document.querySelectorAll(el), function (iel) { removeClass(iel, className); });
    }
    else {
        if (el) el.classList.remove(className);
    }
}

function addEvent(path, event, func) {
    let el = typeof path === "string" ? document.querySelector(path) : path;
    if (el) {
        el.addEventListener(event, func);
    }
}

function addEvents(path, event, func, addClassName) {
    const withAddClass = addClassName !== undefined && addClassName != "";
    if (typeof path === "string") {
        forEach(path, function (el) {
            if (!withAddClass || !el.classList.contains(addClassName)) {
                el.addEventListener(event, func);
                if (withAddClass) addClass(el, addClassName);
            }
        });
    }
    else {
        path.forEach((el) => {
            if (!withAddClass || !el.classList.contains(addClassName)) {
                el.addEventListener(event, func);
                if (withAddClass) addClass(el, addClassName);
            }
        });
    }
}

function toggleClass(el, className) {
    if (typeof el === "string") el = document.querySelector(el);
    if (!el) return;

    if (hasClass(el, className)) {
        removeClass(el, className);
    }
    else {
        addClass(el, className);
    }
}

function addClasses(els, className) {
    if (!els || els.length === 0) return;
    forEach(els, function (el) {
        addClass(el, className);
    });
}

function removeClasses(els, className) {
    if (!els || els.length === 0) return;
    els.forEach(function (el) {
        removeClass(el, className);
    });
}

function translate(key) {
    const v = Local[key];
    if (v !== undefined) return v;
    return key;
}

function stopAll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}

function hasAny(arr, value, key) {
    return first(arr, value, key) !== null;
}

function isVisible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}

function isValidEmail(email) {
    if (email && email.length === 41 && email.substr(-5) === '.GUID') return true;
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
}

function unique(a) {
    return a.sort().filter(function (value, index, array) {
        return (index === 0) || (value !== array[index - 1]);
    });
}

function objectLargestPropertyValue(l, prop) {
    return l.reduce((max, obj) => obj[prop] > max[prop] ? obj : max, l[0]);
}

function first(arr, value, key) {
    if (!arr || !value) return null;
    for (let i = 0; i < arr.length; i++) {
        if (key) {
            if (arr[i][key] === value) {
                return arr[i];
            }
        }
        else {
            if (arr[i] === value) {
                return arr[i];
            }
        }
    }
    return null;
}

function removeElement(el) {
    el.parentNode.removeChild(el);
}

function getWidth(el) {
    return parseFloat(getComputedStyle(el, null).width.replace("px", ""));
}
function getHeight(el) {
    return parseFloat(getComputedStyle(el, null).height.replace("px", ""));
}
function getOffset(el) {
    let rect = el.getBoundingClientRect();
    return {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft
    };
}

function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

function prettyDate(d) {
    return new Date(Date.parse(d)).toLocaleString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' });
}

function throwConfetti() {
    for (let i = 0; i < 14; i++) {
        setTimeout(function () {
            confetti({
                spread: getRndInteger(30, 150),
                startVelocity: getRndInteger(20, 80),
                decay: getRndInteger(80, 100) / 100.0,
                origin: {
                    y: getRndInteger(5, 10) / 10.0,
                    x: getRndInteger(3, 8) / 10.0
                },
                scalar: getRndInteger(5, 15) / 10.0,
                particleCount: getRndInteger(20, 70)
            });
        }, getRndInteger(50, 500));
    }
}

function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    const d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function escapeHTML(str, wrap, urlEncode) {
    if (urlEncode) str = encodeURIComponent(str);
    if (wrap && str) {
        let output = "";
        str.split(/([ _@+-;:.])/gmi).forEach(s => {
            output += `<span>${new Option(s).innerHTML}</span>`;
        });
        str = output;
    }
    else {
        str = new Option(str).innerHTML;
    }
    return str;
}

function replaceTags(element, replacements, replaceInHTML = false) {
    if (replaceInHTML) {
        let html = element.innerHTML;
        for (let tag in replacements) {
            let regex = new RegExp('\\*' + tag + '\\*', 'gi');
            html = html.replace(regex, replacements[tag]);
        }
        element.innerHTML = html;
    } else {
        for (let child of element.childNodes) {
            if (child.nodeType === Node.TEXT_NODE) {
                let text = child.nodeValue;
                for (let tag in replacements) {
                    let regex = new RegExp('\\*' + tag + '\\*', 'gi');
                    text = text.replace(regex, replacements[tag]);
                }
                child.nodeValue = text;
            } else if (child.nodeType === Node.ELEMENT_NODE) {
                replaceTags(child, replacements, false);
            }
        }
    }
}

function parseTimeStampCookie(u) {
    let timeStamps = useTimestamps ? getCookie("TimeStamps") : undefined;
    if (timeStamps && timeStamps.startsWith("[")) {
        try {
            let parsed = JSON.parse(timeStamps);
            let lc = [];
            forEach(parsed, function (ts) {
                lc.push({ "note": ts.Note, "milliseconds": ts.Milliseconds });
            });
            try {
                showTimestamps({ "timeStamps": lc }, u);
            }
            catch (exi) {
                customLog(2, "showtimestamps failed", exi);
            }
        }
        catch (ex) {
            customLog(2, "timestamp parse failed", ex);
        }
    }
}

function showTimestamps(data, heading) {
    if (isDebug && data.timeStamps) {
        let pre = document.getElementById("debugpre");
        if (!pre) {
            pre = document.createElement('pre');
            pre.id = "debugpre"
            pre.classList.add("debugpre");
            if (!isLocal) pre.classList.add("compact");
            document.body.appendChild(pre);
        }
        if (!pre.classList.contains("hasevent")) {
            pre.addEventListener("contextmenu", (e) => {
                e.target.classList.toggle("compact");
                stopAll(e);
            });
            pre.classList.add("hasevent");
        }

        document.querySelectorAll(".debugpre:not(.active)")?.forEach(el => {
            el.addEventListener("contextmenu", e => {
                e.target.classList.toggle("compact");
                stopAll(e);
                return false;
            });
            el.classList.add("active");
        });

        let s = "";
        if (jsTodayIsoDateString != new Date().isoDate()) s += `\n"TODAY" is ${jsTodayIsoDateString}\n\n`;
        if (heading) s += ('\n' + heading).split(".dk").slice(-1) + "\n";
        s += `Memberid ${document.querySelector("body").dataset.memberid}\n\n`;

        forEach(data.timeStamps, function (t) {
            s += ("000000" + t.milliseconds).slice(-6) + " " + t.note + "\n";
        });
        pre.insertAdjacentHTML("beforeend", s);
    }
}

function refreshParticipantBaseData() {
    setCookie("refreshParticipantBaseData", "1");
}

function sendQuantity(quantity) {
    let ev = {
        'event': 'checkout',
        'ecommerce': {
            'currencyCode': 'DKK',
            'checkout': {
                'actionField': {
                    'step': 1
                },
                'products': [{
                    'name': 'Team seats',
                    'id': 1,
                    'price': '89',
                    'quantity': parseInt(quantity.value)
                }]
            }
        }
    };
    plausible("purchase", { revenue: { currency: "DKK", amount: parseInt(quantity.value) * 89 } });
    // dataLayer.push(ev);
}

function handleResponse(url, result, callback, postdata, source, eventExtra, isFetch) {
    let u = url.split('?');
    if (u.length > 1) u = u[1];

    let goal = url.split('/').pop().split('?').pop();

    let postdataLength = 0;
    if (typeof postdata === "string") {
        postdataLength = postdata.length;
    }

    if (goal && goal.length > 0 && (goal.indexOf('=') > 0 || url.indexOf("umbraco") > 0) && (postdata instanceof FormData || postdataLength > 3)) {
        goal = goal.split('=').pop();
        goal += source && source.getAttribute("eventextra") ? source.getAttribute("eventextra") : "";
        if (eventExtra) goal += eventExtra;
        plausible(goal);
    }

    parseTimeStampCookie(u);

    let data = result;
    if (result && result.length > 5 && result.substring(0, 5) === "error") {
        if (result.length > 14 && result.substring(0, 14) === "error.internal") {
            showApiError(result, true, url);
        }
        else {
            showApiError(result, false);
        }
        return true;
    }
    if (result && result.length > 5 && result.indexOf("<form") >= 0) {
        if (result.substring(0, 5) !== "<form") result = result.substring(result.indexOf("<form"), result.indexOf("</form>") + 7);
        let body = document.querySelector("body");
        let div = document.createElement("div");
        addClass(div, "hidden");
        div.innerHTML = result;
        body.appendChild(div);
        body.lastChild.firstChild.submit();
        return true;
    }
    if (result && result.length > 1 && result.substring(0, 1) !== "<") {
        try {
            data = JSON.parse(result);
            if (data.messages && data.messages.length) {
                showApiMessages(data.messages);
            }
        }
        catch (ex) {
            data = result;
        }
    }
    if (result && result.length > 4 && (result.substr(0, 4) === "url:" || result.indexOf("url:") > 0)) {
        if (navigator.userAgent.indexOf("Firefox") != -1) {
            setTimeout(function () { document.location.href = result.substr(result.indexOf("url:") + 4); }, 100);
        }
        else {
            document.location.href = result.substr(result.indexOf("url:") + 4);
        }
        return true;
    }
    if (callback) {
        callback(data, source);
    }
    else if (source) {
        let result = source.querySelector(".result[data-status='" + data + "']");
        if (result) {
            let url = result.getAttribute("data-url");
            if (url) {
                if (navigator.userAgent.indexOf("Firefox") != -1) {
                    setTimeout(function () { document.location = url; }, 100);
                }
                else {
                    document.location = url;
                }
            }
            else {
                forEach(source.querySelectorAll(".result"), function (el) {
                    removeClass(el, "active");
                });
                addClass(result, "active");
                scrollToElement(result);
            }
        }
    }

    if (source) {
        let submit = source.querySelector("input[type=submit]");
        if (submit) submit.removeAttribute("disabled");
    }
}

function handleError(msg, url, data, error, callback = undefined) {
    customLog(2, msg, url, data, error);
    showApiError(genericError, false);
    if (callback) callback(-1);
}

async function httpr(url, callback, postdata, source, eventExtra) {
    if (isDebug) {
        let u = url.split('?');
        if (u.length > 1) u = u[1];
        savedTimes[u] = new Date().getTime();
    }

    if (url === "/umbraco/surface/vctasurface/buy" && postdata && source) {
        sendQuantity(source.querySelector("input.product"));
    }

    let fetchAvailable = (typeof fetch !== 'undefined');

    if (source) {
        let submit = source.querySelector("input[type=submit]");
        if (submit) submit.setAttribute("disabled", "disabled");
    }

    let aft = afToken()?.value;
    if (document.location.href.endsWith("/admin")) {
        const afResponse = await fetch("/umbraco/surface/vctasurface/aftoken");
        const data = await afResponse.json();
        aft = data.token ? data.token : aft;
    }
    if (postdata && typeof postdata !== "string") {
        postdata.append("__RequestVerificationToken", aft);

        if (campaignConfigId) postdata.append("campaignConfigId", campaignConfigId);
    }

    let method = postdata !== undefined ? 'POST' : 'GET';
    if (fetchAvailable) {
        let responseUrl = url;
        let headers = {};
        if (method == "POST") headers["X-CSRF-TOKEN"] = aft;
        fetch(url, {
            method: method,
            headers: headers,
            body: postdata ? postdata : null
        }).then(response => {
            if (!response.ok) {
                handleError("Network response was not ok", response.url, undefined, undefined, callback)
            }
            responseUrl = response.url;
            return response.text();
        }).then(data => {
            handleResponse(responseUrl, data, callback, postdata, source, eventExtra, true);
        }).catch(error => {
            handleError("apierror", url, undefined, error, callback)
        });
    } else {
        let request = new XMLHttpRequest();
        request.open(method, url, true);
        if (method == 'POST') request.setRequestHeader('X-CSRF-TOKEN', aft);
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                handleResponse(request.responseURL, request.responseText, callback, postdata, source, eventExtra, false);
            } else {
                handleError("apierror", url, undefined, error, callback)
            }
        };

        request.onerror = function (data) {
            handleError("onerror", url, data, undefined, callback)
        };

        if (postdata !== undefined) {
            try {
                request.send(postdata);
            }
            catch (ex) {
                handleError("onerror", url, undefined, ex, callback)
            }
        }
        else {
            request.send();
        }
    }
}

function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}

String.prototype.daysInMonth = function () {
    return daysInMonth(this.substring(5, 7), this.substring(0, 4));
};

function isoDate(d) {
    return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
}

Date.prototype.isoDate = function () {
    return isoDate(this);
}

String.prototype.toDate = function () {
    return new Date(Date.UTC(this.substring(0, 4), this.substring(5, 7) - 1, this.substring(8)));
};

String.prototype.isoDate = function () {
    return this.substring(0, 10);
}

String.prototype.isoDatePart = function (p) {
    if (p == "ymd") return this;
    if (p == "ym") return this.substring(0, 7);
    if (p == "md") return this.substring(5);
    if (p == "y") return this.substring(0, 4);
    if (p == "m") return this.substring(5, 7);
    if (p == "d") return this.substring(8);
    customLog(2, `No logical date part for ${p}`);
    return this;
};

String.prototype.isoPadDateParts = function () {
    let t = this.split("-");
    return $`${t[0]}-${t[1].padStart(2, "0")}-${t[2].padStart(2, "0")}`
}

function parsedDate(s) {
    let d = s.split("T")[0].split("-");
    return new Date(d[0], d[1] - 1, d[2]);
}
function toComma(n, pretty) {
    if (pretty) {
        return n.toLocaleString('da-DK', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }
    else {
        return n.toString().replace('.', ',');
    }
}

function toPoint(n) {
    if (n == '') return 0;
    if (!validNumber.test(n)) return n;
    if (n == 0) return 0;
    n = n.toString();
    if (n.endsWith(".") || n.endsWith(",")) n = n.substr(0, n.length - 1);
    return Math.round((parseFloat(n.replace(',', '.')) + 0.00001) * 100) / 100;
}

function monthsTotal(a, b) {
    let as = a.split('-');
    let bs = b.split('-');
    let x = as[0] * 12 + as[1];
    let y = bs[0] * 12 + bs[1];
    return y - x + 1;
}

function daysBetween(a, b) {
    let d1 = a.toDate();
    let d2 = b.toDate();
    return Math.ceil((d1.getTime() - d2.getTime()) / (1000 * 3600 * 24));
}

String.prototype.isoAddDatePart = function (t, v) {
    return adjustDate(this, t, v);
    //    let y = this.substring(0, 4);
    //    let m = this.substring(5, 7);
    //    let d = this.substring(8, 10);
    //    console.log(this, y, m, d);
    //    if (p == "y") sub ? y-- : y++;
    //    if (p == "m") sub ? m-- : m++;
    //    if (p == "d") sub ? d-- : d++;
    //    console.log("after", this, y, m, d, p, sub);
    //    if (m < 1) {
    //        y--;
    //        m = 12;
    //    }
    //    if (m > 12) {
    //        y++;
    //        m = m - 12;
    //    }
    //    if (d < 1) {
    //        m--;
    //        if (m < 1) {
    //            y--;
    //            m = 12;
    //        }
    //        d = daysInMonth(m, y);
    //    }
    //    let dim = daysInMonth(m, y);
    //    if (d > dim) {
    //        m++;
    //        if (m > 12) {
    //            y++;
    //            m = m - 12;
    //        }
    //        d = d - dim;
    //    }
    //    let result = `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    //    return result;
};



function adjustDate(dateStr, type, value) {
    if (value == undefined || value == "") value = 1;
    let [year, month, day] = dateStr.split('-').map(Number);

    let date = new Date(year, month - 1, day);

    switch (type) {
        case 'd':
            date.setDate(date.getDate() + value);
            break;
        case 'm':
            date.setMonth(date.getMonth() + value);
            break;
        case 'y':
            date.setFullYear(date.getFullYear() + value);
            break;
        default:
            cumstomLog(2, `Invalid type ${type}. Type must be "d", "m", or "y". Value: ${value} Date: ${dateStr}`);
    }

    year = date.getFullYear();
    month = (date.getMonth() + 1).toString().padStart(2, '0');
    day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

function highlightElement(el) {
    if (!el) return;

    el.scrollIntoView({
        behavior: 'instant',
        block: 'center'
    });
    el.addEventListener('animationend', () => {
        el.classList.remove('highlight-element');
    });

    el.classList.add("highlight-element");
}
﻿(function () {
    const location = window.location;
    const document = window.document;

    const scriptEl = document.querySelector('script[data-api]');
    const endpoint = scriptEl.getAttribute("data-api") || defaultEndpoint(scriptEl);
    const hasDomainLanguage = scriptEl.getAttribute("data-domainLanguage") == "1";

    function onIgnoredEvent(reason, options) {
        if (reason) console.warn("Ignoring Event: " + reason);
        options && options.callback && options.callback();
    }

    function defaultEndpoint(el) {
        return new URL(el.src).origin + "/api/event";
    }

    function trigger(eventName, options) {
        const deferredEvents = ["buy", "signup", "login"];
        if (window.dataLayer) {
            let dlEvent = {
                event: eventName,
                ...options
            };

            if (window.datalayerPersistence && deferredEvents.indexOf(eventName) > -1)
                window.datalayerPersistence.storeEvent(dlEvent);
            else
                window.dataLayer.push(dlEvent);
        }

        if (
            location.protocol === "file:"
        ) {
            return onIgnoredEvent("localhost", options);
        }
        if (
            window._phantom ||
            window.__nightmare ||
            window.navigator.webdriver ||
            window.Cypress
        ) {
            return onIgnoredEvent(null, options);
        }
        try {
            if (window.localStorage.plausible_ignore === "true") {
                return onIgnoredEvent("localStorage flag", options);
            }
        } catch (e) { }

        const payload = {};
        let href = location.href.toLowerCase().replace("/?", "?");
        let referrer = document.referrer || null;
        if (referrer) {
            referrer = referrer.toLowerCase().replace("/?", "?");
            referrer = referrer.endsWith("/") ? referrer.substring(0, referrer.length - 1) : referrer;
        }
        payload.n = eventName;
        payload.u = href.endsWith("/") ? href.substring(0, href.length - 1) : href;
        payload.d = scriptEl.getAttribute("data-domain");
        payload.r = referrer;
        if (options && options.meta) {
            payload.m = JSON.stringify(options.meta);
        }
        if (options && options.props) {
            payload.p = options.props;
        }
        if (hasDomainLanguage) {
            let language = location.host.split('.')[0].split('-')[0];
            if (language && language.length == 2) {
                if (!payload.p) payload.p = {};
                payload.p.browserLanguage = navigator.language || navigator.userLanguage;
                payload.p.language = language;
            }
        }

        const propAttributes = scriptEl.getAttributeNames().filter(function (name) {
            return name.substring(0, 6) === "event-";
        });

        const props = payload.p || {};

        propAttributes.forEach(function (attribute) {
            const propKey = attribute.replace("event-", "");
            const propValue = scriptEl.getAttribute(attribute);
            props[propKey] = props[propKey] || propValue;
        });

        payload.p = props;

        // TODO: better send

        const url = endpoint;
        const data = JSON.stringify(payload);
        const callback = function () {
            options && options.callback && options.callback();
        }; // Replace with your actual callback function

        try {
            // Use Fetch API with keepalive
            fetch(url, {
                method: 'POST',
                keepalive: true,
                headers: {
                    'Content-Type': 'text/plain'
                },
                body: data
            }).then(() => {
                // Ignore the response
                if (typeof callback === 'function') {
                    callback();
                }
            }).catch((error) => {
                console.error('Error:', error);
                // Use XMLHttpRequest as a fallback
                const xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.setRequestHeader('Content-Type', 'text/plain');
                xhr.send(data);
                xhr.onload = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                };
            });
        } catch (error) {
            console.error('Error:', error);
        }

        //    var request = new XMLHttpRequest();
        //    request.open("POST", endpoint, true);
        //    request.setRequestHeader("Content-Type", "text/plain");

        //    request.send(JSON.stringify(payload));

        //    request.onreadystatechange = function () {
        //        if (request.readyState === 4) {
        //            options && options.callback && options.callback();
        //        }
        //    };
    }

    const queue = (window.plausible && window.plausible.q) || [];
    window.plausible = trigger;
    for (var i = 0; i < queue.length; i++) {
        trigger.apply(this, queue[i]);
    }

    let lastPage;

    function page() {
        if (lastPage === location.pathname) return;
        lastPage = location.pathname;
        trigger("pageview");
    }

    const his = window.history;
    if (his.pushState) {
        const originalPushState = his["pushState"];
        his.pushState = function () {
            originalPushState.apply(this, arguments);
            page();
        };
        window.addEventListener("popstate", page);
    }

    function handleVisibilityChange() {
        if (!lastPage && document.visibilityState === "visible") {
            page();
        }
    }

    if (document.visibilityState === "prerender") {
        document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
        page();
    }
    function getLinkEl(link) {
        while (link && (typeof link.tagName === 'undefined' || !isLink(link) || !link.href)) {
            link = link.parentNode
        }
        return link
    }

    function isLink(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'a'
    }

    function shouldFollowLink(event, link) {
        // If default has been prevented by an external script, Plausible should not intercept navigation.
        if (event.defaultPrevented) { return false }

        const targetsCurrentWindow = !link.target || link.target.match(/^_(self|parent|top)$/i);
        const isRegularClick = !(event.ctrlKey || event.metaKey || event.shiftKey) && event.type === 'click';
        return targetsCurrentWindow && isRegularClick
    }

    const MIDDLE_MOUSE_BUTTON = 1;

    function handleLinkClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        const link = getLinkEl(event.target);
        const hrefWithoutQuery = link && link.href && link.href.split('?')[0];

        if (isElementOrParentTagged(link, 0)) {
            // Return to prevent sending multiple events with the same action.
            // Clicks on tagged links are handled by another function.
            return
        }
        if (isOutboundLink(link)) {
            return sendLinkClickEvent(event, link, { name: 'Outbound Link: Click', props: { url: link.href } })
        }
        if (isDownloadToTrack(hrefWithoutQuery)) {
            return sendLinkClickEvent(event, link, { name: 'File Download', props: { url: hrefWithoutQuery } })
        }
    }

    function sendLinkClickEvent(event, link, eventAttrs) {
        let followedLink = false;

        function followLink() {
            if (!followedLink) {
                followedLink = true
                window.location = link.href
            }
        }

        if (shouldFollowLink(event, link)) {
            plausible(eventAttrs.name, { props: eventAttrs.props, callback: followLink })
            setTimeout(followLink, 5000)
            event.preventDefault()
        } else {
            plausible(eventAttrs.name, { props: eventAttrs.props })
        }
    }

    document.addEventListener('click', handleLinkClickEvent)
    document.addEventListener('auxclick', handleLinkClickEvent)

    function isOutboundLink(link) {
        return link && link.href && link.host && link.host !== location.host
    }

    const defaultFileTypes = ['pdf', 'xlsx', 'docx', 'txt', 'rtf', 'csv', 'exe', 'key', 'pps', 'ppt', 'pptx', '7z', 'pkg', 'rar', 'gz', 'zip', 'avi', 'mov', 'mp4', 'mpeg', 'wmv', 'midi', 'mp3', 'wav', 'wma'];
    const fileTypesAttr = scriptEl.getAttribute('file-types');
    const addFileTypesAttr = scriptEl.getAttribute('add-file-types');
    const fileTypesToTrack = (fileTypesAttr && fileTypesAttr.split(",")) || (addFileTypesAttr && addFileTypesAttr.split(",").concat(defaultFileTypes)) || defaultFileTypes;

    function isDownloadToTrack(url) {
        if (!url) { return false }

        const fileType = url.split('.').pop();
        return fileTypesToTrack.some(function (fileTypeToTrack) {
            return fileTypeToTrack === fileType
        })
    }
    // Finds event attributes by iterating over the given element's (or its
    // parent's) classList. Returns an object with `name` and `props` keys.
    function getTaggedEventAttributes(htmlElement) {
        const taggedElement = isTagged(htmlElement) ? htmlElement : htmlElement && htmlElement.parentNode;
        const eventAttrs = {name: null, props: {}};

        const classList = taggedElement && taggedElement.classList;
        if (!classList) { return eventAttrs }

        for (let i = 0; i < classList.length; i++) {
            const className = classList.item(i);

            const matchList = className.match(/plausible-event-(.+)(=|--)(.+)/);
            if (!matchList) { continue }

            const key = matchList[1];
            const value = matchList[3].replace(/\+/g, ' ');

            if (key.toLowerCase() === 'name') {
                eventAttrs.name = value
            } else {
                eventAttrs.props[key] = value
            }
        }

        return eventAttrs
    }

    function handleTaggedFormSubmitEvent(event) {
        const form = event.target;
        const eventAttrs = getTaggedEventAttributes(form);
        if (!eventAttrs.name) { return }

        event.preventDefault()
        let formSubmitted = false;

        function submitForm() {
            if (!formSubmitted) {
                formSubmitted = true
                form.submit()
            }
        }

        setTimeout(submitForm, 5000)
        plausible(eventAttrs.name, { props: eventAttrs.props, callback: submitForm })
    }

    function isForm(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'form'
    }

    const PARENTS_TO_SEARCH_LIMIT = 3;

    function handleTaggedElementClickEvent(event) {
        if (event.type === 'auxclick' && event.button !== MIDDLE_MOUSE_BUTTON) { return }

        let clicked = event.target;

        let clickedLink;
        let taggedElement;
        // Iterate over parents to find the tagged element. Also search for
        // a link element to call for different tracking behavior if found.
        for (let i = 0; i <= PARENTS_TO_SEARCH_LIMIT; i++) {
            if (!clicked) { break }

            // Clicks inside forms are not tracked. Only form submits are.
            if (isForm(clicked)) { return }
            if (isLink(clicked)) { clickedLink = clicked }
            if (isTagged(clicked)) { taggedElement = clicked }
            clicked = clicked.parentNode
        }

        if (taggedElement) {
            const eventAttrs = getTaggedEventAttributes(taggedElement);

            if (clickedLink) {
                eventAttrs.props.url = clickedLink.href
                sendLinkClickEvent(event, clickedLink, eventAttrs)
            } else {
                plausible(eventAttrs.name, { props: eventAttrs.props })
            }
        }
    }

    function isTagged(element) {
        const classList = element && element.classList;
        if (classList) {
            for (let i = 0; i < classList.length; i++) {
                if (classList.item(i).match(/plausible-event-name(=|--)(.+)/)) { return true }
            }
        }
        return false
    }

    function isElementOrParentTagged(element, parentsChecked) {
        if (!element || parentsChecked > PARENTS_TO_SEARCH_LIMIT) { return false }
        if (isTagged(element)) { return true }
        return isElementOrParentTagged(element.parentNode, parentsChecked + 1)
    }

    document.addEventListener('submit', handleTaggedFormSubmitEvent)
    document.addEventListener('click', handleTaggedElementClickEvent)
    document.addEventListener('auxclick', handleTaggedElementClickEvent)
})();
﻿var allSVGs = {};
// vs
allSVGs["tree"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.14 123.58"><path class="s-tree-a" d="M30.88,76.18c1.82,3.39,5.43,5.09,8.48,7.16a25.26,25.26,0,0,1,7.89,9.38c5.21,9.88-2.06,20.3-1.7,30.56a.31.31,0,0,0,.31.3H64.54a.5.5,0,0,0,.42-.78c-2.81-3.93-3.57-8.89-3.37-13.66a53.43,53.43,0,0,1,1-7.76c.52-2.74.72-5.66,1.75-8.27.49-1.25,1.63-1.74,2.66-2.44,4.72-3.07,7.27-8.64,8.61-13.93.16-.64.35-3.32-1.06-2.79a1.48,1.48,0,0,0-.63.56c-2.61,3.9-4.1,9.1-8.73,11.2a2,2,0,0,1-2-.06c-2.31-2.18.3-9.31,1.84-11.6.81-1.3,2.61-2.66,2.44-4.34a4.67,4.67,0,0,0-2.64-3.3c-1.85-.86-3.42.74-4.27,2.26-2.07,3.69-1.17,8.07-2.86,11.83-2.89,5.85-5.38-4.18-5.35-6.61-.12-2.64,0-5.24-.64-7.82-.75-3-4.32-.42-5.41,1-1.29,1.88.25,4,1.15,5.71,1.06,2,2.54,7.36-1.1,8a4.12,4.12,0,0,1-2.92-1c-4-2.8-6.56-7-10.21-10.2a2.32,2.32,0,0,0-1.7-.77C28.87,69.78,29.79,74.34,30.88,76.18Z" /><path class="s-tree-b" d="M101,40.82a7.69,7.69,0,0,1,.28-3.19c1.21-5,1.36-10-1.6-14.4A13.63,13.63,0,0,0,89,17.09c-2.28.11-2.6-.92-3.09-2.83A16.84,16.84,0,0,0,62.1,4.83a5.39,5.39,0,0,1-3.3,1C57.31,5.5,56.43,4,55.36,3.07c-3.2-3-8-3.69-12.13-2.54C37.34,2,33.21,7.66,32.89,13.64a2.75,2.75,0,0,1-.35,1.42,1.9,1.9,0,0,1-1.51.62c-2.79,0-5.54-.63-8.33-.23A15.45,15.45,0,0,0,9.94,26.89c-.46,1.75-.32,3.58-.66,5.34a4.22,4.22,0,0,1-3.11,3.48,9,9,0,0,0-4.34,3.13C-1,42.6-.39,48.4,2.47,52c.93,1.15,2.3,1.79,3.34,2.81,2.2,2.15.28,5.45.46,8.11,1.09,14,20.65,18.95,29.47,8.72a3.89,3.89,0,0,1,4.87-.73,53.53,53.53,0,0,0,7.44,3.28c3.86,1.23,8,0,11.9.93,1.51.45,2.19,1.51,3.35,2.38,4.26,2.84,9.81,3.29,14.76,2.45,4.65-.85,9.66-2.78,12.28-6.94,1-1.61,1-3.49,1.49-5.28.48-2.76,2.94-2.57,5.06-3.24,6.85-2.6,10-11.3,7.23-17.91C103.34,44.52,101.43,43,101,40.82Z" /></svg>';
allSVGs["heart"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232.89 200.6"><path class="s-hea-a" d="M232.89,61A60.93,60.93,0,0,0,116.44,35.83,60.92,60.92,0,1,0,14.77,100.65a60.38,60.38,0,0,0,6.8,6.77l92.95,92.33a2.91,2.91,0,0,0,2.07.85,3,3,0,0,0,2.09-.85L215.08,104v0a60.58,60.58,0,0,0,17.82-43Z"/><path class="s-hea-b" d="M147.72,106.44l-8.56-22.59-14.82,54.24a4.83,4.83,0,0,1-9.38-.19L99.64,71.07l-10.47,35a4.85,4.85,0,0,1-4.64,3.46H46a4.84,4.84,0,0,1,0-9.68h35L95.63,50.7A4.84,4.84,0,0,1,105,51l15.1,65.92,13.64-50a4.84,4.84,0,0,1,9.2-.45l12.66,33.38h63.18a60.91,60.91,0,1,0-102.33-64A60.92,60.92,0,1,0,14.77,100.65a60.38,60.38,0,0,0,6.8,6.77l92.95,92.33a2.91,2.91,0,0,0,2.07.85,3,3,0,0,0,2.09-.85l90.77-90.19H152.24A4.83,4.83,0,0,1,147.72,106.44Z"/></svg>';
allSVGs["bank"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 233.62 157"><path class="s-ban-a" d="M193.12,62a3,3,0,0,1-.92-5.86l3.19-1c3.91-1.18,7.71-2.33,10.8-4.19a23.48,23.48,0,0,1-4.85-2.65,14.09,14.09,0,0,1-6.17-10.74,11.9,11.9,0,0,1,4.46-9.78A12.43,12.43,0,0,1,209.82,25a10.7,10.7,0,0,1,7.46,5.62,19.15,19.15,0,0,1,1.12,14c2.93-1.54,6.21-4.31,9.87-8.93A3,3,0,0,1,233,39.36c-6.24,7.88-12.53,12.14-18.79,12.78-4.52,5-11.12,7-17.07,8.76-1,.32-2.07.63-3.08,1A3.21,3.21,0,0,1,193.12,62Zm14.56-31.21a6.63,6.63,0,0,0-4.2,1.62,5.93,5.93,0,0,0-2.31,4.92,8.07,8.07,0,0,0,3.62,6.08,13.92,13.92,0,0,0,6.46,2.67,6.44,6.44,0,0,0,.36-.63c2-3.69,2.11-8.74.37-12a4.74,4.74,0,0,0-3.31-2.55A4.62,4.62,0,0,0,207.68,30.79Z"/><path class="s-ban-a" d="M199.62,70.25C199.62,31.45,159.44,0,109.87,0c-20.29,0-39,5.28-54,14.17a3.33,3.33,0,0,1-3.72-.24A48.51,48.51,0,0,0,40.56,7.3C34.66,4.92,27.65,3.84,22,6.55A1.73,1.73,0,0,0,21.29,9c4.09,7.36,7.81,15.15,11.34,22.86A3.1,3.1,0,0,1,32.27,35,61.58,61.58,0,0,0,22,56a3.42,3.42,0,0,1-1.3,1.92,17.55,17.55,0,0,1-2.77,1.64,41.88,41.88,0,0,1-8.19,2.65A52.35,52.35,0,0,1,.8,64a.77.77,0,0,0-.72.72c-.51,8,1.59,15.88,3.7,23.51A51,51,0,0,0,6.13,95c2.4,5.46,8.88,11.67,14.57,13.45a29.44,29.44,0,0,0,12.9.87,2.73,2.73,0,0,1,2.45.93,79.72,79.72,0,0,0,14,12.41,3.23,3.23,0,0,1,1.31,2l6.35,30.51A2.45,2.45,0,0,0,60.09,157H82.48a2.24,2.24,0,0,0,2.14-1.56l4.23-15.08A2,2,0,0,1,91.07,139a113.48,113.48,0,0,0,18.8,1.55q5.82,0,11.44-.56a2.47,2.47,0,0,1,2.69,2l2.79,13.48a2,2,0,0,0,2,1.62h22.83a2.23,2.23,0,0,0,2.08-1.4l12.05-29.72a3,3,0,0,1,1.15-1.38C186.88,111.61,199.62,92.1,199.62,70.25Z"/><circle class="s-ban-b" cx="48.62" cy="58.5" r="7.5"/><path class="s-ban-b" d="M139.07,27.36a1.24,1.24,0,0,1-1.68.44c-22.53-12.74-42.93-4.92-50.69-1.95l-1,.39a1.39,1.39,0,0,1-1.79-.86l-1.38-4.15a1.25,1.25,0,0,1,.73-1.56l1-.36c8.62-3.3,31.32-12,56.74,2.46a1.23,1.23,0,0,1,.45,1.68Z"/><circle class="s-ban-c" cx="112.31" cy="72.5" r="37.5"/><circle class="s-ban-d" cx="112.31" cy="72.5" r="32.5"/><circle class="s-ban-c" cx="112.31" cy="72.5" r="28"/><path class="s-ban-b" d="M96.54,59.79h3.85V73.84l6.49-7.28h4.62l-6.07,6.77,6.16,9.88H107.1l-4.4-7.09-2.31,2.53v4.56H96.54Z"/><path class="s-ban-b" d="M113.84,66.56h3.27l.16,3a4.27,4.27,0,0,1,4.49-3.37H123V69.9h-.87c-2.57,0-3.88,1.09-4.39,3.75v9.56h-3.85Z"/><path class="s-ban-b" d="M123.91,79h4.17v4.17h-4.17Z"/></svg>';
allSVGs["mbike"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 0 322.5 188.4"><path class="s-mbike-a" d="M163.7,131.46a5.06,5.06,0,0,0,4,2h25.65c4.75,28.76,29,51.47,58.47,53.77,1.72.14,3.46.21,5.17.21h0a64.74,64.74,0,0,0,47.41-20.75,64,64,0,0,0,16.91-49,64.78,64.78,0,0,0-31.44-50.2L297,50.17a5,5,0,0,0-4.62-6.92H225.07A5,5,0,0,0,220.62,46l-4,7.86L205.7,37.13l5.9-16.44h10.89a5,5,0,0,0,0-10h-33.2a5,5,0,1,0,0,10H201l-4.29,12H108.47l4.29-11.25a5,5,0,0,0-.52-4.57L107.63,10h15.18a5,5,0,0,0,0-10H98.26a5,5,0,0,0-4.15,7.79l8.38,12.49-16,41.95a64.69,64.69,0,1,0,9.12,4.15l6-15.86Zm29.39-88.78-27,75.42L108.24,42.68ZM280.88,63a63.2,63.2,0,0,0-18.67-4.41c-1.74-.14-3.5-.21-5.24-.21A64.65,64.65,0,0,0,225,66.85l-2.18-3.36,5.26-10.24h56.8Zm-58.63,17.9,27.68,42.53H202.48A54,54,0,0,1,216.93,85.9,52.34,52.34,0,0,1,222.25,80.89Zm8.26-5.64A54.55,54.55,0,0,1,257,68.37c1.47,0,3,.06,4.45.18a53.1,53.1,0,0,1,15.63,3.67l-18.89,45.52Zm80.81,43.2A54.09,54.09,0,0,1,297,159.87,54.7,54.7,0,0,1,257,177.4h0c-1.45,0-2.93-.06-4.4-.17a54.82,54.82,0,0,1-49.07-43.81h55.65a5.1,5.1,0,0,0,4.63-3.09L286,76.79A54.67,54.67,0,0,1,311.32,118.45Zm-136.55,5L201.47,49l15.29,23.5a65.41,65.41,0,0,0-7.18,6.66,63.86,63.86,0,0,0-17.1,44.31ZM10,122.89A54.52,54.52,0,0,1,82.92,71.57L67.5,112,56.94,125.31a5,5,0,1,0,7.84,6.21l11-13.93a5.06,5.06,0,0,0,.75-1.32L92,75.83a54.51,54.51,0,1,1-82,47.06Z" /></svg>';
allSVGs["vs"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.4 97.17"><path class="s-vs-a" d="M43.2,0c8,0,13.07,11.05,19.51,14.78,6.65,3.84,18.72,2.86,22.57,9.51,3.73,6.44-3,16.31-3,24.29s6.78,17.86,3,24.3c-3.85,6.65-15.92,5.66-22.57,9.51C56.27,86.12,51.18,97.17,43.2,97.17s-13.07-11-19.51-14.78C17,78.54,5,79.53,1.12,72.88c-3.73-6.44,3.05-16.32,3.05-24.3s-6.78-17.85-3-24.29C5,17.64,17,18.62,23.69,14.78,30.13,11.05,35.22,0,43.2,0Z"/><circle class="s-vs-b" cx="43.2" cy="48.58" r="35.04"/><circle class="s-vs-c" cx="43.46" cy="7.04" r="3.19"/><circle class="s-vs-c" cx="6.83" cy="27.74" r="3.19"/><circle class="s-vs-c" cx="6.83" cy="69.96" r="3.19"/><circle class="s-vs-c" cx="43.46" cy="90.66" r="3.19"/><circle class="s-vs-c" cx="79.3" cy="27.74" r="3.19"/><circle class="s-vs-c" cx="79.3" cy="69.96" r="3.19"/><circle class="s-vs-c" cx="43.2" cy="48.85" r="31.86"/><line class="s-vs-d" x1="52.63" y1="18.41" x2="33.34" y2="79.15"/><path class="s-vs-e" d="M26.33,30h4.21a.55.55,0,0,1,.52.39L37.18,50a.22.22,0,0,0,.43,0l6.16-19.62a.55.55,0,0,1,.52-.39h4.5l-9,27.08H35.21a.61.61,0,0,1-.58-.42L26,30.48A.37.37,0,0,1,26.33,30Z"/><path class="s-vs-e" d="M41.17,59.31H45a.53.53,0,0,1,.53.51c.2,2.56,1.95,3.79,5.2,3.79s4.9-1.2,4.9-3.59c0-2.55-1.59-3.66-6.05-4.34-6.14-.91-8.41-3.06-8.41-7.88,0-5.38,3.35-8.13,9.64-8.13,5.95,0,9,2.48,9.27,7.59a.57.57,0,0,1-.56.58H55.85a.56.56,0,0,1-.56-.51c-.18-2.36-1.69-3.52-4.6-3.52-3.07,0-4.7,1.24-4.7,3.51s1.55,3.42,5.74,4c6.41.88,8.72,3.23,8.72,8.24,0,5.46-3.23,8.17-9.8,8.17s-9.74-2.57-9.91-8A.43.43,0,0,1,41.17,59.31Z"/></svg>';
allSVGs["vsalt"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.4 97.17"><path class="s-vsa-a" d="M43.2,0c8,0,13.07,11.05,19.51,14.78,6.65,3.84,18.72,2.86,22.57,9.51,3.73,6.44-3,16.31-3,24.29s6.78,17.86,3,24.3c-3.85,6.65-15.92,5.66-22.57,9.51C56.27,86.12,51.18,97.17,43.2,97.17s-13.07-11-19.51-14.78C17,78.54,5,79.53,1.12,72.88c-3.73-6.44,3.05-16.32,3.05-24.3s-6.78-17.85-3-24.29C5,17.64,17,18.62,23.69,14.78,30.13,11.05,35.22,0,43.2,0Z"/><circle class="s-vsa-b" cx="43.2" cy="48.58" r="35.04"/><circle class="s-vsa-c" cx="43.46" cy="7.04" r="3.19"/><circle class="s-vsa-c" cx="6.83" cy="27.74" r="3.19"/><circle class="s-vsa-c" cx="6.83" cy="69.96" r="3.19"/><circle class="s-vsa-c" cx="43.46" cy="90.66" r="3.19"/><circle class="s-vsa-c" cx="79.3" cy="27.74" r="3.19"/><circle class="s-vsa-c" cx="79.3" cy="69.96" r="3.19"/><circle class="s-vsa-c" cx="43.2" cy="48.85" r="31.86"/><path class="s-vsa-d" d="M35.71,48.18,21.62,40a.78.78,0,0,0-1.17.68V57a.78.78,0,0,0,1.17.68l14.09-8.14A.77.77,0,0,0,35.71,48.18Z"/><path class="s-vsa-d" d="M50.82,49.55l13.83,8a.87.87,0,0,0,1.3-.75v-16a.86.86,0,0,0-1.3-.74l-13.83,8A.86.86,0,0,0,50.82,49.55Z"/><line class="s-vsa-e" x1="43.2" y1="21.77" x2="43.2" y2="23.36"/><line class="s-vsa-f" x1="43.2" y1="31.09" x2="43.2" y2="70.47"/><line class="s-vsa-e" x1="43.2" y1="74.34" x2="43.2" y2="75.93"/></svg>';

// andet
allSVGs["label"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 24"><path class="s-label-a" d="M0,0,4.41,12,0,24H120l-4.41-12L120,0Z" /><text x="50%" style="text-anchor: middle;" y="16">{{text}}</text></svg>';
allSVGs["star"] = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.98 75.33"><path class="s-star-a" d="M37.85,64.37,17.48,75.07a2.21,2.21,0,0,1-3.21-2.33l3.89-22.67a3.53,3.53,0,0,0-1-3.13L.67,30.88a2.21,2.21,0,0,1,1.22-3.77L24.66,23.8a3.54,3.54,0,0,0,2.67-1.94L37.51,1.23a2.21,2.21,0,0,1,4,0L51.66,21.86a3.52,3.52,0,0,0,2.66,1.94l22.77,3.31a2.21,2.21,0,0,1,1.22,3.77L61.83,46.94a3.53,3.53,0,0,0-1,3.13l3.89,22.67a2.21,2.21,0,0,1-3.21,2.33L41.14,64.37A3.49,3.49,0,0,0,37.85,64.37Z" /></svg>';
allSVGs["sparkle"] = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 196.98 304"><path d="M114.65,18.22c.63-6.24,1.87-14.07,6.67-17.01,6.36-3.89,13.7,2.34,16.05,7.91,1.9,4.5,2.4,9.44,2.93,14.29,2.69,24.57,5.72,49.83,12.77,73.57,4.38,14.82,11.47,30.15,25.04,37.55,5.25,2.87,11.78,4.63,15.86,9.25,4.62,5.22,3.54,12.73-.7,17.85-3.43,4.14-8.21,6.85-12.56,10.01-23.47,17.07-30.92,45.63-34.07,73.07-1.18,10.31-2.89,23.84-13.85,28.41-1.4.58-2.94.92-4.44.68-4.75-.76-8.16-7.01-10.46-10.74-3.11-5.05-5.51-10.5-7.63-16.02-4.22-10.95-7.33-22.38-12.78-32.82-10.49-20.11-26.21-34.49-44.45-47.5-2.64-1.88-5.35-3.9-6.79-6.8-2.11-4.24.1-8.32,3.27-11.24,4.08-3.76,8.91-6.31,13.19-9.78,18.36-14.9,30.75-36.54,38.7-58.52,6.68-18.46,10.72-38.06,12.8-57.56.14-1.33.27-2.91.44-4.6Z"/><path d="M58.24,261.57c-.39-.53-.73-1.11-1.06-1.68-2.89-5.11-5.03-10.65-6.35-16.37-1.34-5.82-.81-11.9-2.64-17.58-.54-1.66-1.41-3.46-3.08-3.99-1.21-.38-2.56.04-3.57.8-3.51,2.68-5,7.2-6.46,11.17-1.61,4.38-3.68,8.46-6.37,12.29-5.44,7.77-12.62,14.17-20.17,19.83-2.85,2.14-6.44,4.79-7.98,8.11-2.41,5.18,3.3,6.99,7.63,6.74,2.72-.16,5.38-.87,8.1-1.07,10.48-.75,18.91,6.48,22.16,15.96,1.07,3.13,2.27,7.4,6.04,8.13,4.26.82,7.09-3.65,7.6-7.33.51-3.69-.24-7.53.76-11.12,1.23-4.37,4.87-7.32,9.19-8.41,2.48-.63,5.23-.79,7.21-2.41,3.16-2.6,2.65-7.8-1.01-9.57-2.83-1.37-6.17-.08-8.8-2.19-.47-.37-.86-.82-1.21-1.3Z"/></svg>`;
allSVGs["doubleSparkle"] = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294.9 304"><path d="M44.69,48.99c-.34-3.39-1.01-7.64-3.62-9.23-3.45-2.11-7.43,1.27-8.71,4.29-1.03,2.44-1.3,5.12-1.59,7.76-1.46,13.33-3.1,27.04-6.93,39.93-2.38,8.04-6.23,16.37-13.59,20.38-2.85,1.56-6.39,2.51-8.61,5.02-2.51,2.84-1.92,6.91.38,9.69,1.86,2.25,4.46,3.72,6.82,5.44,12.74,9.27,16.78,24.77,18.49,39.66.64,5.59,1.57,12.94,7.52,15.42.76.32,1.6.5,2.41.37,2.58-.41,4.43-3.8,5.68-5.83,1.69-2.74,2.99-5.7,4.14-8.7,2.29-5.94,3.98-12.14,6.94-17.81,5.69-10.92,14.23-18.72,24.13-25.78,1.43-1.02,2.9-2.12,3.69-3.69,1.15-2.3-.05-4.51-1.77-6.1-2.21-2.04-4.84-3.42-7.16-5.31-9.97-8.09-16.69-19.83-21.01-31.76-3.62-10.02-5.82-20.66-6.95-31.24-.08-.72-.15-1.58-.24-2.5Z"/><path d="M75.3,181.08c.21-.29.4-.6.57-.91,1.57-2.78,2.73-5.78,3.44-8.89s.44-6.46,1.43-9.54c.29-.9.77-1.88,1.67-2.17.66-.21,1.39.02,1.94.44,1.91,1.45,2.71,3.91,3.51,6.06.87,2.38,2,4.59,3.46,6.67,2.95,4.22,6.85,7.69,10.95,10.76,1.55,1.16,3.49,2.6,4.33,4.4,1.31,2.81-1.79,3.79-4.14,3.66-1.48-.08-2.92-.47-4.4-.58-5.69-.41-10.27,3.52-12.03,8.66-.58,1.7-1.23,4.02-3.28,4.41-2.31.45-3.85-1.98-4.12-3.98s.13-4.09-.42-6.04c-.67-2.37-2.65-3.97-4.99-4.56-1.35-.34-2.84-.43-3.91-1.31-1.71-1.41-1.44-4.23.55-5.19,1.54-.74,3.35-.04,4.78-1.19.25-.2.47-.44.66-.7Z"/><path d="M212.57,18.22c.63-6.24,1.87-14.07,6.67-17.01,6.36-3.89,13.7,2.34,16.05,7.91,1.9,4.5,2.4,9.44,2.93,14.29,2.69,24.57,5.72,49.83,12.77,73.57,4.38,14.82,11.47,30.15,25.04,37.55,5.25,2.87,11.78,4.63,15.86,9.25,4.62,5.22,3.54,12.73-.7,17.85-3.43,4.14-8.21,6.85-12.56,10.01-23.47,17.07-30.92,45.63-34.07,73.07-1.18,10.31-2.89,23.84-13.85,28.41-1.4.58-2.94.92-4.44.68-4.75-.76-8.16-7.01-10.46-10.74-3.11-5.05-5.51-10.5-7.63-16.02-4.22-10.95-7.33-22.38-12.78-32.82-10.49-20.11-26.21-34.49-44.45-47.5-2.64-1.88-5.35-3.9-6.79-6.8-2.11-4.24.1-8.32,3.27-11.24,4.08-3.76,8.91-6.31,13.19-9.78,18.36-14.9,30.75-36.54,38.7-58.52,6.68-18.46,10.72-38.06,12.8-57.56.14-1.33.27-2.91.44-4.6Z"/><path d="M156.16,261.57c-.39-.53-.73-1.11-1.06-1.68-2.89-5.11-5.03-10.65-6.35-16.37-1.34-5.82-.81-11.9-2.64-17.58-.54-1.66-1.41-3.46-3.08-3.99-1.21-.38-2.56.04-3.57.8-3.51,2.68-5,7.2-6.46,11.17-1.61,4.38-3.68,8.46-6.37,12.29-5.44,7.77-12.62,14.17-20.17,19.83-2.85,2.14-6.44,4.79-7.98,8.11-2.41,5.18,3.3,6.99,7.63,6.74,2.72-.16,5.38-.87,8.1-1.07,10.48-.75,18.91,6.48,22.16,15.96,1.07,3.13,2.27,7.4,6.04,8.13,4.26.82,7.09-3.65,7.6-7.33.51-3.69-.24-7.53.76-11.12,1.23-4.37,4.87-7.32,9.19-8.41,2.48-.63,5.23-.79,7.21-2.41,3.16-2.6,2.65-7.8-1.01-9.57-2.83-1.37-6.17-.08-8.8-2.19-.47-.37-.86-.82-1.21-1.3Z"/></svg>`;
/**
 * DataLayer Persistence Manager
 * Handles storing and retrieving datalayer events across page navigations
 */
(function() {
  // Configuration
  const STORAGE_KEY = 'deferredDataLayerEvents';
  const MAX_STORAGE_AGE_MS = 30 * 60 * 1000; // 30 minutes

  /**
   * Safely stringify JSON with error handling
   */
  function safeStringify(obj) {
    try {
      return JSON.stringify(obj);
    } catch (e) {
      console.error('Error stringifying object:', e);
      return null;
    }
  }

  /**
   * Safely parse JSON with error handling
   */
  function safeParse(str) {
    if (!str) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      console.error('Error parsing JSON:', e);
      return null;
    }
  }

  /**
   * Check if localStorage is available
   */
  function isLocalStorageAvailable() {
    try {
      const test = '__test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Store an event in localStorage
   */
  function storeEvent(eventData) {
    if (!isLocalStorageAvailable()) return false;

    try {
      // Get existing events or initialize empty array
      const storedEvents = safeParse(localStorage.getItem(STORAGE_KEY)) || [];

      // Add timestamp to event
      const eventWithTimestamp = {
        ...eventData,
        __timestamp: Date.now()
      };

      // Add to array and store
      storedEvents.push(eventWithTimestamp);
      localStorage.setItem(STORAGE_KEY, safeStringify(storedEvents));
      return true;
    } catch (e) {
      console.error('Error storing event in localStorage:', e);
      return false;
    }
  }

  /**
   * Process stored events and push to dataLayer
   */
  function processStoredEvents() {
    if (!isLocalStorageAvailable()) return;
    if (!window.dataLayer) return;

    try {
      // Get stored events
      const events = safeParse(localStorage.getItem(STORAGE_KEY)) || [];
      if (events.length === 0) return;

      // Filter out expired events
      const now = Date.now();
      const validEvents = events.filter(event => {
        // Skip events without timestamp or those that are too old
        return event.__timestamp &&
               (now - event.__timestamp) < MAX_STORAGE_AGE_MS;
      });

      // Process valid events
      validEvents.forEach(event => {
        // Remove the timestamp before pushing to dataLayer
        const { __timestamp, ...cleanEvent } = event;

        // Push to dataLayer
        console.log('Processing deferred event:', cleanEvent);
        window.dataLayer.push(cleanEvent);
      });

      // Clear storage
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Error processing stored events:', e);
      // Try to clear storage to prevent repeated errors
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (clearError) {}
    }
  }

  /**
   * Initialize the module
   */
  function init() {
    // Process any stored events on page load
    if (document.readyState === 'complete') {
      processStoredEvents();
    } else {
      window.addEventListener('load', function() {
        processStoredEvents();
      });
    }
  }

  // Auto-initialize
  init();

  // Export public methods
  window.datalayerPersistence = {
    storeEvent: storeEvent,
    processStoredEvents: processStoredEvents
  };
})();
class DaysUI {
    constructor(data, container, today, principalName) {
        this.data = data;
        this.container = container;
        this.jsToday = today;
        this.principalName = principalName;
        this.initialize();
    }

    formatKM = new Intl.NumberFormat('da-DK', {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    day = new Intl.DateTimeFormat('da-DK', { weekday: 'long' });

    initialize() {
        let s = `<form id="principaldays" class="cf" autocomplete="off"><input type="submit" value="Gem cykeldage" /><h1>${this.principalName}</h1>`;
        this.data.campaigns.map((c) => {
            let start = c.startDataEntry.split('T')[0];
            let end = c.endDataEntry.split('T')[0];
            s += `<h2 data-id="${c.id}">${c.name}</h2>
            <p>(${start} - ${end})</p>
                        <table>
                            <thead>
                                <tr>
                                    <th>Arbejde</th>
                                    <th>Fritid</th>
                                </tr>
                            </thead>
                            <tbody>`;


            const currentDate = new Date(start);
            const endDate = new Date(end);
            while (currentDate <= endDate) {
                if (!isNaN(currentDate.getTime())) {
                    let disabled = currentDate > this.jsToday;
                    let date = currentDate.toISOString().slice(0, 10);
                    s += `<tr class="date"><td colspan="2">${currentDate.toLocaleDateString("da-DK")}</td></tr><tr>
                                    <td>${this.dayInput("Arbejde", this.data.days[date], "distance", date, disabled)}</td>
                                    <td>${this.dayInput("Fritid", this.data.days[date], "playDistance", date, disabled)}</td>
                                </tr>`;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
            s += `</tbody></table><input type="submit" value="Gem cykeldage" />`;
        });
        this.container.innerHTML = s + `</form>`;
        document.getElementById('principaldays').addEventListener('submit', (e) => this.saveChanges(e));
        this.container.querySelectorAll('input[type="text"]').forEach(input => {
            input.addEventListener('change', (e) => {
                this.cleanInput(e.target);
            });
        });
    }

    //  pattern="^[0-9]*[.,]?[0-9]*$" breaks icloud passwords extension in edge so left out
    dayInput(title, data, field, date, disabled) {
        const value = data ? data[field] : 0;
        return `<input${(disabled ? ' disabled="disabled"' : '')} maxlength="6" autocomplete="km-${title}" title="${title}" data-value="${value}" value="${value === 0 ? '' : this.formatKM.format(value)}" data-field="${field}" data-date="${date}" data-initial="${value}" placeholder="km" type="text" inputmode="decimal">`;
    }

    formatNumberInput(value) {
        // Return empty string for empty or whitespace-only input
        if (!value || value.trim() === '') {
            return '';
        }

        // Remove all whitespace
        let cleanValue = value.replace(/\s/g, '');

        // Count occurrences of . and ,
        const dotCount = (cleanValue.match(/\./g) || []).length;
        const commaCount = (cleanValue.match(/,/g) || []).length;

        // Handle decimal separator logic
        if (dotCount + commaCount > 0) {
            let lastSeparatorPos = -1;

            // Find the last separator and its position
            const lastDotPos = cleanValue.lastIndexOf('.');
            const lastCommaPos = cleanValue.lastIndexOf(',');

            if (lastDotPos > lastCommaPos) {
                lastSeparatorPos = lastDotPos;
            } else {
                lastSeparatorPos = lastCommaPos;
            }

            // Remove all separators except the last one and convert it to a dot
            cleanValue = cleanValue.substring(0, lastSeparatorPos).replace(/[.,]/g, '') + '.' + cleanValue.substring(lastSeparatorPos + 1).replace(/[.,]/g, '');
        }

        let num = parseFloat(cleanValue);

        if (isNaN(num) || num <= 0) {
            return '';
        }

        num = Math.min(num, 300);

        return this.formatKM.format(num);
    }

    cleanInput(input) {
        const date = input.dataset.date;
        const field = input.dataset.field;
        const value = this.formatNumberInput(input.value);
        input.value = value;

        if (this.data.days[date] == null) {
            this.data.days[date] = {
                distance: 0,
                playDistance: 0,
                changed: false
            };
        }

        this.data.days[date][field] = parseFloat(value.replace(',', '.')) || 0;
        this.data.days[date].changed = value !== input.dataset.initial;
    }

    async saveChanges(e) {
        e.preventDefault();
        e.stopPropagation();
        this.container.querySelectorAll('input[type="text"]').forEach(input => {
            this.cleanInput(input);
        });
        console.log("saving:", this.data);
        toAPI("setPrincipalDays", (days) => {
            console.log(days);
            addBrief("Dage opdateret");
        }, this.data);
    }
}
﻿const cacheVersion = 1;
var localLanguage = "";
const savedTimes = {};

window.local = {
    "General.Campaign.da": "Kampagne",
    "General.Campaign.en": "Campaign",
    "General.Choose.da": "Vælg",
    "General.Choose.en": "Choose",
    "General.Create.da": "Opret",
    "General.Create.en": "Create",
    "General.Email.da": "Email",
    "General.Email.en": "Email",
    "General.GenericError.da": "Der er sket en fejl der ikke burde ske, vi beklager ulejligheden, prøv evt. igen om et par minutter.",
    "General.GenericError.en": "An unexpected error occured, we apologize for the inconvenience, try again in a minute or two.",
    "General.LogIn.da": "Log ind",
    "General.LogIn.en": "Log in",
    "General.Municipality.da": "Kommune",
    "General.Municipality.en": "Municipality",
    "General.Name.da": "Navn",
    "General.Name.en": "Name",
    "General.NotInGroup.cc1.da": "Ikke en del af en skole i listen",
    "General.NotInGroup.da": "Ikke en del af en organisation i listen",
    "General.NotInGroup.en": "Not part of a group of workplaces on this list",
    "General.Participant.da": "Deltager",
    "General.Participant.en": "Participant",
    "General.Participants.da": "Deltagere|Deltager",
    "General.Participants.en": "Participants|Participant",
    "General.ParticipantInvite.da": "Se dine holddeltagere og inviter med email her",
    "General.ParticipantInvite.en": "View your team participants and invite by email here",
    "General.Password.da": "Password (mindst 6 tegn)",
    "General.Password.en": "Password (at least 6 chars)",
    "General.Postcode.da": "Postnummer",
    "General.Postcode.en": "Postcode",
    "General.RepeatPassword.da": "Gentag password",
    "General.RepeatPassword.en": "Repeat password",
    "General.Save.da": "Gem",
    "General.Save.en": "Save",
    "General.Seats.da": "Pladser|Plads",
    "General.Seats.en": "Seats|Seat",
    "General.Team.da": "Hold",
    "General.Team.en": "Team",
    "General.TeamCaptain.da": "Holdkaptajn",
    "General.TeamCaptain.en": "Team captain",
    "General.TeamName.da": "Holdnavn",
    "General.TeamName.en": "Team name",
    "General.TeamSize.da": "Holdstørrelse",
    "General.TeamSize.cc1.da": "Antal elever i klassen",
    "General.TeamSize.en": "Team size",
    "General.NotPlay.da": "Arbejde",
    "General.NotPlay.cc1.da": "Skole",
    "General.Play.da": "Fritid",
    "General.Update.da": "Opdater",
    "General.Update.en": "Update",
    "General.Work.cc1.da": "Skole",
    "General.Work.da": "Arbejde",
    "General.Work.en": "Work",
    "General.Workplace.cc1.da": "Klasse",
    "General.Workplace.cc1.en": "Class",
    "General.Workplace.da": "Arbejdsplads",
    "General.Workplace.en": "Workplace",
    "General.WorkplaceGroup.cc1.da": "Skole",
    "General.WorkplaceGroup.da": "Organisation",
    "General.WorkplaceGroup.en": "Organisation",
    "General.WorkplaceGroupLabel.cc1.da": "Skole",
    "General.WorkplaceGroupLabel.da": "Er din arbejdsplads en del af en større organisation? Vælg herunder: <a>(?)<span>Vi bruger denne information til at kunne vise samlet statistik for alle hold i store virksomheder der har flere adresser.</span></a>",
    "General.WorkplaceGroupLabel.en": "Is your workplace a part of a larger organisation? Choose below: <a>(?)<span>We use this information to show statistics for all workplaces in large companies with multiple addresses.</span></a>",
    "General.WorkplaceGroupYour.cc1.da": "Din skole",
    "General.WorkplaceGroupYour.da": "Din organisation",
    "General.WorkplaceGroupYour.en": "Your Organisation",
    "General.WorkplaceYour.cc1.da": "Din skole",
    "General.WorkplaceYour.da": "Din arbejdsplads ",
    "General.WorkplaceYour.en": "Your workplace",
    "General.YourName.da": "Dit navn",
    "General.YourName.en": "Your name",
    "Profile.CreateTeam.da": "Opret nyt hold",
    "Profile.CreateTeam.cc1.da": "Opret ny klasse",
    "Profile.CreateTeam.en": "Create team",
    "Profile.DeleteTeam.da": "Slet hold",
    "Profile.DeleteTeam.en": "Delete team",
    "Profile.EditTeam.da": "Rediger holddetaljer",
    "Profile.EditTeam.en": "Edit team details",
    "Profile.Municipality.cc1.da": "Skolens kommune",
    "Profile.Municipality.da": "Kommune",
    "Profile.Municipality.en": "Municipality",
    "Profile.Postcode.cc1.da": "Skolens postnummer",
    "Profile.Postcode.da": "Postnummer",
    "Profile.Postcode.en": "Postcode",
    "Profile.SaveBikeDays.da": "Gem cykeldage",
    "Profile.SaveBikeDays.en": "Save bike days",
    "Profile.SaveBikeDaysError.da": "En eller flere af dine cykeldage har en ugyldig værdig, du kan kun bruge tal.<br><br> De ugyldige værdier er fremhævet med rødt",
    "Profile.SaveBikeDaysError.cc1.da": "En eller flere af dine cykeldage har en ugyldig værdig, du kan kun bruge tal.<br><br> De ugyldige værdier er markeret med lyserødt i venstre side",
    "Profile.SaveBikeDaysError.en": "One or more of your bike days has an invalid value, only numbers can be used.<br><br> The invalid value(s) are highlighted in red",
    "Profile.WelcomeHeadingPostfix.cc1.da": "på fællestour",
    "Profile.WelcomeHeadingPostfix.da": "cykler til arbejde",
    "Signup.Consent.da": "Ja, jeg vil gerne deltage i Cyklistforbundets kampagneaktiviteter og accepterer at mine data registreres og anvendes i henhold til <a href =\"https://www.cyklistforbundet.dk/persondata\" target=\"_blank\">Cyklistforbundets persondatapolitik</a>.",
    "Signup.Consent.en": "Yes, I would like to participate in Cyklistforbundets campaignactivities and hereby consent to the registration of my data and its use according to <a href =\"https://www.cyklistforbundet.dk/persondata\" target=\"_blank\">Cyklistforbundets persondatapolitik</a>to VI CYKLER TIL ARBEJDEs <a href=\"/persondata\" target=\"_blank\">persondatapolitik</a>.",
    "Signup.Create.da": "Opret profil",
    "Signup.Create.en": "Create profile",
    "Stats.WorkplaceLinkBy.cc1.da": "groups",
    "Stats.WorkplaceLinkBy.da": "companies",
    "Stats.WorkplaceLinkText.cc1.da": "Se alle hold fra din skole",
    "Stats.WorkplaceLinkText.da": "Se alle hold på din arbejdsplads",
    "Teams.InviteHeading.da": "Invitér deltagere til dit hold",
    "Teams.InviteHeading.cc1.da": "Invitér dine elever",
    "Teams.InviteText.da": "Skriv email på dem der skal med på dit hold",
    "Teams.InviteText.cc1.da": "Kopiér linket og del det med dem, der skal med på dit hold:"
}
﻿addDomReadyEventListener(() => {
    let campaignDropdowns = document.querySelectorAll("select[name='campaigns']");

    if (campaignDropdowns && campaignDropdowns.length > 0) {
        toAPI("adminCampaigns", function (data) {
            let options = '';
            forEach(data, function (c) {
                options += '<option value="' + c.id + '">' + c.name + ' (' + c.startDataEntry.substr(0, c.startDataEntry.indexOf('T')) + ')</option>';
                includePlayInTrophyCalculations[c.id] = c.includePlayInTrophyCalculations;
            });
            var empty = '<option value="0">Vælg kampagne</option>';
            forEach(campaignDropdowns, function (el) {
                el.innerHTML = (el.classList.contains("defaultAll") ? empty : "") + options;
            });

            if (urlParam("campaigntable") && data) {
                let table = document.getElementById("campaignTable");
                if (!table) {
                    table = document.createElement('table');
                    table.id = "campaignTable"
                    document.body.appendChild(table);
                }
                let s = "<tr>";
                forEach(Object.getOwnPropertyNames(data[0]), function (n) {
                    s += "<th>" + n + "</th>";
                });
                s += "</tr>";
                forEach(data.reverse(), function (r) {
                    s += "<tr>";
                    forEach(Object.values(r), function (c) {
                        s += "<td>" + c + "</td>";
                    });
                    s += "</tr>";
                });

                table.innerHTML += s;
            }
        }, "{}");
    }

    addEvent("#adminusers .cf", "submit", function (e) {
        let text = e.target.querySelector("input[name='text']");
        let campaign = e.target.querySelector("select[name='campaigns']");
        let post = { "Users": true, "Text": text.value, "CampaignId": campaign.value ? parseInt(campaign.value) : 0 };
        toAPI("adminSearch", function (data) {
            if (data.participants) {
                let table = "<table>";
                forEach(data.participants, function (el) {
                    table += '<tr><td>' + el.name + '</td><td><a href="/umbraco/surface/adminvctasurface/impersonate?email=' + el.email + '&url=' + encodeURIComponent(document.location.protocol + '//' + document.location.host) + '" target="_blank">' + el.email + '</a></td><td>' + (el.phone ? el.phone : '-') + '</td></tr>';
                });
                if (data.participants.length === 0) table += "<tr><td>Ingen resultater</td></tr>";
                table += "</table>";
                e.target.closest("div").querySelector(".table").innerHTML = table;
            }

        }, JSON.stringify(post));
        stopAll(e);
    });


    addEvent("#adminteams .cf", "submit", function (e) {
        let text = e.target.querySelector("input[name='text']");
        let campaign = e.target.querySelector("select[name='campaigns']");
        let post = { "Teams": true, "Text": text.value, "CampaignId": campaign.value ? parseInt(campaign.value) : 0 };
        toAPI("adminSearch", function (data) {
            if (data.teams) {
                let table = "<table>";
                forEach(data.teams, function (el) {
                    table += '<tr><td>' + el.campaign + '</td><td>' + el.name + '</td><td>' + el.group + '</td><td>' + el.company + '</td><td>' + el.municipality + '</td><td><a href="/umbraco/surface/adminvctasurface/impersonate?email=' + el.owner + '&url=' + encodeURIComponent(document.location.protocol + '//' + document.location.host) + '" target="_blank">' + el.owner + '</a></td><td>' + el.teamId + '</td></tr>';
                });
                if (data.teams.length === 0) table += "<tr><td>Ingen resultater</td></tr>";
                table += "</table>";
                e.target.closest("div").querySelector(".table").innerHTML = table;
            }

        }, JSON.stringify(post));
        stopAll(e);
    });


    addEvent("#admincampaigns .cf", "submit", function (e) {
        let campaign = e.target.querySelector("select[name='campaigns']").value;
        let type = e.target.querySelector("select[name='type']").value;
        let from = e.target.querySelector("input[name='from']").value;
        let to = e.target.querySelector("input[name='to']").value;
        let url = '/umbraco/surface/adminvctasurface/participants?campaignId=' + campaign + "&from=" + from + "&to=" + to;
        if (type === 'Hold') {
            url = VctaAPIUrl + 'teams/' + campaign + '/true';
            if (from) url += "/" + from;
            if (to) url += "/" + to;
        }
        window.open(url);
        stopAll(e);
    });

    addEvent("#adminwinners .cf", "submit", function (e) {
        let campaign = e.target.querySelector("select[name='campaigns']").value;
        let fritid = e.target.querySelector("select[name='fritid']").value;
        console.log(fritid);
        drawIPiTC = includePlayInTrophyCalculations[campaign];
        if (fritid === '1') { drawIPiTC = true; }
        if (fritid === '-1') { drawIPiTC = false; }
        let url = VctaAPIUrl + 'teams/' + campaign + '/false';
        httpr(url, function (data) {
            drawData = data;
            let drawForm = document.querySelector("#admindraw");
            removeClass(drawForm, "hidden");
            let regions = {};
            let municipalities = {};
            let groups = {};
            let companies = {};
            let potentialCount = 0;
            let sumSeatDays = 0;

            forEach(data, function (el) {
                if (el.SD > 0 || (drawIPiTC && el.PSD)) {
                    regions[el.R] = true;
                    municipalities[el.M] = true;
                    groups[el.G] = true;
                    companies[el.C] = true;
                    potentialCount++;
                    sumSeatDays += el.SD + (drawIPiTC ? el.PSD : 0);
                }
            });

            addOverlayMessage(`<p>Kampagnen har ${potentialCount} hold med mindst en cykeldag</p><p>Fritidscykling er ${drawIPiTC ? "" : "IKKE "} med i trækningen</p>`);

            drawForm.querySelector("select[name='region']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(regions));
            drawForm.querySelector("select[name='municipality']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(municipalities));
            drawForm.querySelector("select[name='group']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(groups));
            drawForm.querySelector("select[name='company']").innerHTML = '<option>Alle</option>' + createOptions(Object.entries(companies));

        }).then(() => { }).catch((ex) => { showApiError(genericError); });
        stopAll(e);
    });

    function download(data, filename, type) {
        var file = new Blob([data], { type: type });
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else {
            var a = document.createElement("a"),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }

    addEvent("#admingroups .cf", "submit", (e) => {
        stopAll(e);

        let groupCollectionId = e.target.querySelector("select[name='collectionid']").value;
        if (groupCollectionId == 0) {
            addBrief("Vælg gruppe type først");
            return;
        }
        let includeObsolete = e.target.querySelector("select[name='includeobsolete']").value == "1";
        let post = { "GroupCollectionId": parseInt(groupCollectionId), "includeObsolete": includeObsolete };

        toAPI("AdminGroups", function (data) {
            addBrief("Done, en fil med nuværende grupper kan downloades som information/ backup");
            download(data, "grupper-" + groupCollectionId + "-" + new Date().isoDate(), "txt");
        }, JSON.stringify(post));
    });

    addEvent("#adminupdategroups .cf", "submit", (e) => {
        stopAll(e);

        let groupCollectionId = e.target.querySelector("select[name='collectionid']").value;
        if (groupCollectionId == 0) {
            addBrief("Vælg gruppe type først");
            return;
        }
        let groups = e.target.querySelector("textarea").value?.trim();
        let post = { "GroupCollectionId": parseInt(groupCollectionId), "GroupNames": groups.split("\n") };

        toAPI("AdminUpdateGroups", function (data) {
            addBrief("Done, grupper er opdateret");
            customLog(0, data);
        }, JSON.stringify(post));
    });

    addEvent("#adminresetusers label:last-of-type", "click", e => {
        document.querySelector("#adminresetusers").classList.remove("flash");
    });

    addEvent("#adminresetusers .cf", "submit", (e) => {
        stopAll(e);
        e.target.closest("div").classList.remove("flash");

        let resets = e.target.querySelector("select[name='resets']").value;
        if (resets == 0) {
            addBrief("Vælg hvad der skal nulstilles/ slettes på brugerne");
            return;
        }
        let settings = resets.split(',');
        let emails = e.target.querySelector("textarea").value?.trim().split("\n");
        if (!emails || emails.length == 0 || !settings || settings.length != 3) {
            addBrief("Invalid selection / data");
            return;
        }

        let url = `/umbraco/surface/adminvctasurface/reset`;
        var data = [];
        emails.forEach(mail => {
            if (mail) mail = mail.trim();
            if (isValidEmail(mail)) {
                data.push({
                    DeleteDays: (settings[0] == "1"),
                    DeleteSelf: (settings[1] == "1"),
                    DeleteTeams: (settings[2] == "1"),
                    Email: mail
                });
            }
            else {
                addBrief(`${mail} is not a valid email`);
            }
        });

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': afToken()?.value,
            },
            body: JSON.stringify(data),
         })
        .then(response => response.text())
        .then(data => {
            console.log(data);
            addBrief(data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });

    addEvent("#admindraw .cf", "submit", function (e) {
        let region = e.target.querySelector("select[name='region']").value;
        let municipality = e.target.querySelector("select[name='municipality']").value;
        let group = e.target.querySelector("select[name='group']").value;
        let company = e.target.querySelector("select[name='company']").value;

        let message = `<p>Udtræk vinder, filtrer Region: '${region}' Kommune: '${municipality}' Organisation: '${group}' Arbejdsplads: '${company}'</p><p>Fritidscykling er ${drawIPiTC ? "" : "IKKE "} med i trækningen</p>`;

        let potentials = [];
        let sumSeatDays = 0;
        forEach(drawData, function (el) {
            if ((el.SD > 0 || (drawIPiTC && el.PSD > 0)) && (region === "Alle" || region === el.R) && (municipality === "Alle" || municipality === el.M) && (group === "Alle" || group === el.G) && (company === "Alle" || company === el.C)) {
                potentials.push(el);
                sumSeatDays += el.SD + (drawIPiTC ? el.PSD : 0);
            }
        });

        message += "Filter matcher " + potentials.length + " hold, summen af SeatDays er " + sumSeatDays + "<br /><br />";
        let r = rnd();
        let winningSD = r * sumSeatDays;
        message += "Dagens vindernummer er " + winningSD + "<br />baseret på det tilfældige tal " + r + " ganget med SeatDays summen " + sumSeatDays + "<br /><br />";

        let currentSeatDays = 0;
        var winner;
        for (var i = 0; i < potentials.length; i++) {
            currentSeatDays += potentials[i].SD + (drawIPiTC ? potentials[i].PSD : 0);
            if (currentSeatDays >= winningSD) {
                winner = potentials[i];
                break;
            }
        }

        console.log(winner);
        if (winner) {
            let date = new Date().toISOString().replace(/:/gi, "-");

            let post = { "Id": winner.TI, "Name": "" };

            let extraInfo = "";
            toAPI("adminTeamInfo", function (data) {
                if (data) {
                    if (data.OwnerName) extraInfo += "<br />Holdejer navn: " + data.OwnerName;
                    if (data.OwnerEmail) extraInfo += "<br />Holdejer email: " + data.OwnerEmail;
                    if (data.OwnerPhone) extraInfo += "<br />Holdejer telefon: " + data.OwnerPhone;
                    if (data.CaptainName) extraInfo += "<br />Kaptajn navn: " + data.CaptainName;
                    if (data.CaptainEmail) extraInfo += "<br />Kaptajn email: " + data.CaptainEmail;
                    if (data.CaptainPhone) extraInfo += "<br />Kaptajn telefon: " + data.CaptainPhone;
                }
                message += "Vinderen er: " + winner.N +
                    extraInfo +
                    "<br />Hold id: " + winner.TI + "<br />Postnummer: " + winner.Z + "<br />Region: " + winner.R + "<br />Kommune: " + winner.M + "<br />Organisation: " + winner.G + "<br />Arbejdsplads: " + winner.C +
                    "<br /><br />Udtræk vinder, filtrer Region: '" + region + "' Kommune: '" + municipality + "' Organisation: '" + group + "'" + "' Arbejdsplads: '" + company + "'" +
                    "<br /><br />" + date;
                addOverlayMessage(message);
                download("<html><head></head><body>" + message + "</body></html>", "draw-" + date + ".html", "html");
            }, JSON.stringify(post));

        }
        else {
            addOverlayMessage("Der kunne ikke findes en vinder, der er sandsynligvis sket en fejl.");
        }

        stopAll(e);
    });

});

function createOptions(a) {
    let s = '';
    forEach(a, function (el) {
        s += '<option>' + el[0] + '</option>';
    });
    return s;
}

var drawData = [];
var drawIPiTC = false;
var includePlayInTrophyCalculations = {};

function rnd() {
    return crypto.getRandomValues(new Uint32Array(1))[0] / 2 ** 32;
}
const apiData = {};
var unsavedChanges = 0;
const months = ["", "Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"];
const Days = ["søn", "man", "tir", "ons", "tor", "fre", "lør", "søn"];
const validNumber = /^[0-9.,]+$/;
var genericError;
const co2factor = 0.135;
const kcalfactor = 30;
const co2treefactor = 67;
const icetokcalfactor = 50;
const krSavedFactor = 7.11;
const daysSavedFactor = 1200;
const trophyNames = {
    "0": ["", "Første cykeldag", "5 dage i streg", "Hele holdet", "25km dag", "Djævlebakke",
        "Regnvejr", "Kagedag", "Hent en kollega", "Mørke", "40km dag",
        "Teknisk uheld", "Buks i sokken", "Kombi transport", "Fulgtes ad", "Detour",
        "Quiz", "7 dage"],
    "1": ["", "Første cykeldag", "5 dage i streg", "Hele holdet", "25km dag", "Djævlebakke",
        "Regnvejr", "Kagedag", "Hent en kollega", "Mørke", "40km dag",
        "Teknisk uheld", "Buks i sokken", "Kombi transport", "Fulgtes ad", "Detour",
        "Quiz", "7 dage"]
};

const trophyConfirm = ["", "", "", "", "",
    "Fik du kørt op ad en stejl bakke?",
    "Dryppede det på dig i dag?",
    "Har du haft kage med til hele holdet?",
    "Har du hentet en kollega?",
    "Har du cyklet i mørke?",
    "",
    "Har du repareret på din cykel?",
    "Fik du kørt med buksen i sokken?",
    "Har du både kørt på cykel og brugt et andet transportmiddel?",
    "Fulgtes du med en ven?",
    "Tog du en omvej?",
    "Har du gennemført quizzen?",
    ""];
var passiveTrophies = trophyConfirm.map((value, index) => value === "" ? index : -1).filter(index => index > 0);

const mfTrophyOverride = {"troph1": "troph1-1", "troph2": "troph2-1", "troph3": "troph3-1"};
var trophyFormatPNG = [5, 12];
const playBikeEls = ["#bikedays", "#teamdata"];
const playStatsEls = ["#stattable", "#statfavorites"];
var daysLoaded = false;
var profileLoaded = false;
var teamDataShown = false;

window.onbeforeunload = function (e) {
    if (unsavedChanges > 0) {
        let text = "Du har ændringer du ikke har gemt, er du sikker på du vil forlade denne side?";
        if (e) {
            e.returnValue = text;
        }
        return text;
    }
};

addDomReadyEventListener(() => {
    document.querySelectorAll(".sparkle").forEach(el => {
        let svg = el.classList.contains("doubleSparkle") ? "doubleSparkle" : "sparkle";
        let elf = el.firstElementChild;
        if (elf) {
            elf.insertAdjacentHTML('afterbegin', `<span>${allSVGs[svg]}</span>`);
            elf.insertAdjacentHTML('beforeend', `<span>${allSVGs[svg]}</span>`);
        }
    });

    genericError = localText("General.GenericError");
    let campaignCode = urlParam("campaigncode");
    if (campaignCode) {
        sessionStorage['campaignCode'] = `${campaignCode},${Date.now()}`;
    }

    if (urlParam("removeCampaignCode") == "true") sessionStorage.removeItem("campaignCode");

    let teamCode = urlParam("teamcode");
    if (teamCode) {
        sessionStorage['teamCode'] = `${teamCode},${Date.now()}`;
    }

    let redirect = document.querySelector("#redirect");
    if (redirect && !(redirect.dataset.target?.toLowerCase() == document.location.pathname.toLowerCase())) {
        document.location = redirect.dataset.target;
    } else {
        if ((redirect?.dataset.target?.toLowerCase() == document.location.pathname.toLowerCase())) customLog(2, "identitical path and redirect path, infinite loop", redirect?.dataset.target?.toLowerCase(), document.location.pathname.toLowerCase());
    }

    if (document.querySelector("html").classList.contains("nlo")) {
        let login = document.querySelector("#login");
        let signup = document.querySelector("#signup");
        if ((teamCode || campaignCode) && signup) {
            signup.querySelector(".toggler")?.classList.remove("off");
        } else if (campaignConfigId != 1 && signup && !login) signup.querySelector(".toggler")?.classList.remove("off");
        else if (login && !signup) login.querySelector(".toggler")?.classList.remove("off");
    }

    forEach("div[data-memberaction]", function (el) {
        let action = el.dataset.memberaction;
        if (action) {
            switch (action) {
                case "profile":
                    showProfileMessages(action);
                    break;
                case "teams":
                    showTeams(action);
                    break;
                default:
            }
        }
    });

    // let playStats = !(localStorage.getItem("playstats") === "true");
    // if (playStats) localStorage.setItem("playstats", "true");
    //
    // let ps = document.querySelector("#playstats");
    // if (ps) {
    //     ps.checked = playStats;
    // }
    //
    // addEvent("#playstats", "click", function (e) {
    //     localStorage.setItem("playstats", e.target.checked);
    //     setPlay(playStatsEls, "playstats");
    // });
    // setPlay(playStatsEls, "playstats");

    const principalsSelect = document.getElementById("principals");
    if (principalsSelect) {
        toAPI("principals", (principals) => {
            Object.entries(principals).forEach(([groupLabel, options]) => {
                const optgroup = document.createElement("optgroup");
                optgroup.label = "Hold: " + groupLabel;

                Object.entries(options).forEach(([value, text]) => {
                    const option = document.createElement("option");
                    option.value = value;
                    option.textContent = text;
                    optgroup.appendChild(option);
                });

                principalsSelect.appendChild(optgroup);
            });
            principalsSelect.addEventListener("change", () => {
                toAPI("getPrincipalDays", (days) => {
                    const daysManager = new DaysUI(days, document.querySelector('#AgentPrincipals .days'), jsToday, principalsSelect.options[principalsSelect.selectedIndex].textContent);
                }, {"Id": principalsSelect.value});
            });
            principalsSelect.disabled = false;
        }, "{}");
    }
});

// function setPlay(ids, cookie) {
//     let play = getCookie(cookie) == "1";
//     if (play) {
//         forEach(ids, function (id) {
//             let el = document.querySelector(id);
//             if (el && !hasClass(el, "personal")) {
//                 removeClass(el, "noplay");
//                 if (id != "#stattable") {
//                     addClass(el, "play");
//                 }
//             }
//         });
//     }
//     else {
//         forEach(ids, function (id) {
//             let el = document.querySelector(id);
//             if (el && !hasClass(el, "personal")) {
//                 addClass(el, "noplay");
//                 removeClass(el, "play");
//             }
//         });
//     }
// }

function showApiError(error, internal, extra) {
    if (internal) {
        if (error) {
            addOverlayMessage(error, extra);
        }
        addOverlayMessage(genericError, extra);
    } else {
        addOverlayMessage(error);
    }
}

function showApiMessages(messages) {
    if (messages && messages.length) {
        forEach(messages, function (msg) {
            addOverlayMessage(msg);
        });
    }
}

function SeatsText(el, c) {
    if (c.seats === 10000) {
        el.insertAdjacentHTML("beforeend", "<p>Du kan frit oprette hold til " + c.name + "</p>");
    } else {
        el.insertAdjacentHTML("beforeend", "<p>Du har " + c.seats + " plads" + (c.seats === 1 ? "" : "er") + " i " + c.name + ". Fordel dine pladser på hold à " + c.teamSizeMinimum + "-" + c.teamSizeMaximum + " deltagere." + (c.prepaid ? "" : "</p><p>Har du brug for flere? <a href=\"/min-side/kob\" class=\"link\">Køb her</a>") + "</p>");
    }
}

function drawTeamRoster(t, partipantEmail, includeChartData) {
    let campaign = campaignById(t.ci);
    let mailto = '';
    let me = undefined;
    let trophiesDisabled = campaign.trophiesDisabled;
    let teamRoster = '';

    t.ps.sort(dynamicSortMultiple("-d", "-k", "n"));

    let yellow = -1;
    let green = -1;
    let yScore = [];
    let gScore = [];
    forEach(t.ps, function (p, i) {
        yScore.push(0);
        gScore.push(0);

        // let pd = p.d + (campaign.includePlayInTrophyCalculations ? p.pd : 0);
        // let pk = p.k + (campaign.includePlayInTrophyCalculations ? p.pk : 0);
        let pd = p.d;
        let pk = p.k;

        yScore[i] += (pd * 100);
        yScore[i] += (pk * 0.0001);

        gScore[i] += ((p.tr?.length ?? 0) * 100000000);
        gScore[i] += (pd * 100);
        gScore[i] += (pk * 0.0001);

        if (yScore[i] > 0 && yScore[i] > yellow) yellow = yScore[i];
        if (gScore[i] > 0 && gScore[i] > green) green = gScore[i];
    });

    let ccId = campaign.campaignConfigId;

    // TODO: need data made available to draw daily average and/ or sum for all participants, sum can be calculated from average
    let teamInfo = {s: 0, d: 0, pd: 0, k: 0.0, pk: 0.0};
    let meInfo = {d: 0, pd: 0, k: 0.0, pk: 0.0};
    if (t.ps && t.ps.length > 0) {
        teamRoster += '<table class="participants"><tr class="play"><th></th><th>' + localText("General.NotPlay", false, ccId) + '</th><th></th><th>' + localText("General.Play", false, ccId) + '</th><th></th><th></th>';
        forEach(t.ps, function (p, i) {
            let isMe = p.e.toLowerCase() === partipantEmail;
            if (isMe && p.l) isCaptain = true;
            let ps = '<tr><td' + (p.l === 1 ? ' class="strong"' : '') + ' title="' + p.n + '">' + p.n + (p.l === 1 ? '<div class="star small"></div>' : '') +
                (!trophiesDisabled && yellow > 0 && yScore[i] == yellow ? '<div class="jersey yellow"></div>' : '') +
                //(!trophiesDisabled && green > 0 && gScore[i] == green ? '<div class="jersey green"></div>' : '') +
                '</td><td>' + singularE(' dag', p.d) + '</td><td>' + toComma(p.k, true) + ' km</td><td class="play">' + p.pd + ' dage</td><td class="play">' + toComma(p.pk, true) + ' km</td>';

            if (!trophiesDisabled) {
                ps += '<td><div class="trophies small" data-campaignid="' + t.ci + '">'
                    + drawTrophies(campaign, p.tr, isMe, false);
                +'</div></td>';
            } else {
                ps += "<td></td>";
            }
            ps += '</tr>';
            teamInfo.s++;
            teamInfo.d += p.d;
            teamInfo.pd += p.pd;
            teamInfo.k += p.k;
            teamInfo.pk += p.pk;

            if (isMe) {
                meInfo.d = p.d;
                meInfo.pd = p.pd;
                meInfo.k = p.k;
                meInfo.pk = p.pk;
                me = p;
            } else {
                mailto += (mailto.length > 0 ? '%3B' : '') + p.e.trim();
            }
            teamRoster += ps;
        });
        teamRoster += '</table>';
    }


    // TODO add personal and team data from loop, return, add element with id and draw chart
    let personalChartData, teamChartData;
    let start = campaign.startDataEntry.isoDate();
    let end = campaign.endDataEntry.isoDate();
    if (jsTodayIsoDateString < end) end = jsTodayIsoDateString;
    let campaignLength = daysBetween(end, start) + 1;

    if (includeChartData) {
        let lbl = [];
        let serDay = [];
        let serPlayDay = [];
        let maxLength = 31;
        let startIndex = campaignLength > maxLength ? campaignLength - maxLength : 0;
        let currentDate = startIndex > 0 ? start.isoAddDatePart("d", startIndex) : start;
        let dayInWeek = currentDate.toDate().getDay();
        while (currentDate <= end) {
            lbl.push(Days[dayInWeek]);
            let v = apiData.days[currentDate];

            serDay.push(v?.distance && isFloat(v.distance) ? Number.parseFloat(v.distance) : null);
            serPlayDay.push(v?.playDistance && isFloat(v.distance) ? Number.parseFloat(v.playDistance) : null);

            dayInWeek = dayInWeek >= 6 ? dayInWeek = 0 : dayInWeek + 1;
            currentDate = currentDate.isoAddDatePart("d");
        }

        personalChartData = {
            labels: lbl,
            series: [
                {
                    name: "Cykling",
                    className: "day",
                    data: serDay,
                },
                {
                    name: "Fritidscykling",
                    className: "playday",
                    data: serPlayDay,
                },
            ],
        }
    }

    //    teamChartData = {
    //        labels: [],
    //        series: [
    //            {
    //                name: "Holdet",
    //                className: "team",
    //                data: [17, 12, 19, 16, 14, 19, 12, 14, 15, 19, 12, 19, 12, 18],
    //            },
    //        ],
    //    }
    return {
        "campaign": campaign,
        "mailto": mailto,
        "me": me,
        "teamRoster": teamRoster,
        "trophiesDisabled": trophiesDisabled,
        "personalChartData": personalChartData,
        "teamChartData": teamChartData,
        "campaignLength": campaignLength,
        "teamInfo": teamInfo,
        "meInfo": meInfo
    };
}

function drawTrophies(campaign, hasTrophies, isMe, labels = false) {
    let ps = "";

    let label = allSVGs["label"];
    let loop = campaign.enabledTrophies && campaign.enabledTrophies.length > 0 ? campaign.enabledTrophies.replace(/\s/g, '').split(',').map(Number) : Array.from({length: trophyNames.length - 1}, (_, i) => i + 1);
    let l = "</div></div>";
    loop.forEach(type => {
        let grey = hasTrophies ? ((hasTrophies?.indexOf(type) ?? -1) < 0 ? " grey" : "") : (newTrophy(campaign.id, type) ? " grey" : "");
        if (labels) {
            l = '</div><div>' + label.replace('{{text}}', trophyNames['' + campaign.campaignConfigId][type]) + '</div></div>';
        }
        let t = `troph${type}`;
        if (campaign.campaignConfigId == 1 && mfTrophyOverride[t]) t = mfTrophyOverride[t];
        let e = trophyFormatPNG.indexOf(type) >= 0 ? "png" : "svg";

        ps += '<div class="trophy tr' + type + grey + (labels && trophyConfirm[type] !== "" ? " active" : "") + '"' + (isMe ? ' data-id="ttr-' + campaign.id + '-' + type + '"' : '') + `><div style="background-image: url(/assets/svg/${t}.${e})">`
            //+ `<img loading="lazy" src="/assets/svg/${t}.${e}" alt="${n}" title="${n}" />`
            + l;
    });
    return ps;
}

function drawPersonalChart(id, barData, lineData) {
    let el = document.getElementById(id);
    if (el) {
        let bEl = el.querySelector(".bars");
        let lEl = el.querySelector(".lines");
        if (bEl) {
            if (lEl) lEl.parentNode.removeChild(lEl);
            bEl.replaceChildren();
            drawBarchart(bEl, barData.series, barData.labels, false, false, 0, true);
        }
        // TODO draw when data is available
        //    if (lEl) {
        //        lEl.replaceChildren();
        //        drawLineChart(lEl, lineData.series, lineData.labels, false, area = false, 2, false, false);
        //    }
    }
}

const savedHeights = {};

function maintainHeight(el, restore = false) {
    if (!el.style.height && !restore) {
        let key = new Date().getTime();
        el.dataset.savedheightkey = key;
        savedHeights[key] = el.offsetHeight;
        el.style.height = savedHeights[key] + 'px';
        el.innerHTML = "";
    } else if (restore) {
        if (el.dataset.savedheightkey) delete savedHeights[el.dataset.savedheightkey];
        el.style.height = '';
    }
}

function drawTeamData() {
    let teamData = apiData.profile.teamData;

    if (teamData.length === 0) return;

    let teamdataContainer = document.getElementById("teamdata");
    maintainHeight(teamdataContainer);
    let partipantEmail = apiData.profile.email.toLowerCase();
    let isCaptain = false;
    forEach(teamData, function (t) {
        let dr = drawTeamRoster(t, partipantEmail, true);
        let ccId = dr.campaign.campaignConfigId;

        let chartId = `chart-${t.i}`;
        if (jsTodayIsoDateString >= dr.campaign.startDataEntry.isoDate()) {
            let maxWidth = `min(100%, ${100 + dr.campaignLength * 70}px`;
            dr.charts = `<div class="charts" id="${chartId}" style="max-width: ${maxWidth}">
                <div class="bars"></div>
                <div class="lines"></div>
                <div class="legend"><span>${localText("General.Work", false, ccId)}</span><span>${localText("General.Play", false, ccId)}</span></div>
            </div>`;
        } else {
            dr.charts = "";
        }
        dr.teamRoster =
            '<div class="co"><div class="c"><h3>Deltagere på dit hold</h3>' +
            dr.teamRoster + '</div></div><div class="co close"><article><p style="margin-top: 12px"><a class="link" target="_blank" href="/statistik?id=' + dr.campaign.id + '&show=teams&filter=' + encodeURIComponent(ccId == 1 ? t.g : t.c) + '$&by=' + localText("Stats.WorkplaceLinkBy", true, ccId) +
            '&s=&r=&cv=&sort=3,1#stattable">' + localText("Stats.WorkplaceLinkText", false, ccId) + '</a><br />' +
            (window.campaignConfigId != 1 ? '<a class="link" target="_blank" href="/individuel-statistik?id=' + dr.campaign.id + '&by=c&filter=' + encodeURIComponent(t.c) + '$#stattable">Se alle deltagere fra ' + localText("General.WorkplaceYour", true, ccId) + '</a><br />' : '') +
            '</p></article></div>' +
            (dr.mailto.length > 0 && window.campaignConfigId != 1 ? '<div class="co close"><div class="c"><p><a class="button" href="mailto:' + dr.mailto + '">Skriv til dit hold</a></p></div></div>' : '') +
            (window.campaignConfigId != 1 ? '<div class="co"><div class="c"><form class="cf battle simpleToAPI" data-method="battle"><h3 class="toggler off">Send en udfordring</h3><div><p>Indtast email på den du vil udfordre, og vælg hvad du vil udfordre: hold eller ' + localText("General.Workplace", true, ccId) + '.<br />Vi sender en mail til jer begge to med link til jeres battle side</p>' +
                '<label for="email">Hvem vil du udfordre?</label>' +
                '<input name="email" type="email" placeholder="Email" required /><input data-type="int" type="hidden" value="' + dr.campaign.id + '" name="campaignId" />' +
                '<label for="challenge">Hvad skal battle?</label>' +
                '<select title="Challenge" name="challenge"><option value="team" selected="selected">Hold</option><option value="company">' + localText("General.Workplace", false, ccId) + '</option><option value="group">' + localText("General.WorkplaceGroup", false, ccId) + '</option></select>' +
                '<div class="result" data-status="1">Udfordringen er sendt.</div>' +
                '<div class="result" data-status="0">Vi kunne ikke sende udfordringen, er du sikker på den email du har indtastet er med i denne kampagne?</div>' +
                '<input type="submit" value="Send udfordring" />' +
                '</div></form></div></div>' : '');

        let intro = '';
        let introEl = document.getElementById("profilecampaignintro-" + t.ci);
        if (introEl) {
            intro = introEl.innerHTML;
        }

        let status = "";
        if (dr.teamInfo && dr.teamInfo.s > 0 && dr.teamInfo.d > 0) {
            status = `<div class="c"><p class="camel"><em>Du</em> har cyklet <em>${toComma(dr.meInfo.k, true)}</em> km på ${singularE(' dag', dr.meInfo.d, true, true, true)} og <em>${toComma(dr.meInfo.pk, true)}</em> fritids km på ${singularE(' dag', dr.meInfo.pd, true, true, true)}<br>`
                + `<em>Dit hold</em> har cyklet <em>${toComma(dr.teamInfo.k, true)}</em> km på ${singularE(' dag', dr.teamInfo.d, true, true, true)} og <em>${toComma(dr.teamInfo.pk, true)}</em> fritids km på ${singularE(' dag', dr.teamInfo.pd, true, true, true)}</p></div>`;
        }

        let visualProfile = '<div class="co close"><div class="c"><h3><em><span>' + escapeHTML(t.n) + '</span>' + (ccId != 1 ? "" : '<span class="ifwidehide">&#8203;,</span> <span>' + escapeHTML(t.c)) + ' </span></em>' +
            '<span class="nowrap"> - ' + t.ca + '</span></h3></div> ' +
            status +
            dr.charts +
            intro +
            (dr.trophiesDisabled ? '</div>' : `<div class="c"><h3>Dine trofæer</h3></div></div><div class="co close trophies ccid${ccId}" data-campaignid="${t.ci}">`
                + drawTrophies(campaignById(t.ci), undefined, true, true)
                + '</div><div class="co close"><article class="trophyintro"></article></div>');

        let stats = "";
        if (dr.charts) document.querySelector(".r.showDayEntry.hidden.hasSparkle")?.classList.remove("hidden");
        teamdataContainer.insertAdjacentHTML("beforeend", visualProfile + dr.teamRoster + (stats ? '<div class="r close solid bblue wideMob">' + stats + '</div>' : ''));
        teamdataContainer.querySelectorAll("em, span.nowrap").forEach(el => {
            if (el.classList.contains("nowrap")) {
                fitWidthSingle(el, el.parentNode);
            } else {
                fitWidths(el, el.parentNode, "span");
            }
        });
        drawPersonalChart(chartId, dr.personalChartData, dr.teamChartData);
    });
    maintainHeight(teamdataContainer, true);

    if (isCaptain) {
        let hasStar = document.querySelector("h1").querySelector(".star");
        if (!hasStar) document.querySelector("h1").insertAdjacentHTML("afterbegin", '<div class="star small">' + allSVGs["star"] + '</div>');
    }

    addEvents(".trophy.active", "click", function (e) {
        stopAll(e);
        let c = e.target.closest(".active");
        let info = c.dataset.id.split('-');
        let campaignId = parseInt(info[1]);
        let campaign = campaignById(campaignId);
        let type = parseInt(info[2]);

        if (Date.parse(campaign.startDataEntry) < jsToday && newTrophy(campaignId, type) || !hasClass(c, "grey")) {
            if (confirm(hasClass(c, "grey") ? trophyConfirm[type] : "Skal trofæet fjernes?")) {
                let nt = [{
                    "TypeId": type,
                    "CampaignId": campaignId,
                    "Action": hasClass(c, "grey") ? 1 : -1
                }];
                saveTrophies(nt);
            }
        } else {
            addBrief("Når kampagnen er i gang og du har cyklet i regnvejr/ hentet en kollega / taget kage med / besteget din lokale djævlebakke, kan du få trofæet!");
        }
    });

    let replaceHTML = ["trophyintro|.trophyintro"];
    forEach(replaceHTML, function (s) {
        s = s.split('|');
        let el = document.getElementById(s[0]);
        if (el) {
            let html = el.innerHTML;
            forEach(el.querySelectorAll(s[1]), function (div) {
                div.innerHTML = html;
            });
        }
    });

    initForms();

    activateToggles();

    removeClass(teamdataContainer.closest(".r"), "hidden");
}

function fitWidths(el, container, childSelector) {
    if (!childSelector) return;
    el.querySelectorAll(childSelector).forEach(child => {
        fitWidthSingle(child, container);
    });
}

function fitWidthSingle(el, container) {
    let fontSize = window.getComputedStyle(el).getPropertyValue("font-size").replace("px", "");
    let overflow = el.offsetWidth > container.offsetWidth;
    let scaled = false;
    while (fontSize > 10 && overflow) {
        fontSize--;
        el.style.fontSize = fontSize + "px";
        overflow = el.offsetWidth > container.offsetWidth;
        scaled = true;
    }
    if (scaled) el.classList.add("wide");
}


function getTogglePath(toggle) {
    let path = hasClass(toggle, "remember") ? getDomPath(toggle) : undefined;
    if (path) path = path.substr(0, path.lastIndexOf('.remember') + 9);
    return path;
}

function activateToggles() {
    let togglers = document.querySelectorAll(".toggler:not(.active)");
    addEvents(togglers, "click", function (e) {
        let toggle = e.target;
        let path = getTogglePath(toggle);
        if (hasClass(toggle, "off")) {
            removeClass(toggle, "off");
            if (path) {
                localStorage.setItem(path, true);
            }
        } else {
            addClass(toggle, "off");
            if (path) {
                localStorage.removeItem(path);
            }
        }
    }, "active");
    togglers.forEach((el) => {
        if (el.classList.contains("remember") && localStorage.getItem(getTogglePath(el))) removeClass(el, "off");
    });
}

function addMessageToNextLoad(msg, brief = true) {
    const key = brief ? "NextLoadBriefMessages" : "NextLoadMessages";
    let json = sessionStorage.getItem(key);
    let arr = json ? JSON.parse(json) : [];
    arr.push(msg);
    sessionStorage.setItem(key, JSON.stringify(arr));
}

function AgeInMinutes(d1) {
    return (Date.now() - d1) / (60 * 1000);
}

function addCode(code, postData, key) {
    if (!code) return;
    let tcParts = code.split(",");
    let datePart = tcParts.length < 2 ? Date.now() : tcParts[1] * 1;
    let expired = AgeInMinutes(datePart) > 30;
    customLog(0, key, code, tcParts, AgeInMinutes(datePart), expired, new Date(Date.now()), new Date(datePart));
    if (expired) {
        // TODO: hvad skal vi gøre hvis der lå en gammel teamcode? Hvad skal vi sige?
        sessionStorage.removeItem(key);
        const warning = `${key} expired, ${code} removed, age: ${AgeInMinutes(datePart)} minutes, your time: ${new Date(Date.now())} code time: ${new Date(datePart)} datePart: ${datePart} tcParts: ${JSON.stringify(tcParts)}`;
        customLog(1, warning, AgeInMinutes(datePart), expired);
    } else {
        postData[key.toLowerCase()] = tcParts[0];
    }
}

window.onerror = function (message, source, lineno, colno, error) {
    if (visibleLogging) {
        try {
            printError(2, message, source, lineno, colno, error);
        } catch (err) {
            console.error(err);
        }
    } else {
        console.error(message, source, lineno, colno, error);
    }
    // TODO: anything else meaningful, send an event?
    return false;
};

function customLog(level, ...args) {
    if (level < 0) {
        console.log(...args);
        return;
    }
    if (level > 0) {
        try {
            let err = {};
            args.forEach((a, i) => {
                err["p" + i] = a;
            });
            plausible(level > 1 ? "error" : "warn", {"props": err});
        } catch (error) {
            console.error("plausible", error);
            if (visibleLogging) {
                printError(2, ...args)
            }
        }
    }
    if (visibleLogging) {
        printError(level, ...args)
    }
    switch (level) {
        case 0:
            console.log(...args);
            break;
        case 1:
            console.warn(...args);
            break;
        case 2:
            console.error(...args);
            break;
        default:
            console.log(...args);
    }
}

function isElement(o) {
    try {
        return o instanceof HTMLElement;
    } catch (e) {
        return (typeof o === "object") &&
            (o.nodeType === 1) &&
            (typeof o.style === "object") &&
            (typeof o.ownerDocument === "object");
    }
}

function printError(level, ...args) {
    let errors = document.querySelector("#errors");
    if (errors) {
        let html = `<code class="${(level > 0 ? `level${level}` : '')}">`;
        args.forEach((a, i) => {
            html += `${typeof a == "string" ? a : (isElement(a) ? escapeHTML(a.outerHTML) : JSON.stringify(a, null, 2))}${i < (args.length - 1) ? " | " : ""}`;
        });
        errors.insertAdjacentHTML("afterbegin", html + "</code>\n");
    }
}

function showProfileMessages(action) {
    let postData = {};
    let campaignCode = sessionStorage['campaignCode']
    let teamCode = sessionStorage['teamCode'];
    addCode(campaignCode, postData, "campaignCode");
    addCode(sessionStorage['teamCode'], postData, "teamCode");

    toAPI(action, function (data) {
        apiData[action] = data;
        if (!apiData || !apiData.profile) {
            console.error("No profile data");
        }
        if (data.days) {
            addDays(data.days);
        }

        if (isDebug) {
            let pre = document.querySelector(".debugpre.right");
            if (pre) pre.insertAdjacentHTML("beforeend", "\n" + JSON.stringify(data, null, 2));
        }

        apiData["invitations"] = data.invitations;
        let invitationMessages = document.getElementById("invitations");
        if (data.invitations && data.invitations.length > 0) {
            forEach(data.invitations, function (el) {
                invitationMessages.insertAdjacentHTML("beforeend", '<p class="interactive campaignInvitation" data-campaignid="' + el.campaignId + '" data-teamid="' + el.teamId + '">Du er blevet inviteret til at deltage på hold ' +
                    el.teamName + ' i kampagnen ' + el.campaignName + ', vil du acceptere invitationen? <span class="result buttons"><a class="click button" data-value="6">Ja tak</a> <a class="click button Grey" data-value="-1">Nej tak</a></span></p>');
            });

            forEach("body > div.r", (el, i) => {
                if (i > 1) addClass(el, "hide");
                i++;
            });
            invitationMessages.closest(".r").classList.remove("hide");
            invitationMessages.closest(".r").classList.remove("hidden");
        }

        let invitationEls = invitationMessages.querySelectorAll("p.campaignInvitation");
        if (data.invitations && data.invitations.length > 0 && invitationEls && invitationEls > 0) {
            customLog(0, "should auto accept invitation");
        }
        forEach(invitationEls, function (el) {
            addEvents(el.querySelectorAll("a.click"), "click", function (e) {
                let p = e.target.closest("p");
                let post = {
                    "teamId": parseInt(p.getAttribute("data-teamid")),
                    "campaignId": parseInt(p.getAttribute("data-campaignid")),
                    "status": parseInt(e.target.getAttribute("data-value")),
                    "email": apiData.profile.email
                };

                removeElement(p);
                toAPI("invitations", function (data) {
                    if (teamCode) sessionStorage.removeItem('teamCode');
                    if (post.status == 6 && data.reload) {
                        refreshParticipantBaseData();
                        reload();
                    } else {
                        customLog(0, post?.status, data?.reload);
                    }
                }, JSON.stringify(post), false, undefined, "Accept");
            });
        });

        if (invitationMessages && campaignConfigId == 1 && (!apiData.profile.teamData || apiData.profile.teamData.length == 0)) {
            let yesButton = invitationMessages.querySelector("a[data-value='6']");
            if (yesButton) {
                yesButton.dispatchEvent(new Event("click"));
            }
        }

        let participantNameEl = document.getElementById("participantName");
        if (participantNameEl) {
            participantNameEl.innerHTML = data.name;
            removeClass(participantNameEl.closest(".r"), "hidden");
        } else {
            let els = document.querySelectorAll(".replaceTags");
            if (els) {
                els.forEach((el) => {
                    replaceTags(el, {"*name*": data.name?.split(new RegExp('[' + [' ', ',', '.', '@', '_', ':', ';'].join('') + ']', 'g'))[0], "*br*": "<br />"}, true);
                });
            }
        }

        let profileOwnedTeamsContainer = document.querySelector("#ProfileOwnedTeams");
        if (profileOwnedTeamsContainer && apiData.profile.isAnOwner && apiData.profile.ownedTeams) {
            removeClass(profileOwnedTeamsContainer, "hidden");
            let s = `<div class="co close"><div class="c"><h2 class="toggler remember off">Hold jeg har oprettet</h2><div><p><a class="button" href="/min-side/hold">Ret dine hold og tilføj nye</a></p>`;

            let partipantEmail = apiData.profile.email.toLowerCase();
            apiData.profile.ownedTeams.forEach((t) => {
                let dr = drawTeamRoster(t, partipantEmail, false);
                let cls = dr.teamRoster?.toString() != '' ? " remember" : " disabled";
                s += `<h5 class="toggler off${cls}">${t.n}, ${t.c}${apiData.profile.campaigns.length > 1 ? ', ' + t.ca : ''}<span class="note">${singularE(' deltager', t.ps.length)}, ${singularE(' cykeldag', t.d)}, ${t.k} km</span></h5>` +
                    (dr.teamRoster?.toString() != '' ? `<div>${dr.teamRoster}</div>` : "");
            });

            s += `</div></div></div>`;
            profileOwnedTeamsContainer.insertAdjacentHTML("afterbegin", s);
        }

        apiData.profile.startDataEntry = new Date(parsedDate(apiData.profile.startDataEntry));
        apiData.profile.endDataEntry = new Date(parsedDate(apiData.profile.endDataEntry));
        apiData.profile.lastEnd = new Date(parsedDate(apiData.profile.lastEnd));
        let messages = document.getElementById("messages");
        let showOnPublicPrepaid = false;
        let hasPublic = false;
        let hasPrepaid = false;
        let hasPaid = false;
        let hasSeats = false;
        let hasPaidSeats = false;
        let isOnTeam = false;
        let isOnPaidTeam = false;
        let activeCC1 = false;

        forEach(data.campaigns, function (c) {
            activeCC1 = c.campaignConfigId == 1;
            if (c.campaignConfigId == campaignConfigId) {
                if (c.public) hasPublic = true;
                if (c.prepaid) hasPrepaid = true;
                if (!c.prepaid && c.public) hasPaid = true;
                if (c.public && c.prepaid) showOnPublicPrepaid = true;
                if (c.seats > 0 && !c.prepaid) {
                    hasSeats = true;
                }
                if (c.seats > 0 && !c.prepaid && c.public) hasPaidSeats = true;
            }
        });
        if (!hasSeats) hasSeats = apiData.profile.isAnOwner;
        if (showOnPublicPrepaid) removeClass(".showOnPublicPrepaid", "hidden");
        if (hasSeats || (data.isACaptain && window.campaignConfigId != 1)) removeClass(".showIsTeamAdmin", "hidden");
        if (messages.innerHTML.trim() !== '') removeClass(messages.closest(".r"), "hidden");

        let showTeamData = data.teamData.length > 0;
        profileLoaded = true;
        if (showTeamData) {
            if (daysLoaded && !teamDataShown) {
                teamDataShown = true;
                updateTrophies(function () {
                });
            }
        }

        let participantEmail = apiData.profile.email.toLowerCase();
        for (let i = 0; i < data.teamData.length; i++) {
            for (let j = 0; j < data.teamData[i].ps.length; j++) {
                if (data.teamData[i].ps[j].e.toLowerCase() === participantEmail) {
                    isOnTeam = true;
                    break;
                }
            }
            if (isOnTeam) break;
        }

        activateToggles();

        let stars = "";
        let pastParticipations = "";
        forEach(apiData.profile.historicParticipations, function (participation) {
            if (participation.wasCaptain) {
                let starId = participation.campaign.id;
                if (CaptainStars.indexOf("," + starId + ",") < 0) starId = 1;
                stars += '<div class="captainstar c"><div><img loading="lazy" src="/assets/stars/' + starId + '.svg" alt="' + participation.campaign.name + '"/></div><span>' + participation.campaign.name + '<span>' + prettyDate(participation.campaign.startDataEntry) + '</span></span></div>';
            }
            pastParticipations += '<a target="_blank" href="/statistik?id=' + participation.campaign.id + '&show=teams&filter=' + encodeURIComponent(participation.team.n) + '$&by=teams">' + escapeHTML(participation.team.n) + ' (' + participation.campaign.name + ' ' + prettyDate(participation.campaign.startDataEntry) + ')</a><br />';
        });

        let captainContent = document.getElementById("captainContent");
        if (stars !== "" && captainContent) {
            captainContent.insertAdjacentHTML("beforeend", '<div class="close co c4 captainstars">' + stars + '</div>');

            let r = document.getElementById("captainContentLink");
            let a = r ? r.querySelector("a") : undefined;
            if (r) {
                removeClass(r, "hidden");
                a.addEventListener("click", function (e) {
                    stopAll(e);
                    removeClass(captainContent, "hidden");
                    removeClass(captainContent, "keep");
                    addClass(r, "hidden");
                    return false;
                });
            } else {
                removeClass(captainContent.closest(".r"), "hidden");
            }
        }

        let ppEl = document.getElementById("pastParticipations");
        if (ppEl) {
            let pastParticipations = "";
            forEach(apiData.profile.historicParticipations, function (participation) {
                if (participation.wasCaptain) {
                    let starId = participation.campaign.id;
                    if (CaptainStars.indexOf("," + starId + ",") < 0) starId = 1;
                    stars += '<div class="captainstar c"><div><img class="lazy" data-src="/assets/stars/' + starId + '.svg" alt="' + participation.campaign.name + '"/></div><span>' + participation.campaign.name + '<span>' + prettyDate(participation.campaign.startDataEntry) + '</span></span></div>';
                }
                pastParticipations += '<a target="_blank" href="/statistik?id=' + participation.campaign.id + '&show=teams&filter=' + participation.team.n + '$&by=teams">' + escapeHTML(participation.team.n) + ' (' + participation.campaign.name + ' ' + prettyDate(participation.campaign.startDataEntry) + ')</a><br />';
            });
            if (pastParticipations !== "") {
                let pastParticipationsContent = ppEl.querySelector("article");
                if (!pastParticipationsContent) {
                    ppEl.querySelector(".co").innerHTML = "<article></article>";
                    pastParticipationsContent = ppEl.querySelector("article");
                }
                pastParticipationsContent.insertAdjacentHTML("beforeend", '<p>' + pastParticipations + '</p>');

                let r = document.getElementById("pastParticipationsLink");
                let a = r ? r.querySelector("a") : undefined;
                if (a) {
                    removeClass(r, "hidden");
                    a.addEventListener("click", function (e) {
                        stopAll(e);
                        removeClass(ppEl, "hidden");
                        removeClass(ppEl, "keep");
                        addClass(r, "hidden");
                        return false;
                    });
                } else {
                    removeClass(pastParticipationsContent.closest(".r"), "hidden");
                }
            }
        }

        if (!hasPrepaid && !hasPaid && !activeCC1) removeClass(document.getElementById("ProfileNoActiveCampaigns"), "hidden");
        if (!isOnTeam && !hasPaidSeats && hasPublic && hasPaid) removeClass(document.getElementById("ProfilePayCampaignNoTeam"), "hidden");
        if (!isOnTeam && hasPrepaid) removeClass(document.getElementById("ProfilePrepaidCampaignNoTeam"), "hidden");
        apiData.showDays = showTeamData && jsToday >= apiData.profile.startDataEntry && jsToday <= apiData.profile.lastEnd;
        let campaignIds = apiData.profile.campaigns ? apiData.profile.campaigns.map((el) => el.id) : [];
        if (!apiData.showDays && apiData.profile.teamData.length > 0) {
            document.querySelectorAll(".showNoDayEntry").forEach((el) => {
                if (!el.dataset.ids || campaignIds.some(item => el.dataset.ids.includes(item))) el.classList.remove("hidden");
            });
            let hde = document.querySelector(".showNoDayEntry:not(.hidden)");
            if (hde) {
                let art = hde.querySelector("article");
                if (art && apiData.profile.teamData) {
                    art.insertAdjacentHTML('beforeend', "<p>Du er med i:</p>");
                    forEach(apiData.profile.teamData, function (td) {
                        let c = first(apiData.profile.campaigns, td.ci, "id");
                        if (c) art.insertAdjacentHTML('beforeend', '<p>' + c.name + '<br />' + prettyDate(c.startDataEntry) + ' - ' + prettyDate(c.endDataEntry) + '</p>');
                    });
                }
            }
        }
        if (apiData.showDays) showCalendar(apiData.days);
        if (campaignCode) sessionStorage.removeItem('campaignCode');
        if (teamCode) sessionStorage.removeItem('teamCode');
    }, JSON.stringify(postData));
}

function showDays(action) {
    getApiData(action, function (data) {
        addDays(data);
    });
}

function addDays(data) {
    apiData.days = data;
    let days = document.getElementById("bikedays");
    if (!days) return;
    let dates = {};
    dates.endDate = apiData.profile.endDataEntry.isoDate();
    dates.startDate = apiData.profile.startDataEntry.isoDate();
    dates.date = jsToday.isoDate();
    if (dates.date > dates.endDate) dates.date = dates.endDate;

    if (apiData.showDays) showCalendar(data);

    daysLoaded = true;
    if (profileLoaded && !teamDataShown) {
        teamDataShown = true;
        updateTrophies(function () {
            drawTeamData();
        });
    }
}

function showTeams(action) {
    toAPI("municipalities", function (data) {
        apiData.municipalities = data;
        let s = "";
        forEach("select[name='municipality']", function (el) {
            let options = el.querySelectorAll("option");
            if (!options || options.length === 0) {
                let id = el.getAttribute("data-id");
                let zip = el.getAttribute("data-zip");
                el.innerHTML = municipalityOptions(zip, id);
            }
        });
        forEach(data, function (item) {
            s += '<option value="' + item.id + '">' + item.name + '</option>';
        });
    }, undefined, true);

    getApiData(action, function (data) {
        if (!apiData["profile"]) apiData["profile"] = data;
        apiData.teams = data.teams;
        apiData.onTeams = data.onTeams;

        let campaigns = data.campaigns;
        let teamIntro = document.querySelector("#teamIntro");
        if (campaigns && campaigns.length > 0) {
            teamIntro.innerHTML = "<div></div>";
            let teamIntroDiv = teamIntro.querySelector("div");
            let anySeats = false;
            let anyPaidSeats = false;
            let payable = undefined;
            forEach(campaigns, function (c) {
                if (c.public && !c.prepaid) payable = c;
                if (c.seats > 0 && c.campaignConfigId == campaignConfigId) {
                    anySeats = true;
                    if (c.public && !c.prepaid && c.seats > 0) anyPaidSeats = true;

                    SeatsText(teamIntroDiv, c);
                }
            });
            if (payable) {
                if (apiData.profile.onTeams && apiData.profile.onTeams.length > 0) {
                    const cos = document.querySelectorAll("body > .r");
                    if (cos && cos.length > 0) cos[cos.length - 1].querySelector(".co").insertAdjacentHTML("beforeend", "<article><h3>Vil du lave et nyt hold eller udvide et eksisterende?</h3><p>Køb pladser til <a href=\"/min-side/kob\">" + payable.name + "</a></p><p>Det er kun den der har oprettet et hold der kan købe flere pladser til holdet.</p></article>");
                } else {
                    let cpc = window.participantBaseData?.CurrentPaidCampaignIds;
                    let ci = window.participantBaseData?.CurrentFilterValues?.CampaignIds;
                    if (cpc && ci && !cpc.some(e => ci.includes(e))) removeClass(document.getElementById("ProfilePayCampaignNoTeam"), "hidden");
                    //teamIntroDiv.insertAdjacentHTML("beforeend", "<p><a href=\"/min-side/kob\" class=\"button\">Køb pladser til " + payable.name + "</a></p>");
                }
            }
            if (payable && teamIntro.innerHTML !== '<div></div>') {
                //teamIntro.insertAdjacentHTML("afterbegin", '<p class="toggler off">Hvor mange pladser har jeg?</p>');
            } else {
                teamIntro.innerHTML = "";
            }
        } else {
            teamIntro.innerHTML = "<p>Der er ikke nogen aktive kampagner i øjeblikket</p>";
        }

        drawTeams();
    });
}

function municipalityOptions(zip, id) {
    if (!apiData.municipalities) return "";
    let zips = apiData.municipalities[zip];
    if (!zips) return "";
    let s = "";
    if (id) id = id.toString();
    if (zips) {
        if (zips.length > 1) {
            s += '<option value="">' + localText("General.Choose") + ' ' + localText("General.Municipality", true) + '</option>';
        }
        forEach(zips, function (item) {
            s += '<option value="' + item[0] + '"' + (item[0] === id ? ' selected' : '') + '>' + item[1] + '</option>';
        });
    }
    return s;
}

function getSizeHelp(campaign, teamId) {
    let html = '';
    if (!campaign && apiData.profile.campaigns.length > 0) campaign = apiData.profile.campaigns[0];
    if (campaign) {
        let ccId = campaign.campaignConfigId;
        let teams = apiData.teams;
        let seatsLeft = 0;
        seatsLeft = campaign.seats;
        forEach(teams, function (team) {
            if (team.campaignId === campaign.id) seatsLeft -= team.seats;
        });
        let currentSize = 0;
        if (teamId) {
            let team = first(teams, teamId, "id");
            if (team) {
                currentSize = team.seats;
            }
        }

        html += `<a class="spaceafter toggler off">Tilføj plads</a><div class="">`;
        if (currentSize === campaign.teamSizeMaximum && seatsLeft < campaign.teamSizeMinimum) {
            html += `<p>Dit hold kan ikke laves større, og du har ikke pladser nok til at lave et nyt hold, <a href="/min-side/kob">Køb flere pladser for at udvide holdet eller lave et nyt hold</a></p>`;
        } else if (currentSize === campaign.teamSizeMaximum && seatsLeft >= campaign.teamSizeMinimum) {
            html += `<p>Dit hold kan ikke laves større, men du kan lave et nyt hold lidt længere nede ad siden under "Opret nyt hold"</p>`;
        } else if (seatsLeft === 0) {
            html += `<p><a href="/min-side/kob">Køb flere pladser for at udvide holdet eller lave nyt</a></p>`;
        } else {
            html += `<p>Du kan lave holdet større eller mindre ved at vælge en anden <a class="highlight closest" data-highlight="size">holdstørrelse</a></p>`;
            if (seatsLeft < campaign.teamSizeMinimum) {
                html += `<p>Du har ikke pladser nok til at lave et nyt hold, <a href="/min-side/kob">Køb flere pladser for at lave et nyt hold</a></p>`;
            }
        }
        html += `</div>`;
    }
    return html;
}

function getSizeHTML(campaign, teamId) {
    let sizeHTML = '';
    if (!campaign && apiData.profile.campaigns.length > 0) campaign = apiData.profile.campaigns[0];
    if (campaign) {
        let ccId = campaign.campaignConfigId;
        let teams = apiData.teams;
        let seatsLeft = 0;
        seatsLeft = campaign.seats;
        forEach(teams, function (team) {
            if (team.campaignId === campaign.id) seatsLeft -= team.seats;
        });
        let currentSize = 0;
        if (teamId) {
            let team = first(teams, teamId, "id");
            if (team) {
                currentSize = team.seats;
                seatsLeft += currentSize;
            }
        }
        if (seatsLeft >= campaign.teamSizeMinimum) {
            for (let i = campaign.teamSizeMinimum; i <= campaign.teamSizeMaximum; i++) {
                if (i <= seatsLeft) sizeHTML += '<option value="' + i + '"' + (i === currentSize ? ' selected' : '') + '>' + i +
                    (ccId != 1 ? ' ' + (i == 1 ? localText("General.Participants").substring(0, localText("General.Participants").length - 1) : localText("General.Participants")) : '') + '</option>';
                if (i == seatsLeft && i < campaign.teamSizeMaximum) sizeHTML += `<option disabled>Køb flere pladser for at lave holdet større end ${i}</option>`;
            }
        } else {
            sizeHTML = '';
        }
    }
    return sizeHTML;
}

function updateCaptain(form) {
    if (form.dataset.campaignconfigid != "1") {
        let captains = form.querySelector("select[name='captain']");
        let currentCaptain = captains.value;
        let captainOptions = "";
        forEach(form.querySelectorAll("input[name='email']"), function (el) {
            let v = el.value;
            if (isValidEmail(v)) {
                captainOptions += '<option' + (v === currentCaptain ? ' selected' : '') + '>' + v + '</option>';
            }
        });
        captains.innerHTML = captainOptions;
    }
}

function addDataList(campaign) {
    let datalist = document.getElementById("companies" + campaign.id);
    if (!datalist) {
        let dls = "";
        forEach(campaign.workplaces, function (item) {
            dls += '<option>' + item + '</option>';
        });
        let dl = document.createElement("datalist");
        dl.id = "companies" + campaign.id;
        dl.innerHTML = dls;
        document.body.insertAdjacentElement('beforeend', dl);
    }
}

function drawTeams(openTeamId) {
    let teamsEl = document.getElementById("teams");
    maintainHeight(teamsEl);
    teamsEl.innerHTML = apiData.teams && apiData.teams.length > 0 && apiData.onTeams && apiData.onTeams.length > 0 ? '<h1>Hold, du har oprettet</h1>' : '';

    let headingShownForId = [];
    let campaignColors = [];
    forEach(apiData.teams, function (el) {
        let heading = undefined;
        if (headingShownForId.indexOf(el.campaignId) < 0) {
            headingShownForId.push(el.campaignId);
            if (campaignColors.indexOf(el.campaignId) < 0) campaignColors.push(el.campaignId);
            heading = '<h2 class="fakeR col' + (campaignColors.indexOf(el.campaignId) % 4) + '">' + el.campaignName + '</h2><p>' + prettyDate(el.startDataEntry) + ' - ' + prettyDate(el.endDataEntry) + '</p>';
        }
        drawTeam(el, true, heading, (campaignColors.indexOf(el.campaignId) % 4), openTeamId);
    });

    if (apiData.teams && apiData.teams.length > 0 && apiData.onTeams && apiData.onTeams.length > 0) {
        teamsEl.insertAdjacentHTML('beforeend', '<h1 class="spaced fakeR">Hold, du er holdkaptajn på</h1>');
    }

    headingShownForId = [];
    forEach(apiData.onTeams, function (el) {
        if (!hasAny(apiData.teams, el.id, "id")) {
            let heading = undefined;
            if (headingShownForId.indexOf(el.campaignId) < 0) {
                headingShownForId.push(el.campaignId);
                if (campaignColors.indexOf(el.campaignId) < 0) campaignColors.push(el.campaignId);
                heading = '<h2 class="fakeR col' + (campaignColors.indexOf(el.campaignId) % 4) + '">' + el.campaignName + '</h2><p>' + prettyDate(el.startDataEntry) + ' - ' + prettyDate(el.endDataEntry) + '</p>';
            }
            drawTeam(el, false, heading, (campaignColors.indexOf(el.campaignId) % 4));
        }
    });
    let campaignsHTML = '';
    let s = '';
    let selectedCampaign = undefined;
    let campaignsWithSeats = 0;
    let selectedGroupId = "";
    forEach(apiData.profile.campaigns, function (campaign) {
        if (campaign.seats > 0 && campaign.campaignConfigId == campaignConfigId) {
            let sizeHTML = getSizeHTML(campaign);
            if (sizeHTML != "") {
                campaignsHTML += '<option value="' + campaign.id + '">' + campaign.name + '</option>';
                campaignsWithSeats++;
                if (selectedCampaign === undefined) selectedCampaign = campaign;
            }
            if (campaign.campaignConfigId != 1) addDataList(campaign);
        }
    });

    if (selectedCampaign) {
        let sizeHTML = selectedCampaign ? getSizeHTML(selectedCampaign) : "";

        selectedGroupId = selectedCampaign.groups && selectedCampaign.groups.length === 1 ? selectedCampaign.groups[0].id : "";
        let notInGroup = localText("General.NotInGroup", false, selectedCampaign.campaignConfigId);
        let groupLabel = localText("General.WorkplaceGroupLabel", false, selectedCampaign.campaignConfigId);

        let groupSelect = "";
        if (selectedCampaign.hasDefaultGroup) groupSelect += '<option value="1">' + notInGroup + '</option>';
        forEach(selectedCampaign.groups, function (g) {
            groupSelect += '<option value="' + g.id + '">' + g.name + '</option>';
        });

        let workplaceValue = '';
        if (selectedCampaign.workplacesAsDropdown && selectedCampaign.workplace && selectedCampaign.workplaces.length == 1) {
            workplaceValue = selectedCampaign.workplaces[0];
        }
        s = campaignsHTML === "" ? "" : '<form autocomplete="off" class="cf team create" data-eventextra="create" data-id="">' +
            '<div class="fakeR"></div><h2 class="toggler' + (apiData.teams && apiData.teams.length > 0 ? " off" : "") + '">' + localText("Profile.CreateTeam") + '</h2><div>' +
            '<div' + (campaignsWithSeats <= 1 ? ' class="hidden"' : "") + '><label>' + localText("General.Campaign") + '</label><select title="Campaign" name="campaign"' + (campaignsWithSeats > 1 ? '' : ' disabled="disabled"') + '>' + campaignsHTML + '</select></div>' +
            '<label>' + localText("General.TeamSize") + '</label><select title="Size" name="size" required><option value="">' + localText("General.Choose") + ' ' + localText("General.TeamSize", true) + '</option>' + sizeHTML + '</select>' +
            '<label>' + localText("General.TeamName") + '</label><input placeholder="' + localText("General.TeamName") + '" name="name" value="" required />' +
            '<label id="createWorkplaceLabel">' + localText("General.Workplace") + '</label><input placeholder="' + localText("General.Workplace") + '" name="company" ' +
            (selectedCampaign.campaignConfigId != 1 ? 'list="companies' + selectedCampaign.id + '"' : '') +
            ' value = "' + workplaceValue + '" required ' + (workplaceValue ? 'disabled ' : '') + ' /> ' +
            '<div' + (selectedGroupId ? ' class="hidden"' : '') + '><label id="createGroupLabel">' + groupLabel + '</label><select title="Group" name="group" data-id="" required>' + groupSelect + '</select></div>' +
            '<label>' + localText("Profile.Postcode") + '</label><input list="allzips" placeholder="' + localText("Profile.PostcodePlaceHolder", false, 0, ["Profile.Postcode"]) + '" name="zip" data-id="" value="" pattern="[0-9]{4}" maxlength="4" required />' +
            '<label>' + localText("Profile.Municipality") + '</label><select title="Municipality" name="municipality" data-id="" data-zip="" required></select>' +
            '<input type="submit" value="' + localText("Profile.CreateTeam") + '" disabled></div></form>';
    }

    if (campaignsHTML === '') s = '';

    //teamsEl.insertAdjacentHTML('afterbegin', s);
    teamsEl.insertAdjacentHTML('beforeend', s);

    if (selectedCampaign && selectedGroupId && s) {
        document.querySelector(".create select[name='group']").value = selectedGroupId;
    }

    let c = "";
    let teamsShown = {};
    forEach(apiData.teams, function (el) {
        if (daysDiff(el.endDataEntry, jsToday) <= 0) {
            c += '<p class="toggler off">' + el.name + '(' + el.seats + ') - ' + el.campaignName + '</p>' +
                '<div><form class="cf combined" data-id="' + el.id + '" data-campaignid="' + el.campaignId + '" data-seats="' + el.seats + '" data-length="' + daysDuration(el.startDataEntry, el.endDataEntry) + '">' +
                '<label>Cykeldage i alt for hele holdet</label><input placeholder="Cykeldage" name="days" value="" pattern="[0-9]+" maxlength="4" required />' +
                '<label>KM i alt for hele holdet</label><input placeholder="KM" name="kms" value="" pattern="[0-9,]+" maxlength="15" required />' +
                '<input type="submit" value="Gem data for hele holdet og overskriv nuværende data" style="white-space: initial;" disabled>' +
                '</form></div>';
            teamsShown[el.id] = 1;
        }
    });
    forEach(apiData.onTeams, function (el) {
        if (!teamsShown[el.id] && daysDiff(el.endDataEntry, jsToday) <= 0) {
            c += '<p class="toggler off">' + el.name + '(' + el.seats + ') - ' + el.campaignName + '</p>' +
                '<div><form class="cf combined" data-id="' + el.id + '" data-campaignid="' + el.campaignId + '" data-seats="' + el.seats + '" data-length="' + daysDuration(el.startDataEntry, el.endDataEntry) + '">' +
                '<label>Cykeldage i alt for hele holdet</label><input placeholder="Cykeldage" name="days" value="" pattern="[0-9]+" maxlength="4" required />' +
                '<label>KM i alt for hele holdet</label><input placeholder="KM" name="kms" value="" pattern="[0-9,]+" maxlength="15" required />' +
                '<input type="submit" value="Gem data for hele holdet og overskriv nuværende data" style="white-space: initial;" disabled>' +
                '</form></div>';
            teamsShown[el.id] = 1;
        }
    });

    let oldCombinedEl = document.getElementById("combinedDayKM");
    if (oldCombinedEl) oldCombinedEl.parentElement.removeChild(oldCombinedEl);
    if (c != "" && campaignConfigId != 1) {
        teamsEl.parentElement.insertAdjacentHTML('beforeend', '<div id="combinedDayKM"></div>');
        let combinedEl = document.getElementById("combinedDayKM");
        combinedEl.insertAdjacentHTML('beforeend', '<div class="fakeR"></div><p class="toggler off">Samlet indtastning af KM og cykeldage</p><div><p>OBS! Brug kun funktionen, hvis dine holdkammerater absolut ikke har mulighed for selv at logge ind og taste. Når du skriver de samlede km og cykeldage ind, vil det overskrive alt, hvad dine holdkammerater har indtastet, og erstatte det med en andel af de resultater du taster.</p><p>Læg hele holdets kilometer og cykeldage sammen og udfyld felterne.</p><p>Eksempel: Hvis A har cyklet 10 dage og 100km, B har cyklet 5 dage og 50 km, skal man taste: 15 cykeldage og 150 km.</p>' + c + '</div>');

        addEvents("#combinedDayKM input", "change", function (e) {
            if (e.target.type && e.target.type !== "submit") {
                let form = e.target.closest("form");
                form.querySelector("input[type='submit']").disabled = false;
            }
        });

        addEvents("#combinedDayKM form", "submit", function (e) {
            e.preventDefault();
            let form = e.target.closest("form");
            let teamId = parseInt(form.getAttribute("data-id"));
            let campaignId = parseInt(form.getAttribute("data-campaignid"));
            let seats = parseInt(form.getAttribute("data-seats"));
            let length = parseInt(form.getAttribute("data-length"));
            let days = toPoint(form.querySelector('input[name="days"]').value);
            let kms = toPoint(form.querySelector('input[name="kms"]').value);
            if (days > length * seats) {
                addBrief("Du har flere cykeldage end der er dage og deltagere til på dit hold.")
                return;
            }
            if (kms > length * seats * 300) {
                addBrief("Du har flere KM end der må være per deltager per dag, maksimum er 300km for en deltager på en dag.")
                return;
            }
            if (teamId && campaignId && days && kms) {
                if (confirm("Er du helt sikker på, du vil taste samlet? Alle deltagere på holdet får overskrevet deres cykeldage og km for kampagnen (og får i stedet tilskrevet deres del af de data, du har indtastet). Den samlede indtastning kan ikke fortrydes.")) {
                    form.querySelector("input[type='submit']").disabled = true;
                    let combined = {
                        "TeamId": teamId,
                        "CampaignId": campaignId,
                        "Days": days,
                        "KMs": kms
                    };
                    toAPI("combinedDayKMs", function (data) {
                        if (data.result == 3) {
                            addBrief("Data er IKKE gemt, der er indtastet for mange cykeldage eller km i forhold til kampagnens længde og antallet af deltagere på dit hold.");
                        } else if (data.result == 2) {
                            addBrief("Data er IKKE gemt, de er ikke gyldige.");
                        } else {
                            if (reloadOK()) document.location.reload();
                        }
                    }, combined);
                }
            }
        });
    }

    maintainHeight(teamsEl, true);

    addEvents("#teams select[name='campaign']", "change", function (e) {
        let campaignSelect = e.target;
        let campaign = campaignById(campaignSelect.value);
        if (campaign) {
            let form = campaignSelect.closest(".team");
            let sizeEl = form.querySelector("select[name='size']");
            let groupEl = form.querySelector("select[name='group']");
            let companyEl = form.querySelector("input[name='company']");
            let groupLabel = document.getElementById("createGroupLabel");
            let workplaceLabel = document.getElementById("createWorkplaceLabel");

            let notInGroupText = localText("General.NotInGroup", false, campaign.campaignConfigId);
            let groupLabelText = localText("General.WorkplaceGroupLabel", false, campaign.campaignConfigId);
            let workplaceLabelText = localText("General.Workplace", false, campaign.campaignConfigId);
            let workplacePlaceholderText = localText("General.Workplace", false, campaign.campaignConfigId);

            groupLabel.innerHTML = groupLabelText;
            workplaceLabel.innerHTML = workplaceLabelText;

            addEvents("#createGroupLabel a", "click", function (e) {
                let span = e.target.querySelector("span");
                if (span) {
                    addOverlayMessage(e.target.querySelector("span").innerHTML);
                    stopAll(e);
                }
            });

            let selectedGroupId = campaign.groups && campaign.groups.length === 1 ? campaign.groups[0].id : "";

            let groupOptions = "";

            if (!selectedGroupId) groupOptions += '<option value="" disabled selected>' + localText("General.Choose") + '...</option>';
            if (campaign.hasDefaultGroup) groupOptions += '<option value="1">' + notInGroupText + '</option>';

            forEach(campaign.groups, function (g) {
                groupOptions += '<option value="' + g.id + '">' + g.name + '</option>';
            });

            groupEl.innerHTML = groupOptions;

            if (campaign.campaignConfigId != 1) companyEl.setAttribute("list", "companies" + campaign.id);
            companyEl.setAttribute("placeholder", workplacePlaceholderText);

            sizeEl.innerHTML = getSizeHTML(campaign);
            if (selectedGroupId) {
                groupEl.value = selectedGroupId;
                addClass(groupEl.closest("div"), "hidden");
            } else {
                removeClass(groupEl.closest("div"), "hidden");
            }
        }
    });

    addEvents("label a", "click", function (e) {
        let span = e.target.querySelector("span");
        if (span) {
            addOverlayMessage(e.target.querySelector("span").innerHTML);
            stopAll(e);
        }
    });

    let triggerSel = document.querySelector("#teams select[name='campaign']");
    if (triggerSel) triggerSel.dispatchEvent(new Event("change"));

    addEvents("#teams input[name='zip']", "input", function (e) {
        let z = e.target;
        let k = z.closest(".team").querySelector("select[name='municipality']");
        addClass(z, "changed");
        let muni = apiData.municipalities[z.value];
        if (!muni) {
            addClass(z, "error");
        } else {
            removeClass(z, "error");
        }
        k.innerHTML = municipalityOptions(z.value, muni && muni.length === 1 ? muni[0][0] : undefined);
    });


    addEvents("#teams input[name='email']", "input", function (e) {
        let el = e.target;
        let v = el.value;
        if (v === el.getAttribute("data-value")) {
            removeClass(el, "error");
            removeClass(el, "changed");
            return;
        }
        e.target.closest(".team").querySelector("input[type='submit']").disabled = false;
        addClass(el, "changed");
        if (v === '' || isValidEmail(v)) {
            removeClass(el, "error");
            updateCaptain(e.target.closest("form"));
        } else {
            addClass(el, "error");
        }
    });

    addEvents("#teams input", "input", function (e) {
        if (e.target.type && e.target.type !== "submit") {
            let team = e.target.closest(".team");
            addClass(team, "changed");
            team.querySelector("input[type='submit']").disabled = false;
        }
    });

    addEvents("#teams select", "change", function (e) {
        if (e.target.type && e.target.type !== "submit") {
            let team = e.target.closest(".team");
            addClass(team, "changed");
            let submit = team.querySelector("input[type='submit']");
            submit.disabled = false;
            if (!e.target.closest("form").classList.contains("create") && e.target.name === "size") submit.click();
        }
    });

    addEvents("#teams select[name='size']", "change", function (e) {
        let team = e.target.closest(".team");
        let visible = e.target.value;
        let i = 0;
        forEach(team.querySelectorAll(".members div"), function (el) {
            i++;
            if (i <= visible) {
                removeClass(el, "hidden");
            } else {
                addClass(el, "hidden");
            }
        });
    });

    addEvents("#teams .copy input", "click", (e) => {
        stopAll(e);
        let el = e.target;
        el.select();
        el.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(el.value);
        el.selectionStart = el.selectionEnd;
        el.blur();
        addBrief(`'${el.value}' blev kopieret til dit clipboard/ udklipsholder.`);
    });

    function getBaseProfile() {
        return {
            "name": apiData.profile.name,
            "email": apiData.profile.email,
            "teams": [],
            "onTeams": []
        };
    }

    addEvents("#teams .delete", "click", function (e) {
        stopAll(e);
        if (confirm("Er du sikker, du kan ikke fortryde bagefter? (men du kan altid lave et nyt hold)")) {
            let team = e.target.closest(".team");
            let teamId = parseInt(team.getAttribute("data-id"));
            let profile = getBaseProfile();
            let match = first(apiData.teams, teamId, "id");
            if (match) profile.teams.push(match);
            if (match) {
                forEach(match.teamParticipants, function (el) {
                    el.changed = true;
                    el.email = "";
                });
                match.delete = true;
                match.changed = true;
                toAPI("teams", function (data) {
                    apiData["profile"] = data;
                    apiData.teams = data.teams;
                    apiData.onTeams = data.onTeams;
                    addBrief("Holdet er slettet.", data);
                    refreshParticipantBaseData();
                    drawTeams();
                }, profile, false, undefined, "Delete");
            } else {
                addOverlayMessage("Vi kan ikke finde holdet du prøver at slette.");
            }
        }
    });

    addEvents("#teams form.team", "submit", function (e) {
        e.preventDefault();
        let team = e.target.closest(".team");
        e.target.disabled = true;
        let teamId = parseInt(team.getAttribute("data-id"));
        if (teamId) {
            let messages = validateTeam(team);
            if (messages.length) {
                showApiMessages(messages);
            } else {
                let profile = getBaseProfile();
                let match = first(apiData.teams, teamId, "id");
                if (match) profile.teams.push(match);
                if (!match) {
                    match = first(apiData.onTeams, teamId, "id");
                    if (match) profile.onTeams.push(match);
                }
                if (match) {
                    match.name = team.querySelector("input[name='name']").value;
                    match.seats = parseInt(team.querySelector("select[name='size']").value);
                    match.company = team.querySelector("input[name='company']").value;
                    match.groupId = parseInt(team.querySelector("select[name='group']").value);
                    match.municipalityId = parseInt(team.querySelector("select[name='municipality']").value);
                    match.changed = true;
                    match.teamParticipants = [];
                    let additions = [];

                    let ccId = team.dataset.campaignconfigid;
                    let captainSelect = team.querySelector("select[name='captain']");
                    let captain = captainSelect.value;
                    if (ccId != "1") {
                        let oldCaptain = captainSelect.getAttribute("data-value");
                        if (captain && captain !== oldCaptain) additions.push(captain);
                    } else {
                        captain = undefined;
                    }

                    let deletions = [];
                    let inputs = team.querySelectorAll("input[name='email']");
                    forEach(inputs, function (el) {
                        if (hasClass(el.parentNode, "hidden")) {
                            let dv = el.getAttribute("data-value");
                            if (isValidEmail(dv)) deletions.push(dv);
                        } else {
                            if (hasClass(el, "changed")) {
                                let v = el.value;
                                let dv = el.getAttribute("data-value");
                                if (v === '' && isValidEmail(dv)) {
                                    deletions.push(el.getAttribute("data-value"));
                                } else {
                                    if (v !== '' && isValidEmail(v)) additions.push(v);
                                    if (isValidEmail(dv)) {
                                        deletions.push(dv);
                                    }
                                }
                            }
                        }
                    });
                    additions = unique(additions);
                    deletions = unique(deletions);

                    let ignoredAdditions = [];
                    let filteredAdditions = [];
                    let filteredDeletions = [];

                    forEach(deletions, function (el) {
                        if (additions.indexOf(el) < 0) {
                            filteredDeletions.push(el);
                        } else {
                            ignoredAdditions.push(el);
                        }
                    });

                    forEach(additions, function (el) {
                        if (filteredDeletions.indexOf(el) < 0 && ignoredAdditions.indexOf(el) < 0) filteredAdditions.push(el);
                    });

                    forEach(filteredAdditions, function (el) {
                        let participant = {
                            "teamId": teamId,
                            "email": el,
                            "changed": true
                        };
                        if (participant.email === captain) {
                            participant.status = 3;
                            participant.isCaptain = true;
                        }
                        match.teamParticipants.push(participant);
                    });
                    forEach(filteredDeletions, function (el) {
                        let participant = {
                            "teamId": teamId,
                            "email": el,
                            "changed": true,
                            "status": -1
                        };
                        match.teamParticipants.push(participant);
                    });

                    toAPI("teams", function (data) {
                        apiData["profile"] = data;
                        apiData.teams = data.teams;
                        apiData.onTeams = data.onTeams;
                        addBrief("Holdet er gemt.", data);
                        refreshParticipantBaseData();
                        drawTeams(teamId);
                    }, profile, false, undefined, "Update");
                }
            }
        } else {
            let messages = validateTeam(team);
            if (messages.length) {
                showApiMessages(messages);
            } else {
                let profile = getBaseProfile();
                profile.teams = [
                    {
                        "CampaignId": parseInt(team.querySelector("select[name='campaign']").value),
                        "Name": team.querySelector("input[name='name']").value,
                        "Seats": parseInt(team.querySelector("select[name='size']").value),
                        "TeamParticipants": [],
                        "Company": team.querySelector("input[name='company']").value,
                        "GroupId": parseInt(team.querySelector("select[name='group']").value),
                        "MunicipalityId": parseInt(team.querySelector("select[name='municipality']").value),
                        "Changed": true
                    }
                ];
                toAPI("teams", function (data) {
                    apiData["profile"] = data;
                    apiData.teams = data.teams;
                    apiData.onTeams = data.onTeams;
                    addBrief("Holdet er oprettet.", data);
                    refreshParticipantBaseData();
                    drawTeams(objectLargestPropertyValue(apiData.teams, "id"));
                }, profile, false, undefined, "Create");
            }
        }
    });

    addEvents("a.highlight", "click", function (e) {
        stopAll(e);
        let el = e.target;
        let targetName = el.getAttribute("data-highlight");
        let form = el.closest("form");
        let target = form.querySelector("[name='" + targetName + "']");
        highlightElement(target);
    });

    activateToggles();
    if (document.getElementById("teamIntro") && !document.getElementById("teamIntro").hasAttribute("data-active")) {
        document.getElementById("teamIntro").setAttribute("data-active", "1");
    }

    initForms();

    //    let togglers = teamsEl.querySelectorAll("#teams h3.toggler");
    //    if (togglers && togglers.length > 0 && togglers.length < 2) togglers[0].click();
}

function getFuncName() {
    return getFuncName.caller.name
}

function validateTeam(team) {
    const messages = [];
    let campaign = campaignById(team.dataset.campaignid);
    let groupValue = team.querySelector("select[name='group']").value;
    let companyValue = team.querySelector("input[name='company']").value;
    let isCreate = !parseInt(team.getAttribute("data-id"));
    if (isCreate) {
        let selectedCampaign = team.querySelector("select[name='campaign']").value;
        if (!isInt(selectedCampaign)) {
            messages.push("Der skal vælges en kampagne.");
        } else {
            campaign = campaignById(selectedCampaign);
        }

        if (groupValue === "1" && team.getAttribute("data-groupalert") !== "1") {
            team.setAttribute("data-groupalert", "1");
            let cvLC = companyValue.toLowerCase().replace(" a/s", "").replace(" aps");
            let m = "";
            let count = 0;
            if (campaign.groups) {
                campaign.groups.forEach(function (g) {
                    if (g.name.toLowerCase().indexOf(cvLC) >= 0) {
                        m += g.name + "?<br />";
                        count++;
                    }
                });
            }
            if (count > 0) {
                m = "<p>Er din " + localText("General.Workplace", false, campaign.campaignConfigId) + " en del af" + (count > 1 ? " en af følgende " + localText("General.WorkplaceGroup", false, campaign.campaignConfigId) + "r:<br />" : " ") + m + "Så vælg " + localText("General.WorkplaceGroup", false, campaign.campaignConfigId) + " i listen efter du har trykket ok, så kan vi lave den bedst mulige statistik til jer!</p><p>Hvis ikke, så bare tryk Opret hold igen</p>";
                messages.push(m);
            }
        }
    } else {
        if (!parseInt(team.getAttribute("data-campaignid"))) messages.push("Holdet du gemmer er ikke tilknyttet en kampagne.");
        let captainSelector = team.querySelector("select[name='captain']");
        if (campaignConfigId != 1 && captainSelector.querySelectorAll("option").length > 0 && (campaign.public && isNullOrWhiteSpace(captainSelector.value))) messages.push("Du skal vælge en kaptajn for holdet.");
    }

    let notInGroup = localText("General.NotInGroup", false, campaign.campaignConfigId);

    if (isNullOrWhiteSpace(team.querySelector("input[name='name']").value)) messages.push("Holdnavn skal udfyldes.");
    if (!isInt(team.querySelector("select[name='size']").value)) messages.push("Der skal vælges en holdstørrelse.");
    if (!isInt(groupValue)) messages.push('Der skal vælges en om din ' + localText("General.Workplace", false, campaign.campaignConfigId) + ' er en del af en større ' + localText("General.WorkplaceGroup", false, campaign.campaignConfigId) + ', hvis din ' + localText("General.Workplace", false, campaign.campaignConfigId) + ' ikke er del af en ' + localText("General.Workplace", false, campaign.campaignConfigId) + ' i listen, vælg "' + notInGroup + '".');
    if (isNullOrWhiteSpace(companyValue)) messages.push(localText("General.Workplace", false, campaign.campaignConfigId) + " skal udfyldes.");
    if (!isInt(team.querySelector("select[name='municipality']").value)) messages.push("Der skal vælges en kommune, indtast postnummer og vælg kommune.");

    if (!isCreate) {
        forEach(team.querySelectorAll("input[name='email']"), function (el) {
            let v = el.value;
            if (v !== '' && !isValidEmail(v)) messages.push(v + " er ikke en gyldig email.");
        });
    }
    return messages;
}

function drawTeam(team, asOwner, heading, col, openTeamId) {
    let teamsEl = document.getElementById("teams");
    let campaign = campaignById(team.campaignId);
    let selectedGroup = campaign.groups && campaign.groups.length === 1 ? campaign.groups[0].id : "";

    let ccId = campaign.campaignConfigId;

    let notInGroup = localText("General.NotInGroup", false, ccId);
    let groupLabel = localText("General.WorkplaceGroupLabel", false, ccId);

    let groupSelect = '<select title="Group" name="group" class="group" data-id="' + team.groupId + '" required>';

    if (!team.groupId) groupSelect += '<option value="" disabled selected>' + localText("General.Choose") + '...</option>';
    if (campaign.hasDefaultGroup) groupSelect += '<option value="1">' + notInGroup + '</option>';

    forEach(campaign.groups, function (g) {
        groupSelect += '<option value="' + g.id + '"' + (g.id == team.groupId ? ' selected' : '') + '>' + g.name + '</option>';
    });

    groupSelect += '</select>';

    let workplaceValue = '';
    if (campaign.workplacesAsDropdown && campaign.workplaces && campaign.workplaces.length == 1) {
        workplaceValue = campaign.workplaces[0];
    }

    let teamCodeLink = team.code ? `${selves[ccId]}/${team.code}` : "";

    let s = (heading ? heading : '') + '<div class="team" data-id="' + team.id + '">' +
        '<h3 class="toggler' + (openTeamId == team.id ? "" : " off") + (col ? ' col' + col : '') + '">' + escapeHTML(team.name) + (campaign.campaignConfigId != 1 ? ' (' + team.seats + ' ' + localText("General.Seats", true, undefined, undefined, team.seats) + ')' : '') + '</h3><div>' +
        (asOwner ? '' : '<p class="small">Hvis du har behov for flere pladser på holdet, så kontakt din holdejer ' + team.ownerEmail + '</p>') +
        (ccId != 1 ? '<div class="resendInvitation"></div>' : '') +
        '<form autocomplete="off" class="cf team" data-eventextra="Edit" data-id="' + team.id + '" data-campaignid="' + team.campaignId + '" data-campaignconfigid="' + ccId + '">' +
        '<p class="highlight toggler off' + (col ? ' col' + col : '') + '">' + localText("Profile.EditTeam") + '</p><div>' +
        (asOwner ? '<label class="small" style="text-align: right;"><a href="#" class="danger delete">' + localText("Profile.DeleteTeam") + '</a></label>' : '') +
        '<label>' + localText("General.TeamName") + '</label><input placeholder="' + localText("General.TeamName") + '" name="name" value="' + team.name + '" required />' +
        '<label>' + localText("General.Workplace", false, ccId) + '</label><input placeholder="' + localText("General.Workplace") + '" name="company" ' + (ccId != 1 ? 'list="companies' + campaign.id + '"' : '') + ' value="' + team.company + '" required ' + (workplaceValue == team.company ? 'disabled ' : '') + '/>' +
        '<div' + (selectedGroup ? ' class="hidden"' : '') + '><label>' + groupLabel + '</label>' + groupSelect + '</div>' +
        '<label>' + localText("Profile.Postcode") + '</label><input list="allzips" placeholder="' + localText("Profile.Postcode") + '" name="zip" data-id="' + team.municipalityId + '" value="' + (team.municipality ? team.municipality.zip : '') + '" required />' +
        '<label>' + localText("Profile.Municipality") + '</label><select title="Municipality" name="municipality" data-id="' + team.municipalityId + '" data-zip="' + (team.municipality ? team.municipality.zip : '') + '" required>' + (team.municipality ? municipalityOptions(team.municipality.zip, team.municipalityId) : '') + '</select>' +
        (ccId != 1 ? '</div>' : '') +
        (asOwner ? '<label>' + localText("General.TeamSize", false, ccId) + '</label><select title="Size" name="size">' + getSizeHTML(campaign, team.id) + '</select>' : '<select title="Size" name="size" class="hidden"><option selected>' + team.seats + '</option></select>') +
        (ccId == 1 ? '</div>' : '') +
        (ccId == 1 && teamCodeLink ? `<h4>${localText("Teams.InviteHeading", false, ccId)}</h4><p>${localText("Teams.InviteText", false, ccId)}<br /><span class="copy"><input type="text" value="${teamCodeLink}" readonly /></p>` : "");

    if (ccId != 1) {
        s += `<h4>${localText("Teams.InviteHeading", false, ccId)}</h4><p>${localText("Teams.InviteText", false, ccId)}</p>` + '<div class="members co c3"></div>' +
            getSizeHelp(campaign, team.id) +
            '<label>' + localText("General.TeamCaptain") + '</label><select title="Captain" name="captain"></select>';
    } else if (team.teamParticipants && team.teamParticipants.length > 0) {
        s += '<p class="toggler off">Slet deltager</p><div class="membertoggle cc1">' +
            '<p>Klik på en deltager for at fjerne den fra holdet.<br>Husk at gemme holdet bagefter.</p>' +
            getSizeHelp(campaign, team.id) +
            '<div class="members co c3"></div>' +
            '<select title="Captain" name="captain"></select></div>';
    } else {
        s += getSizeHelp(campaign, team.id) +
            '<div class="hidden"><div class="members co c3"></div><select title="Captain" name="captain"></select></div>';
    }

    s += '<input type="submit" value="' + localText("General.Save") + ' ' + localText("General.Team", true) + '" disabled></div></form></div>';
    teamsEl.insertAdjacentHTML('beforeend', s);
    forEach(teamsEl.querySelectorAll("label a"), function (el) {
        el.addEventListener("click", function (e) {
            let span = e.target.querySelector("span");
            if (span) {
                addOverlayMessage(span.innerHTML);
                stopAll(e);
            }
        });
    });

    let captainOptions = "";
    let memberInputs = "";
    let teamEl = teamsEl.querySelector("div.team:last-child");
    let captainSelect = teamEl.querySelector("select[name='captain']");
    let j = 0;
    let resendInvitation = "";
    if (!campaign.public || ccId == 1) captainOptions += '<option value="" selected>Ingen kaptajn valgt</option>';
    forEach(team.teamParticipants, function (el) {
        j++;
        if (ccId != 1) {
            memberInputs += '<div class="c s' + el.status + '"><input type="email" list="autocompleteoff" autocomplete="off' + j + '" name="email" placeholder="email" value="' + el.email + '" data-value="' + el.email + '" /></div>';
        } else {
            memberInputs += '<div class="c cl"><input type="email" list="autocompleteoff" autocomplete="off' + j + '" name="email" value="' + el.email + '" data-value="' + el.email + '" />' + el.email + '</div>';
        }
        if (el.status === 1) {
            resendInvitation += '<option>' + el.email + '</option>'
        }
        if (ccId != 1) {
            captainOptions += '<option' + (el.isCaptain ? ' selected' : '') + '>' + el.email + '</option>';
            if (el.isCaptain) {
                captainSelect.setAttribute("data-value", el.email);
                hasCaptain = true;
            }
        }
    });
    if (resendInvitation !== '') {
        let resendEl = teamEl.querySelector(".resendInvitation");
        if (resendEl) {
            resendInvitation = '<p class="toggler off' + (col ? ' col' + col : '') + '">Gensend invitationer</p><div><p>Vælg den du vil sende til, en ad gangen</p><form class="cf simpleToAPI" data-method="resendInvitation"><label for="email">Modtager</label><select title="Email" name="email">' +
                resendInvitation +
                '</select><input type="hidden" data-type="int" name="teamId" value="' + team.id + '" />' +
                '<div class="result" data-status="1">Invitationen er sendt.</div>' +
                '<div class="result" data-status="0">' + genericError + '</div>' +
                '<input type="submit" value="Send" /></form></div>'
            resendEl.innerHTML = resendInvitation;
        }
    }
    if (ccId != 1) {
        for (let i = 0; i < team.seats - (team.teamParticipants ? team.teamParticipants.length : 0); i++) {
            j++;
            memberInputs += '<div class="c"><input list="autocompleteoff" autocomplete="off' + j + '" name="email" placeholder="email" /></div>';
        }
    }
    let membersEl = teamEl.querySelector(".members");
    captainSelect.innerHTML = captainOptions;
    // if (captainOptions) {
    //     captainSelect.classList.remove("hidden");
    //     captainSelect.previousElementSibling.classList.remove("hidden");
    // } else {
    //     captainSelect.classList.add("hidden");
    //     captainSelect.previousElementSibling.classList.add("hidden");
    // }
    membersEl.innerHTML = memberInputs;
    membersEl.querySelectorAll(".c.cl").forEach((el) => {
        el.addEventListener("click", (e) => {
            let inp = e.target.querySelector("input");
            inp.value = '';
            inp.dispatchEvent(new Event("input"));
            e.target.classList.add("hidden");
            e.target.classList.remove("cl");
        });
    });
}

function showCalendar(data, date) {
    if (!data) data = [];
    let bikedays = document.getElementById("bikedays");

    if (!date) date = jsToday;
    let dates = {};
    dates.today = jsToday.isoDate();
    dates.startDate = isoDate(apiData.profile.startDataEntry);
    dates.endDate = isoDate(apiData.profile.endDataEntry);
    if (dates.endDate > dates.today) dates.endDate = dates.today;
    dates.date = isoDate(date);
    dates.latest = dates.date > dates.endDate ? dates.endDate : dates.date;
    dates.year = dates.latest.isoDatePart("y");
    dates.month = dates.latest.isoDatePart("m");
    dates.startDay = apiData.profile.startDataEntry.getDay();
    dates.dim = daysInMonth(dates.month, dates.year);
    dates.months = monthsTotal(dates.startDate, dates.endDate);

    let s = `<form autocomplete="off" class="cf"><div class="sidescroll ss${dates.months}" data-months="${dates.months}">`;

    let showPlay = false;
    forEach(apiData.profile.campaigns, function (c) {
        if (c.hasPlay) showPlay = true;
    });

    let m = dates.latest.substring(0, 8) + "01";
    let sym = dates.startDate.isoDatePart("ym");
    let eym = dates.endDate.isoDatePart("ym");
    let lym = dates.latest.isoDatePart("ym");
    let showMonth = bikedays.dataset.showmonth ? bikedays.dataset.showmonth : 1;
    let drawMonth = 1;

    while (m >= sym) {
        let ym = m.isoDatePart("ym");
        s += "<div class=\"ssm" + (drawMonth == showMonth ? "" : " hidden") + "\"><div class=\"calendarMonth" + (dates.months === 1 ? " single" : "") + "\"><a class=\"prev" + (ym > sym ? "" : " dim") +
            "\"></a><span>" + months[1 * m.isoDatePart("m")] + " " + m.isoDatePart("y") + "</span><a class=\"next" + (ym < eym ? "" : " dim") +
            "\"></a></div><ul><li class=\"day\">Mandag</li><li class=\"day\">Tirsdag</li><li class=\"day\">Onsdag</li><li class=\"day\">Torsdag</li><li class=\"day\">Fredag</li><li class=\"day\">Lørdag</li><li class=\"day\">Søndag</li>";

        let dow = m.toDate().getDay();
        for (let i = 1; i < dow; i++) {
            s += "<li class=\"dim\"></li>";
        }
        let daysInMonth = m.daysInMonth();
        let firstDay = sym == ym ? dates.startDate.isoDatePart("d") : 1;
        let lastDay = lym == ym ? dates.endDate.isoDatePart("d") : daysInMonth;
        for (let i = 1; i <= daysInMonth; i++) {
            let inputDate = ym + "-" + String(i).padStart(2, "0");
            let v = data[inputDate] && data[inputDate].distance > 0 ? toComma(data[inputDate].distance) : "";
            let pv = showPlay ? data[inputDate] && data[inputDate].playDistance > 0 ? toComma(data[inputDate].playDistance) : "" : "";
            if (i >= firstDay && i <= lastDay) {
                s += '<li class="y' + inputDate + '"><span>' + i +
                    ".</span><label>KM cyklet</label><input placeholder=\"km\" maxlength=\"6\" type=\"text\" class=\"d " + (inputDate === dates.date ? " now" : "") + "\" data-date=\"" + inputDate + "\" value=\"" + v + "\" data-old=\"" + v + "\" />" +
                    (showPlay ? "<label>Fritids KM cyklet</label><input placeholder=\"fritid\" maxlength=\"6\" type=\"text\" class=\"pd " + (inputDate === dates.date ? " now" : "") + "\" data-date=\"" + inputDate + "\" value=\"" + pv + "\" data-old=\"" + pv + "\" />" : "") +
                    "</li>";
            } else {
                s += "<li></li>";
            }
        }

        let padCells = 35 - daysInMonth - (dow - 1);
        if (padCells < 0) padCells += 7;
        if (padCells > 6) padCells = -1;

        for (let i = 0; i < padCells; i++) {
            s += "<li class=\"dim\"></li>";
        }

        s += "</ul></div>";
        m = m.isoAddDatePart("m", -1);
        if (drawMonth == showMonth) bikedays.dataset.showmonth = drawMonth;
        drawMonth++;
    }
    s += `</div><input id="savebikedays" class="button" type="button" value="${localText("Profile.SaveBikeDays")}" /></form>`;

    let options = '';
    let optionDate = dates.startDate;
    while (optionDate <= dates.latest) {
        let optionText = optionDate.toDate().toLocaleDateString("da-DK", {weekday: "long", month: "long", day: "numeric"});
        options = '<option value="y' + optionDate + '"' + (optionDate === dates.date || ((!dates.date || dates.date > dates.latest) && optionDate === dates.latest) ? " selected" : "") + '>' +
            (optionDate === dates.today ? "I dag " + optionText : optionText.charAt(0).toUpperCase() + optionText.slice(1)) +
            '</option>' + options;
        optionDate = optionDate.isoAddDatePart("d");
    }

    s = '<div class="cf"><select title="Day" name="day">' + options + '</select></div>' + s;
    bikedays.querySelector(".calendar").innerHTML = s;

    setSelectKM();

    removeClass(bikedays.closest(".r"), "hidden");

    let day = bikedays.querySelector("select[name=day]");
    addEvent(day, "change", function (e) {
        let val = e.target.value;
        document.querySelectorAll(".calendar li.visible").forEach((li) => {
            removeClass(li, "visible");
        });
        let li = document.querySelector("li." + val);
        if (li) addClass(li, "visible");
    });
    addClass(bikedays.querySelector(".calendar li." + day.value), "visible");

    addEvents("#bikedays .calendarMonth a:not(.dim)", "click", function (e) {
        e.target.classList.contains("prev") ? bikedays.dataset.showmonth++ : bikedays.dataset.showmonth--;
        let showMonth = bikedays.dataset.showmonth - 1;
        bikedays.querySelectorAll(".ssm").forEach((el, i) => {
            i == showMonth ? el.classList.remove("hidden") : el.classList.add("hidden");
        });
    });

    addEvents("#bikedays input[type=text]", "keyup", function (e) {
        let i = e.target;
        let v = i.value;
        let o = i.dataset.old;
        let n = 0;
        let isPlay = hasClass(i, "pd");
        if (v !== '') {
            n = toPoint(v);
            if (!validNumber.test(v) || n < 0 || (n > 300 && !isPlay) || (n > 999 && isPlay)) {
                addClass(i, "error");
            } else {
                removeClass(i, "error");
            }
        } else {
            removeClass(i, "error");
        }
        if (v !== o) {
            let savebikedays = document.getElementById("savebikedays");
            if (savebikedays.disabled) {
                addClass(i.closest("form"), "changed");
                unsavedChanges++;
                savebikedays.disabled = false;
            }
            addClass(i, "changed");
        } else {
            removeClass(i, "changed");
        }
        if (e.keyCode === 13) {
            saveCalendar();
        }
    });

    addEvents("#bikedays input[type=text]", "blur", function (e) {
        let i = e.target;
        let v = i.value;
        if (validNumber.test(v)) i.value = toComma(toPoint(v));
    });

    bikedays.querySelector(".calendar form").addEventListener("submit", function (e) {
        stopAll(e);
    });

    addEvent("#savebikedays", "click", function (e) {
        saveCalendar();
    });
}

function isNextDay(d1, d2) {
    let hours = (d2 - d1) / 3600000;
    return hours > 20 && hours < 30;
}

function daysDiff(d1, d2) {
    if (typeof d1 === "string") d1 = new Date(d1);
    if (typeof d2 === "string") d2 = new Date(d2);

    return Math.round((d1.getTime() - d2.getTime()) / 86400000);
}

function daysDuration(d1, d2) {
    if (typeof d1 === "string") d1 = new Date(d1);
    if (typeof d2 === "string") d2 = new Date(d2);

    return Math.round(Math.abs(d1.getTime() - d2.getTime()) / 86400000) + 1;
}

function selectElement(elements, property, value) {
    for (let i = 0; i < elements.length; i++) {
        if (elements[i][property] === value) {
            return elements[i];
        }
    }
    return null;
}

function saveCalendar(callback) {
    let errorInputs = document.querySelector("#bikedays").querySelector("input.error");
    if (errorInputs) {
        showApiError(localText("Profile.SaveBikeDaysError"));
        return false;
    }

    let changedDays = {};
    let hasChanges = false;
    let inputDays = {};
    let inputPlayDays = {};
    let dates = {};
    document.querySelector("#bikedays").querySelectorAll("input.d").forEach((d) => {
        let date = d.dataset.date;
        inputDays[date] = d;
        if (!dates[date]) dates[date] = true;
    });
    document.querySelector("#bikedays").querySelectorAll("input.pd").forEach((pd) => {
        let date = pd.dataset.date;
        inputPlayDays[date] = pd;
        if (!dates[date]) dates[date] = true;
    });
    let apiDays = apiData.profile.days;

    for (let date in dates) {
        if (dates.hasOwnProperty(date)) {
            let apiDay = apiDays[date];
            let d = toPoint(inputDays[date]?.value ?? 0);
            let pd = toPoint(inputPlayDays[date]?.value ?? 0);

            if (!apiDay && d > 0 || pd > 0) {
                hasChanges = true;
                changedDays[date] = {"changed": true, "distance": d, "playdistance": pd, "date": date};
            } else if (apiDay && (toPoint(apiDay.distance) != d || toPoint(apiDay.playdistance) != pd)) {
                hasChanges = true;
                changedDays[date] = {"changed": true, "distance": d, "playdistance": pd, "date": date};
            }
        }
    }

    if (hasChanges) {
        document.getElementById("savebikedays").disabled = true;
        toAPI("days", function (data) {
            forEach("#bikedays input.changed:not(.error)", function (el) {
                el.setAttribute("data-old", el.value);
                removeClass(el, "changed");
            });
            removeClass(document.getElementById("savebikedays").closest("form"), "changed");
            if (unsavedChanges > 0) unsavedChanges--;
            apiData.days = data.days;
            apiData.profile.days = data.days;
            apiData.profile.teamStats = data.teamStats;
            apiData.profile.teamData = data.teamData;
            addBrief("Dine cykeldage er gemt.", data);

            setSelectKM()

            if (callback) callback();

            updateTrophies();
        }, changedDays);
    } else {
        if (!document.getElementById("savebikedays").disabled) unsavedChanges--;
        if (callback) callback();
    }
}

function setSelectKM() {
    let options = document.querySelectorAll("#bikedays select option");
    options.forEach(o => {
        let optionDate = o.value.split('y').pop();
        if (optionDate && optionDate.length == 10) {
            let d = apiData.days[optionDate]?.distance;
            let pd = apiData.days[optionDate]?.playDistance;
            let dText = d ? ` (${d}/${pd ? pd : 0} km)` : pd ? ` (0/${pd} km)` : "";
            o.innerHTML = o.innerHTML.split('(')[0] + dText;
        }
    });
}

function updateTrophies(callback) {
    forEach(apiData.profile.campaigns, function (c) {
        c.endDate = parsedDate(c.endDataEntry);
        c.startDate = parsedDate(c.startDataEntry);
        c.trophyVars = [0, 0, 0, 0, 0, 0,
            new Date(2000, 0), 0, 0, 0, 0,
            0, 0, 0, 0, 0,
            0, 0, 0];
    });
    if (apiData.days) {
        Object.keys(apiData.days).forEach(function (key, index) {
            let date = parsedDate(key);
            let dist = apiData.days[key].distance;
            let pdist = apiData.days[key].playDistance;
            forEach(apiData.profile.campaigns, function (c) {
                let currentDist = dist + (c.includePlayInTrophyCalculations ? pdist : 0);
                if (!c.trophiesDisabled && date >= c.startDate && date <= c.endDate && currentDist > 0) {
                    c.trophyVars[0] = 1;

                    // consecutive days
                    if (c.trophyVars[5] < 4) {
                        isNextDay(c.trophyVars[6], date) ? c.trophyVars[5]++ : c.trophyVars[5] = 0;
                        c.trophyVars[6] = date;
                    }
                    if (currentDist >= 25) c.trophyVars[3] = 1;
                    if (currentDist >= 40) c.trophyVars[9] = 1;

                    // total days
                    c.trophyVars[7]++;
                }
            });
        });
    }

    let newTrophies = [];
    forEach(apiData.profile.campaigns, function (c) {
        if (!c.trophiesDisabled) {
            //let days = daysDuration(c.startDate, c.endDate);
            //if (c.trophyVars[7] / days >= beyondQualifier) {
            //    c.trophyVars[4] = 1;
            //}
            if (c.trophyVars[7] >= 7) c.trophyVars[16] = 1;

            if (c.trophyVars[5] >= 4) c.trophyVars[1] = 1;

            let td = apiData.profile.teamData;
            if (c.trophyVars[0] === 1 && td && td.length > 0) {
                let all = true;
                let ps = undefined;
                for (let i = 0; i < td.length; i++) {
                    if (td[i].ci === c.id) {
                        ps = td[i].ps;
                        break;
                    }
                }
                if (ps && ps.length >= 2) {
                    for (let i = 0; i < ps.length; i++) {
                        if (ps[i].d === 0 && ps[i].tr.indexOf(1) < 0) {
                            all = false;
                            break;
                        }
                    }
                }
                if (all) c.trophyVars[2] = 1;
            }

            let enabledTrophies = c.enabledTrophies ? "," + c.enabledTrophies.replace(/\s/g, '') + "," : "";

            // ret til trofæer - active
            // automatic trophies have no confirm text
            passiveTrophies.forEach(typeId => {
                // trophyVars index is 0, typeId index is 1
                let i = typeId - 1;
                if (c.trophyVars[i] === 1 && newTrophy(c.id, typeId)) {
                    if (enabledTrophies === "" || enabledTrophies.includes("," + typeId + ",")) {
                        newTrophies.push({
                            "TypeId": typeId,
                            "CampaignId": c.id,
                            "Action": 1
                        });
                    }
                } else if (c.trophyVars[i] === 0 && !newTrophy(c.id, typeId)) {
                    newTrophies.push({
                        "TypeId": typeId,
                        "CampaignId": c.id,
                        "Action": -1
                    });
                }
            });
        }
    });
    if (newTrophies.length > 0) {
        saveTrophies(newTrophies, callback);
    } else {
        if (callback) callback();
        drawTeamData();
    }
}

function saveTrophies(newTrophies, callback) {
    toAPI("trophies", function (trophyData) {
        let totalTrophies = [];
        let removedTrophies = [];
        forEach(trophyData, function (t) {
            let el = document.querySelector("#teamdata [data-id='tr-" + t.campaignId + "-" + t.typeId + "']");
            let elt = document.querySelector("#teamdata [data-id='ttr-" + t.campaignId + "-" + t.typeId + "']");
            if (t.action === 1) {
                totalTrophies.push(t);
                if (el) removeClass(el, "grey");
                if (elt) removeClass(elt, "grey");
            } else if (t.action === -1) {
                removedTrophies.push(t.campaignId + "-" + t.typeId);
                if (el) addClass(el, "grey");
                if (elt) addClass(elt, "grey");
            }
        });
        let callUpdate = totalTrophies.length > 0 || removedTrophies.length > 0;
        if (totalTrophies.length > 0) {
            let s = '<p>TILLYKKE!<br />Du har fået nye trofæer:<br />';
            let addedTypes = [];
            forEach(totalTrophies, function (t) {
                if (addedTypes.indexOf(t.typeId) < 0) {
                    addedTypes.push(t.typeId);
                    s += trophyNames[campaignById('' + t.campaignId).campaignConfigId][t.typeId] + "<br />";
                }
            });
            s += '</p>';
            addBrief(s, null, true, true);
        }

        forEach(apiData.profile.trophies, function (pt) {
            let key = pt.campaignId + "-" + pt.typeId;
            if (removedTrophies.indexOf(key) < 0) totalTrophies.push(pt);
        });
        apiData.profile.trophies = totalTrophies;

        let em = apiData.profile.email.toLowerCase();
        for (let i = 0; i < apiData.profile.teamData.length; i++) {
            for (let j = 0; j < apiData.profile.teamData[i].ps.length; j++) {
                let participant = apiData.profile.teamData[i].ps[j];
                if (participant.e.toLowerCase() === em) {
                    let ci = apiData.profile.teamData[i].ci;
                    let newTeamDataTr = [];
                    for (let k = 0; k < apiData.profile.trophies.length; k++) {
                        let participantTrophy = apiData.profile.trophies[k];
                        if (participantTrophy.campaignId === ci) {
                            newTeamDataTr.push(participantTrophy.typeId);
                        }
                    }
                    participant.tr = newTeamDataTr;
                }
            }
        }

        if (callUpdate) {
            updateTrophies(callback);
        } else {
            if (callback) callback();
            drawTeamData();
        }
    }, newTrophies);
}

function newTrophy(campaignId, typeId) {
    let a = apiData.profile.trophies;
    if (!a || a.length === 0) return true;
    for (let i = 0; i < a.length; i++) {
        let t = a[i];
        if (t.campaignId === campaignId && t.typeId === typeId) return false;
    }
    return true;
}

function reloadOK() {
    let key = "reload." + document.location;
    let count = sessionStorage.getItem(key);
    if (count && count > 25) {
        customLog(2, "more than 25 reloads of the same page, is probably an error");
        return false;
    } else {
        count ? count++ : 1;
        sessionStorage.setItem(key, count);
        return true;
    }
}

function toAPI(action, callback, postData, noAuth, source, eventExtra) {
    let url = noAuth ? VctaAPIUrl + action : vctaSurface + "ToAPI?action=" + action;
    httpr(url, function (data) {
        if (data === -1) {
            customLog(2, action, url, data);
            addOverlayMessage(genericError, url);
        } else if (data === "0") {
            if (document.location.pathname.toLowerCase() != "/login") {
                window.location = "/login";
            } else {
                customLog(2, "trying to redirect to login, but we're already on login");
            }
        } else {
            callback(data);
        }
    }, typeof postData === "string" ? postData : JSON.stringify(postData), source, eventExtra)
        .then(() => {
        }).catch((ex) => {
        customLog(2, "httpr exception " + action, ex);
        showApiError(genericError);
    });
}

function getApiData(action, callback, refresh) {
    if (refresh || !apiData[action]) {
        toAPI(action, function (data) {
            apiData[action] = data;
            callback(data);
        }, "{}");
    } else {
        callback(apiData[action]);
    }
}

function campaignById(id) {
    return first(apiData.profile.campaigns, parseInt(id), "id");
}
﻿const chartColors = ["-purple", "-pink", "-green", "-blue", "-yellow", "-darkpurple"];

const lineConfig = {
	data: {
	},
	axisX: {
		showLabel: false,
		showGrid: false,
	},
	axisY: {
		showLabel: false,
		showGrid: false,
		scaleMinSpace: 50,
		onlyInteger: true,
	},
	chartPadding: { top: 40, right: 0, bottom: 10, left: 20 },
	low: 0,
};
const barConfig = {
	data: {
	},
	chartPadding: lineConfig.chartPadding,
	axisY: {
		scaleMinSpace: 50,
		onlyInteger: true,
	},
	seriesBarDistance: 0,
	low: 0,
};

function setSeriesColors(series, colorOffset) {
	let colorIndex = 0 + colorOffset;
	for (var i = 0; i < series.length; i++) {
		series[i].className = chartColors[colorIndex];
		colorIndex++;
		if (colorIndex >= chartColors.length) colorIndex = 0;
	}
}

function drawLineChart(el, series, labels, acc = false, area = false, colorOffset = 0, animate = false, responsive = false) {
	el.classList.add("-line");
	if (acc) sumSeries(series);
	setSeriesColors(series, colorOffset);

	let config = clone(lineConfig);
	config.showArea = area;

	let data = {
		series: series
	};


	if (labels && labels.length > 0) {
		data.labels = labels;
		config.axisX.showLabel = true;
		config.axisY.showLabel = true;
		config.axisY.showGrid = true;
	}

	if (responsive) {
		el.classList.add("-resp");
		if (showLabels) el.parentNode.classList.add(`-h${Math.ceil(data.labels.length / 5.0) * 100}`);
	}

	const chart = new Chartist.LineChart(el, data, config);

	if (animate) {
		el.classList.add("-anim");
		let speed = 1000;
		chart.on("draw", (data) => {
			setTimeout(() => {
				el.classList.add("-done");
			}, speed);
			if (!el.classList.contains("-done") && data.type === "line" || data.type === "area") {
				data.element.animate({
					d: {
						begin: 0, //speed * data.index,
						dur: speed,
						from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
						to: data.path.clone().stringify(),
						easing: Chartist.easings.easeOutQuint,
					},
				});
			}
		});
	}
}

function sumSeries(series) {
	if (!series) return;
	series.forEach(ser => {
		let arr = ser.data ? ser.data : ser;
		if (arr) {
			let last = 0;
			arr.forEach((e, i) => {
				last += e && isFloat(e) ? Number(e) : 0;
				arr[i] = i > 0 ? last : arr[i];
			});
		}
	});
	return series;
}

function drawBarchart(el, series, labels, acc = false, stacked = false, colorOffset = 0, responsive = false) {
	el.classList.add("-bar");
	if (acc) sumSeries(series);
	setSeriesColors(series, colorOffset);

	let config = clone(barConfig);
	let data = {
		series: series
	};
	if (labels && labels.length > 0) data.labels = labels;
	config.stackBars = stacked;

	if (stacked) {
		el.classList.add("-stacked");
	}
	else if (!stacked) {
		el.classList.add(`-series${series.length}`);
	}

	let responsiveConfig = [];
	if (responsive) {
		el.classList.add("-resp");
		el.parentNode.classList.add(`-h${Math.ceil(labels.length / 5.0) * 100}`);

		responsiveConfig = [
			[
				"screen and (max-width: 500px)",
				{
					stackBars: true,
					reverseData: true,
					horizontalBars: true,
				},
			],
			[
				"screen and (max-width: 700px)",
				{
					stackBars: true,
				},
			],
		];
	}

	new Chartist.BarChart(el, data, barConfig, responsiveConfig);
}

﻿addDomReadyEventListener(async () => {
    var elements = document.querySelectorAll('input,select,textarea');
    var invalidListener = function () {
        let form = this.closest("form");
        let firstInvalid = form.querySelector(":invalid");
        if (firstInvalid === this) {
            this.scrollIntoView(false);
            scrollToElement(this);
        }
    };

    for (let i = elements.length; i--;) {
        elements[i].addEventListener('invalid', invalidListener);
    }

    let prefillEmail = urlParam("email");
    if (prefillEmail) {
        if (prefillEmail.indexOf("@") < 0) {
            if (typeof fetch !== 'undefined') {
                try {
                    const afResponse = await fetch(VctaAPIUrl +  "DecryptEmail/" + prefillEmail);
                    prefillEmail = await afResponse.text();
                }
                catch (ex) {
                    console.error(ex);
                }
            }
            else {
                prefillEmail = "";
            }
        }
        forEach(document.querySelectorAll("form.prefill"), function (el) {
            let field = el.querySelector("input[type='email']");
            if (field) field.value = prefillEmail;
        });
    }

    initForms();

    forEach(".products .product", function (el) {
        el.addEventListener("input", function (e) {
            let el = e.target;
            if (el) {
                let v = el.value;
                let p = el.nextElementSibling;
                let pr = el.dataset.price;
                if (v && isInt(v) && p && pr) {
                    p.innerHTML = "I alt " + toComma(v * toPoint(pr), true) + " kr.";
                    removeClass(p, "hidden");
                }
                else {
                    p.innerHTML = "";
                    addClass(p, "hidden");
                }
            }
        });
    });
});

function initForms() {
    let forms = document.querySelectorAll("form.simple:not(.initdone)");
    addEvents(forms, "submit", function (e) {
        let form = e.target;
        if (hasClass(form, "pw")) {
            let pw = form.querySelector("input[name=password]");
            let newpw = form.querySelector("input[name=newpassword]");
            let pwe = form.querySelector("span[for=password]");
            let blankOk = hasClass(form, "update");

            if (blankOk && pw.value.length === 0) {
                addClass(pwe, "hidden");
            }
            else {
                if (pw.value.length < 6 || pw.value !== newpw.value) {
                    removeClass(pwe, "hidden");
                    return stopAll(e);
                }
                else {
                    addClass(pwe, "hidden");
                }
            }
        }
        if (hasClass(form, "hasProducts")) {
            let sum = 0;
            forEach(form.querySelectorAll(".product"), function (el) {
                let val = el.value;
                if (val && isInt(val) && val > 0) sum += parseInt(val);
            });
            if (sum === 0) {
                scrollToElement(form.querySelector(".products"));
                return stopAll(e);
            }
        }

        httpr(vctaSurface + form.getAttribute("data-method"), undefined, new FormData(form), form)
        .then(() => { }).catch((ex) => { showApiError(genericError); });
        return stopAll(e);
    });
    addClasses(forms, "initdone");


    forms = document.querySelectorAll("form.simpleToAPI:not(.initdone)");
    addEvents(forms, "submit", function (e) {
        let form = e.target.closest("form");
        removeClasses(form.querySelectorAll(".result"), "active");

        let dto = {};
        forEach(form.querySelectorAll("select, input:not([type=submit]):not([type=button])"), function (formEl) {
            dto[formEl.getAttribute("name")] = (formEl.getAttribute("data-type") === "int" ? parseInt(formEl.value) : formEl.value);
        });

        toAPI(form.getAttribute("data-method"), function (data) {
            if (data) {
                let activeResult = form.querySelector(".result[data-status='" + data.result + "']");
                if (activeResult) addClass(activeResult, "active");
            }
            else {
                let activeResult = form.querySelector(".result[data-status='0']");
                if (activeResult) addClass(activeResult, "active");
            }
        }, dto, false, form);

        return stopAll(e);
    });
    addClasses(forms, "initdone");
}
﻿function webPsupport(callback) {
    var webP = new Image();
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    webP.onload = webP.onerror = function () {
        callback(webP.height === 2);
    };
}

addDomReadyEventListener(() => {
    webPsupport(function (hasWebP) {
        let skipSteppingSize = [370, 570, 1170];
        forEach("img[data-src]", function (img) {
            if (hasClass(img, "lazy")) return;
            if (!isVisible(img)) {
                addClass(img, "lazy");
                return;
            }
            let mode = img.closest(".images") ? "max" : "crop";
            let src = img.getAttribute("data-src")?.toLowerCase();
            let isPNG = src.indexOf(".png") > 0;
            let height = img.clientHeight;
            let width = img.clientWidth;
            let uw = img.getAttribute("data-uw");
            if (uw && width > uw) width = uw;
            let allowSizeSteps = true;
            if (hasClass(img, "defaultAspect")) {
                if (uw) {
                    img.style.maxWidth = uw + "px";
                    if (uw < width) {
                        width = uw;
                        allowSizeSteps = false;
                    }
                }
                if (img.getAttribute("data-aspect")) {
                    height = width * img.getAttribute("data-aspect");
                }
                else {
                    height = "";
                }
            }
            if (hasClass(img, "sizebyheight")) {
                height = img.parentNode.clientHeight;
                width = "";
            }
            let pe = img.parentElement;
            if (width <= 1) {
                while (pe) {
                    width = pe.offsetWidth;
                    if (width > 1) {
                        break;
                    }
                    else {
                        pe = pe.parentElement;
                    }
                }
            }

            if (allowSizeSteps && width && skipSteppingSize.indexOf(width) < 0) {
                let stepSize = 10;
                if (width > 1200) {
                    stepSize = 200;
                }
                else if (width > 600) {
                    stepSize = 100;
                }
                else if (width > 300) {
                    stepSize = 50;
                }
                let steppedWidth = Math.ceil(width / stepSize) * stepSize;
                let steppedHeight = height ? Math.round(height / width * steppedWidth) : height;
                width = steppedWidth;
                height = steppedHeight;
            }

            if ((pe === img.parentElement) && pe.tagName !== 'DIV' && pe.closest('article')) height = 0;

            if (src.indexOf(".svg") < 0) {
                src = src.split('?')[0] + "?quality=80&rmode=" + mode + "&width=" + (width <= 0 ? "" : width) + "&height=" + (height <= 1 ? "" : height) + (img.getAttribute("data-center") ? "&rxy=" + img.getAttribute("data-center") : "") + (hasClass(img, "preflow") ? "&bgcolor=ffffff&autorotate=true&format=jpg" : (hasWebP && !isPNG ? "&format=webp" : ""));
            }
            img.addEventListener("load", function (e) {
                var parent = e.target.parentNode;
                if (parent) {
                    setTimeout(function () { addClass(parent, "hlc"); }, 300);
                    if (parent.classList.contains("img")) addClass(parent, "lazyloaded");
               }
                img.removeAttribute("data-src");
                addClass(img, "lazyloaded");
            });
            img.setAttribute("loading", "lazy");
            img.setAttribute("src", src);
            if (hasClass(img.parentNode, "contain")) {
                img.parentNode.setAttribute("data-bg", "url(" + img.getAttribute("data-src") + ")");
            }
        });
    });
});

function injectSVG(el) {
    let src = el.src;
    let parent = el.parentNode;
    removeElement(el);
    loadInto(parent, src, function () { }, "image/svg+xml");
}
//var videoAccept = '<div class="cookieconsent-optout-statistics">Du skal <a href="javascript:Cookiebot.renew()">acceptere marketing cookies</a> for at se video.</div>';
//$(function () {
//    if (window.videoAccept !== undefined) $("iframe[data-cookieconsent]").closest(".embed-container").before(videoAccept);
//    $("iframe[data-cookieconsent]").each(function () {
//        $(this).attr("src", $(this).attr("data-src"));
//    });
//});

addDomReadyEventListener(() => {
    let ticking = false;

    function updateScrollY() {
        let s = window.scrollY;
        let f = s.toString().length;
        document.body.setAttribute('data-scroll-y', s);
        let removals = [];
        document.body.classList.forEach(cls => {
            if (cls.startsWith('sy')) removals.push(cls);
        });
        removals.forEach(cls => document.body.classList.remove(cls));
        if (s > 10) {
            document.body.classList.add("sy0");
            document.body.classList.add("sy" + f);
        }

        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(updateScrollY);
            ticking = true;
        }
    });

    // Initial call to set the attribute on page load
    updateScrollY();


    let brgr = document.querySelector("#burger-check");
    brgr.addEventListener("click", e => {
        let body = document.querySelector("body");
        if (brgr.checked) {
            body.classList.add("menu");
        } else {
            body.classList.remove("menu");
        }
    });
    document.querySelectorAll("nav .menu a").forEach((a) => {
        a.addEventListener("click", (e) => {
            brgr.checked = false;
        });
    });

    parseTimeStampCookie("main.js");

    if (document.querySelector(".profileCTA")) {
        document.querySelectorAll(".notProfileCTA").forEach(el => {
            el.classList.add("hidden");
        });
    }

    localizeElements();

    let chooseLanguage = document.getElementById("chooseLanguage");
    if (chooseLanguage) {
        let r = chooseLanguage.closest(".r");
        addEvents("#chooseLanguage a", "click", function (e) {
            stopAll(e);
            setCookie("VCTALanguage", e.target.getAttribute("data-lang"), 365);
            addClass(r, "hidden");
            return false;
        });
    }
    let switchLanguage = document.getElementById("switchLanguage");
    if (switchLanguage) {
        let switches = switchLanguage.querySelectorAll("a");
        let currentLanguage = getCookie("VCTALanguage");
        if (currentLanguage) {
            forEach(switches, function (el) {
                if (el.getAttribute("data-lang") == currentLanguage) addClass(el, "disabled");
            });
        }
        addEvents("#switchLanguage a", "click", function (e) {

            stopAll(e);
            let setLang = e.target.getAttribute("data-lang");
            setCookie("VCTALanguage", setLang, 365);
            forEach(switches, function (el) {
                if (el.getAttribute("data-lang") == setLang) {
                    addClass(el, "disabled");
                } else {
                    removeClass(el, "disabled");
                }
            });
            return false;
        });
    }

    let map = document.querySelector("#map");
    if (map) {
        var refs = document.getElementsByTagName('script');
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBwUmOPOhiVRK3mg2VIwEvldOjF_lSR5Kg&callback=initMap&v=quarterly';
        refs[refs.length - 1].parentNode.insertBefore(script, refs[refs.length - 1]);
    }

    forEach(".pu", function (el) {
        addClass(el.parentNode, "haspu");
    });

    var someshare = document.querySelector("li.share");
    if (someshare) {
        var url = window.location.href.split('?')[0].split('#')[0];
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) url = canonical.getAttribute("href");

        let sh = someshare.querySelector(".tw");
        if (sh) sh.setAttribute("href", "http://twitter.com/share?text=&hashtags=vcta&url=" + encodeURIComponent(url));
        sh = someshare.querySelector(".fb");
        if (sh) sh.setAttribute("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
    }

    forEach(".banner .bike", function (el) {
        var url = cssVar("logocykel" + el.getAttribute("data-bike"));
        var svg = decodeURIComponent(url.substring(url.indexOf(",") + 1, url.indexOf(")") - 1));
        el.innerHTML = svg;
    });

    let mega = document.querySelector("nav.mega > ul");
    forEach(".stick a", function (el) {
        if (!hasClass(el, "search") && el !== el.parentNode.children[0]) {
            let li = document.createElement("li");
            addClass(li, "added");
            li.innerHTML = el.outerHTML;
            removeClass(li.querySelector("a"), "button");
            mega?.prepend(li);
        }
    });

    addEvents(".gallery div > img", "click", function (e) {
        let src = e.target.src;
        if (src) {
            src = src.split('?')[0] + '?quality=80&mode=crop&upscale=false&width=1200&format=webp';
            window.open(src);
        }
    });

    activateToggles();

    addEvent("nav.mega", "click", function (e) {
        e.stopPropagation();
    });

    addEvent(".burger", "click", function (e) {
        toggleClass("nav.mega", "showMobile");
        toggleClass("body", "noscroll");
        document.getElementById("burger-check").checked = !document.getElementById("burger-check").checked;
        return stopAll(e);
    });

    addEvent("a.search", "click", function (e) {
        toggleClass(e.target, "out");
        return stopAll(e);
    });

    addEvents(".main a, .sub a:not(.search)", "click", function (e) {
        if (hasClass(e.target, "show")) {
            hideMenu();
        } else {
            let mega = document.querySelector("nav.mega");
            removeClass(mega, "showMobile");
            document.getElementById("burger-check").checked = false;

            return showMenu(e.target, e);
        }
        return stopAll(e);
    });

    addEvent(".sub form", "click", function (e) {
        e.stopPropagation();
    });

    addEvent("body", "click", function (e) {
        let s = document.querySelector("a.search");
        if (s) removeClass(s, "out");
        hideMenu();
    });

    forEach("p.limit", function (el) {
        if (el.offsetHeight > 150) {
            addClass(el, "limited");
        } else {
            removeClass(el, "limit");
        }
    });

    addEvent("p.limit", "click", function (e) {
        removeClass(e.target, "limited");
        stopAll(e);
    });

    var pop = document.querySelector("div.pop");
    if (pop) {
        let popId = pop.dataset.id;
        let popKey = "pop" + popId;
        let today = new Date().toISOString().split('T')[0];
        let lastShown = localStorage.getItem(popKey);
        if (!lastShown || lastShown != today) {
            localStorage.setItem(popKey, today);
            const dialog = document.getElementById('imageDialog');
            document.body.classList.add("noscroll");
            dialog.addEventListener("close", (e) => {
                document.body.classList.remove("noscroll");
            });
            dialog.querySelector("form").insertAdjacentHTML("beforeend", pop.outerHTML);

            let delay = pop.dataset.delay;
            if (delay) {
                setTimeout(function () {
                    document.body.classList.add("noscroll");
                    dialog.showModal();
                }, delay * 1000);
            } else {
                document.body.classList.add("noscroll");
                dialog.showModal();
            }
        }
    }

    showNextLoadMessages();

    if (window.gtmId !== undefined && window.gtmId !== '') {
        window.dataLayer = window.dataLayer || [];

        gtag("consent", "default", {
            ad_storage: "denied",
            analytics_storage: "denied",
            wait_for_update: 500
        });
        gtag("set", "ads_data_redaction", true);


        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
            var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', gtmId);
    }
});

window.addEventListener('load', function () {
    setDataScale();
});

window.addEventListener('resize', function () {
    setDataScale();
});

window.setDataScale = function () {
    setTimeout(function () {
        let vwVal = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        document.querySelector(':root').style.setProperty("--currentWidth", vwVal);

        forEach(document.querySelectorAll(".rscaled"), function (el) {
            let max = el.getAttribute("data-max");
            if (!max) max = 1170;
            let vw = vwVal;
            if (vw > el.parentNode.offsetWidth) vw = el.parentNode.offsetWidth;
            let elW = el.offsetWidth;
            if (elW > max) max = elW;
            let scale = vw < max ? vw / max : 1;
            if (scale < 0.01) scale = 1;
            el.setAttribute("style", '--rscale: ' + scale + '; --scalemax: ' + max + 'px');
            if (vw < max) {
                addClass(el, "scaled");
            } else {
                removeClass(el, "scaled");
            }
        });
    }, 200);
}

function localizeElements() {
    forEach(document.querySelectorAll('[data-local]'), function (el) {
        var t = localText(el.getAttribute("data-local"));
        if (el.tagName === "INPUT") {
            let type = el.getAttribute("type");
            if (type === "submit" || type === "button") {
                el.setAttribute("value", t);
            } else {
                el.setAttribute("placeholder", t);
            }
        } else {
            el.innerHTML = t;
        }
    });
}

function showNextLoadMessages() {
    let nlBriefMessages = sessionStorage.getItem("NextLoadBriefMessages");
    let nlMessages = sessionStorage.getItem("NextLoadMessages");
    if (nlBriefMessages) {
        addBrief(JSON.parse(nlBriefMessages).join("<br><br>"));
        sessionStorage.removeItem("NextLoadBriefMessages");
    }
    if (nlMessages) {
        addOverlayMessage(JSON.parse(nlBriefMessages).join("<br><br>"));
        sessionStorage.removeItem("NextLoadMessages");
    }
}

function gtag() {
    dataLayer.push(arguments);
}

function toggle(e) {
    let toggle = e.target;
    if (hasClass(toggle, "off")) {
        removeClass(toggle, "off");
    } else {
        addClass(toggle, "off");
    }
}

function hideMenu() {
    let mega = document.querySelector("nav.mega");
    if (mega) {
        addClass(mega, "hidden");
        removeClass(mega, "showMobile");
        document.getElementById("burger-check").checked = false;

        forEach(".main a, .sub a:not(.search)", function (el) {
            removeClass(el, "show");
        });
    }
}

function showMenu(el, e) {
    forEach(".main a, .sub a:not(.search)", function (el) {
        removeClass(el, "show");
    });
    addClass(el, "show");

    var href = el.getAttribute("href");
    var solo = false;
    forEach(".mega > ul > li > a", function (elx) {
        if (elx.getAttribute("href") === href) {
            if (!solo) solo = hasClass(elx, "solo");
            removeClass(elx.parentNode, "hidden");
        } else {
            addClass(elx.parentNode, "hidden");
        }
    });
    if (solo) return;

    removeClass(document.querySelector("nav.mega"), "hidden");

    if (e) return stopAll(e);
}
﻿var mapData;
var map;
var lastMarkerId;
var extraR = 250;
var extraL = 70;
var extraT = 300;
var lastBounds;

var smallWidth = 800;
var centerMapX = 56.3;
var centerMapY = 11.4;
var searchZoom = 12;
var searchZoomSmall = 10;
var defaultZoom = 7;
var defaultZoomSmall = 6;
var disableMapTable = false;
var narrowMap = false;

addDomReadyEventListener(() => {
    let ts = document.querySelector("#topstats");
    if (ts) {
        let qsid = urlParam("id");
        if (qsid) mapCampaignId = qsid;
        if ((mapCampaignId + '').indexOf(",") > 0) {
            let parts = mapCampaignId.split(",");
            if (parts.length > 1 && parts[1] == "0") disableMapTable = true;
            if (parts.length > 2 && parts[2] == "0") narrowMap = true;

            mapCampaignId = parts[0];
        }
        if (!disableMapTable) {
            httpr(VctaAPIUrl + 'TopStats/' + mapCampaignId, function (data) {
                let t = data.totals.Total;
                //let stats = '<article><p><a href="/statistik?id=' + mapCampaignId + '">Gå til den fulde statistik for hele kampagnen</a></p></article>';
                let stats = '<div class="c stattable lfirst"><table><tr><th></th><th>Deltagere</th><th>Cykeldage</th><th>KM</th></tr>' +
                    '<tr><td><a href="/statistik?id=' + mapCampaignId + '&show=totals">Total</a></td><td>' + drawBar(t.s, t.s, false, " deltager" + (t.s === 1 ? "" : "e")) + '</td><td>' + drawBar(t.d, t.d, false, " dag" + (t.d === 1 ? "" : "e")) + '</td><td>' + drawBar(t.k, t.k, false, " km") + '</td></tr>';

                let dict = data.regions;
                let rs = [];
                Object.keys(dict).forEach(function (key) {
                    let v = dict[key];
                    rs.push([key, v.s, v.d, v.k]);
                });

                rs = sortByColumn(rs, 1, 1);


                forEach(rs, function (r) {
                    stats += '<tr><td><a href="/statistik?id=' + mapCampaignId + '&show=municipalities&by=municipalities&filter=' + encodeURIComponent(r[0]) + '">' + r[0] + '</td><td>' + drawBar(r[1], t.s, false, " deltager" + (r[1] === 1 ? "" : "e")) + '</td><td>' + drawBar(r[2], t.d, false, " dag" + (r[2] === 1 ? "" : "e")) + '</td><td>' + drawBar(r[3], t.k, false, " km") + '</td></tr>';
                });

                stats += '</table></div></div>';
                ts.innerHTML = stats;
            });
        }
    }
});

function CustomMarker(latlng, map, args) {
    this.latlng = latlng;
    this.args = args;
    this.setMap(map);
}

window.initMap = function initMap() {
    CustomMarker.prototype = new google.maps.OverlayView();

    CustomMarker.prototype.draw = function () {

        var self = this;

        var div = this.div;

        if (!div) {

            div = this.div = document.createElement('div');

            div.className = 'marker';

            div.dataset.markerid = self.args.markerid;
            if (self.args.zip) div.dataset.zip = self.args.zip;
            if (self.args.ts) div.dataset.ts = self.args.ts;
            if (self.args.ss) div.dataset.ss = self.args.ss;
            if (self.args.size) div.dataset.size = self.args.size;
            if (self.args.ll) div.dataset.ll = self.args.ll;

            google.maps.event.addDomListener(div, "click", function (e) {
                let el = e.target;
                if (hasClass(el, "active")) return;
                addClass(el, "active");
                let $map = document.querySelector("#map");
                let $mapinfo = document.querySelector("#mapinfo");
                let to = getOffset(el);
                let mo = getOffset($map);

                mo.right = getWidth($map) + mo.left;
                mo.bottom = getHeight($map) + mo.top;
                var panX = 0;
                var panY = 0;
                if (to.left < mo.left + extraL) panX = (mo.left + extraL) - to.left;
                if (to.left > mo.right - extraR) panX = (mo.right - extraR) - to.left;
                if (to.top < mo.top + extraT) panY = (mo.top + extraT) - to.top;

                map.panBy(-panX, -panY);

                if (lastMarkerId) {
                    let $lm = $map.querySelector("div[data-markerid='" + lastMarkerId + "']");
                    removeClass($lm, "active");
                    $lm.innerHTML = "";
                }
                lastMarkerId = el.getAttribute("data-markerid");

                var item = mapData[lastMarkerId];
                el.innerHTML = '<div><a class="close"></a><h3>Postnummer ' + item.z + '</h3><p>' + item.ts + ' hold med ' + item.ss + ' deltagere.</p>' + ($mapinfo ? '<p><a class="mapinfo" href="#mapinfo">Se alle hold i ' + item.z + '</a></p>' : '') + '<p><a class="stats" href="/statistik/?id=' + mapCampaignId.split(',')[0] + '&show=teams&filter=' + item.z + '&by=zips&sort=3,1">Gå til statistik for hold i ' + item.z + '</a></p></div>';

                if ($mapinfo) {
                    let $mi = el.querySelector(".mapinfo");
                    $mi.addEventListener("click", function (e) {
                        scrollToElement(document.querySelector("#mapinfo"));
                        stopAll(e);
                    });
                }

                let $stats = el.querySelector(".stats");
                $stats.addEventListener("click", function (e) {
                    window.open(e.target.href);
                    stopAll(e);
                });

                let s = "";
                let lastGroup = "";
                let lastCompany = "";
                forEach(item.wp, function (wp) {
                    if (wp.g !== lastGroup) {
                        lastGroup = wp.g;
                        lastCompany = wp.c;
                        s += '<h2>' + lastGroup + '</h2>';
                        if (lastCompany !== lastGroup) {
                            s += '<h3>' + lastCompany + '</h3>';
                        }
                    }
                    else if (wp.c !== lastCompany) {
                        lastCompany = wp.c;
                        s += '<h3>' + lastCompany + '</h3>';
                    }
                    forEach(wp.t, function (t) {
                        s += "<p>" + t.n + " (" + t.s + " deltagere, " + t.d + " cykeldage, " + toComma(t.k, true) + " KM)</p>";
                    });
                });
                if ($mapinfo) {
                    $mapinfo.innerHTML = s;
                    removeClass($mapinfo.closest(".r"), "hidden");
                }

                el.querySelector("div").addEventListener("click", function (e) {
                    stopAll(e);
                });
                el.querySelector(".close").addEventListener("click", function (e) {
                    stopAll(e);
                    if (lastMarkerId) {
                        let $lm = $map.querySelector("div[data-markerid='" + lastMarkerId + "']");
                        removeClass($lm, "active");
                        $lm.innerHTML = "";
                    }
                    return false;
                });
            });

            var panes = this.getPanes();
            panes.overlayImage.appendChild(div);
        }

        var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

        if (point) {
            div.style.left = point.x - 10 + 'px';
            div.style.top = point.y - 10 + 'px';
        }
    };

    CustomMarker.prototype.remove = function () {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    };

    CustomMarker.prototype.getPosition = function () {
        return this.latlng;
    };

    var request = new XMLHttpRequest();
    request.open('GET', VctaAPIUrl + 'zips/' + mapCampaignId.split(',')[0], true);

    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            var data = JSON.parse(request.responseText);
            var mapOptions = {
                zoom: window.innerWidth > smallWidth ? defaultZoom : defaultZoomSmall,
                center: new google.maps.LatLng(centerMapX, centerMapY),
                disableDefaultUI: true,
                styles: mapStyles
            };

            map = new google.maps.Map(document.getElementById('map'), mapOptions);

            //map.addListener('bounds_changed', function () {
            //    log("bounds changed");
            //});

            mapData = data;

            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                let size = 1;
                if (item.ts > 4) size = 2;
                if (item.ts > 25) size = 3;
                if (item.ts > 100) size = 4;

                overlay = new CustomMarker(
                    new google.maps.LatLng(item.lat, item.lng),
                    map,
                    {
                        markerid: i,
                        zip: item.z,
                        ts: item.ts,
                        ss: item.ss,
                        size: size,
                        ll: item.lat + "," + item.lng
                    }
                );
            }
        } else {
            console.log("error loading map data");
        }
    };

    request.onerror = function () {
        console.log("request error loading map data");
    };

    request.send();
}

var mapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#523735"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#c9b2a6"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#dcd2be"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#ae9e90"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "poi",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#93817c"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#a5b076"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#447530"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f1e6"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "stylers": [
            {
                //"visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#fdfcf8"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f8c967"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#e9bc62"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e98d58"
            }
        ]
    },
    {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#db8555"
            }
        ]
    },
    {
        "featureType": "road.local",
        "stylers": [
            {
                //"visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#806b63"
            }
        ]
    },
    {
        "featureType": "transit",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8f7d77"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ebe3cd"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dfd2ae"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#b9d3c2"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#92998d"
            }
        ]
    }
];
﻿var cseUrl = 'https://www.googleapis.com/customsearch/v1/siterestrict?key=AIzaSyDR8Wdq-g47Pf5-bYEdwBKqFL6e_qPyLio&cx=002541532685811098227:95zewwkwhw0&fields=items(title,link,snippet,htmlSnippet,pagemap/cse_image),searchInformation(totalResults),queries(request/searchTerms,nextPage/startIndex)&q=';

addDomReadyEventListener(() => {
    var q = urlParam("q");
    if (q && q !== '') {
        var searchResult = document.getElementById("searchResult");
        if (searchResult) {
            addEvent(".moreResults a.button", "click", function () {
                showSearchResults(searchResult.getAttribute("data-q"), searchResult, searchResult.getAttribute("data-next"));
            });

            forEach(".searchForm input[type=text]", function (el) {
                el.value = q;
            });

            addEvent(".searchForm", "submit", function (e) {
                let q = e.target.querySelector("input[type=text]");
                if (q && q.value !== "") {
                    showSearchResults(q.value, searchResult);
                }
                return false;
            });

            showSearchResults(q, searchResult);
        }
    }
});

function showSearchResults(q, searchResult, start) {
    if (!start) start = 1;
    if (q) {
        httpr(cseUrl + encodeURIComponent(q) + "&start=" + start, function (data) {
            if (start === 1) searchResult.innerHTML = "";
            showItems(data, searchResult);
        })
        .then(() => { }).catch((ex) => { showApiError(genericError); });
    }
}

function showItems(data, searchResult) {
    searchResult.setAttribute("data-q", data.queries.request[0].searchTerms);
    var moreResults = document.querySelector(".moreResults");
    if (data.queries.nextPage) {
        removeClass(moreResults, "hidden");
        searchResult.setAttribute("data-next", data.queries.nextPage[0].startIndex);
    }
    else {
        addClass(moreResults, "hidden");
    }
    var html = "";
    if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
            var item = data.items[i];

            html += '<a href="' + item.link + '" class="c">' +
                '<span class="h3">' + item.title + '</span>' +
                '<p>' + item.htmlSnippet.replace(/<br>/gi, "").replace(/&nbsp;/gi, "") + '</p>' +
                '</a>';
        }
    }
    else {
        html = "<p class=\"c\">Ingen resultater</p>";
    }
    searchResult.insertAdjacentHTML("beforeend", html);
}
﻿const tableData = {
    maxD: 0,
    minD: 0,
    maxK: 0,
    minK: 0,
    maxPD: 0,
    minPD: 0,
    maxPK: 0,
    minPK: 0,
    maxSD: 0,
    minSD: 0,
    maxSK: 0,
    minSK: 0,
    maxPSD: 0,
    minPSD: 0,
    maxPSK: 0,
    minPSK: 0,
    sort: 3,
    order: 0,
    rows: []
};

const tableSort = 3;
let statsKey = "stats";
let favsKey = "favs";
let maxFavorites = 3;
let miniView = false;
let isPersonal = false;
let statsfilterId = "statsfilter";

let statsshow = {};

addDomReadyEventListener(() => {
    miniView = urlParam("cv") === "2";

    let statsRow = document.querySelector("#statsRow");
    let combined = document.querySelector("#combinedstats")?.parentElement;
    let play = document.querySelector("#playstats");
    document.querySelectorAll("#playstats, #combinedstats, #perstats").forEach(function (el) {
        let id = el.id;
        statsshow[id] = (localStorage.getItem(id) ?? "true") === "true";
        el.checked = statsshow[id];
        if (el.checked) statsRow?.classList.add(id);
        el.addEventListener("click", function (e) {
            statsshow[id] = el.checked;
            localStorage.setItem(id, el.checked);
            statsRow?.classList.toggle(id);
            if (play?.checked && combined) combined.classList.remove("hidden");
            if (!play || !play.checked) combined?.classList.add("hidden");
            setStatsTableDataMax();
        });
    });
    if (play?.checked && combined) combined.classList.remove("hidden");

    initCSR();
    initStats();
    initPersonalStats();

    window.setDataScale();
});

function setStatsTableDataMax() {
    let container = document.querySelector("#stattable");
    let table = container?.querySelector("table");
    if (!table) return;
    let favTable = document.querySelector("table.favorites");
    let team = container.classList.contains("teamtable");
    let max = 600;
    if (team) {
        if (statsshow["playstats"] && statsshow["combinedstats"] && statsshow["perstats"]) {
            max = 1170;
        }
        else if (statsshow["playstats"] && statsshow["combinedstats"] && !statsshow["perstats"]) {
            max = 900;
        }
        else if (statsshow["playstats"] && !statsshow["combinedstats"] && statsshow["perstats"]) {
            max = 1000;
        }
        else if (!statsshow["playstats"] && statsshow["perstats"]) {
            max = 800;
        }
    }
    table.dataset.max = max.toString();
    if (favTable) favTable.dataset.max = table.dataset.max;
    window.setDataScale();
}

function initPersonalStats() {
    let sf = document.querySelector("#statfilterpersonal");
    if (!sf) return;
    let stattable = document.querySelector("#stattable");
    if (stattable) addClass(stattable, "workplay");
    maxFavorites = 30;
    statsKey = "IndividualStats";
    favsKey = "personalfavs";
    statsfilterId = sf.id;
    isPersonal = true;

    let id = urlParam("id");
    let f = urlParam("f");

    if (f) {
        try {
            if (f.indexOf("-") >= 0 || f.indexOf("[") < 0) f = atob(f.replace(/-/gi, "="));
            f = JSON.parse(f);
            if (f && f.length > 0) localStorage.setItem(favsKey, JSON.stringify(f));
        }
        catch (ex) {
            console.error(ex);
        }
    }
    if (id) statsCampaignId = id;

    httpr(VctaAPIUrl + statsKey + '/' + statsCampaignId, function (data) {
        apiData[statsKey] = data;

        let by = urlParam("by");
        let filter = urlParam("filter");
        let sort = urlParam("sort");

        if (!sort) {
            sort = data.totals.d > 0 ? "2,1" : "0,1";
        }

        let byEl = document.querySelector("select[name='by']");
        let sortEl = document.querySelector("select[name='sort']");

        if (data.campaignConfigId) {
            let groupText = localText('General.WorkplaceGroup', false, data.campaignConfigId);
            let workplaceText = localText('General.Workplace', false, data.campaignConfigId);

            byEl.querySelector("option[value='g']").innerHTML = groupText;
            byEl.querySelector("option[value='c']").innerHTML = workplaceText;
        }
        if (!data.hasPlay) {
            let sr = document.getElementById("statsRow");
            if (sr) addClass(sr, "neverplay");
        }

        sortEl.addEventListener("change", function (e) {
            showStatsTable();
        });

        byEl.addEventListener("change", function (e) {
            let by = document.querySelector("select[name='by']").value;
            setFilterData(by);
        });

        if (filter) document.querySelector("input[name='filter']").value = filter;
        if (sort) sortEl.value = sort;

        if (by) {
            byEl.value = by;
            sendEvent(byEl, "change");
        }
        else {
            setFilterData(document.querySelector("select[name='by']").value);
        }

        showFavTable();
        showStatsTable();

        window.setDataScale();

        addClass(document.getElementById("statloading"), "hidden");
        removeClass(document.getElementById("statfavorites"), "hidden");
        removeClass(document.getElementById(statsfilterId), "hidden");
    })
    .then(() => { }).catch((ex) => { showApiError(genericError); });

    sf.querySelector("form").addEventListener("submit", function (e) {
        showStatsTable();
        stopAll(e);
    });
}

function initCSR() {
    let csr = document.querySelector("#csr");
    if (!csr) {
        return;
    }
    let id = urlParam("id");
    let cid = urlParam("cid");
    console.log("loading data for csr");
    httpr(VctaAPIUrl + statsKey + '/' + cid, function (data) {
        apiData[statsKey] = data;
        let favStats = loadStatRows(id.split('||'));

        csr.innerHTML = getVSHtml(favStats);
        console.log("eoapi", window.eoapi);
        if (window.eoapi && eoapi.isEOPdf()) eoapi.convert();
    })
    .then(() => { }).catch((ex) => { showApiError(genericError); });
}
function initStats() {
    let sf = document.querySelector("#statfilter");
    if (!sf) return;

    if (miniView) addClass(sf, "hide");

    let id = urlParam("id");
    let f = urlParam("f");
    if (urlParam("s") === "1") {
        addClass(sf, "simple");
    }
    if (urlParam("r") === "1") setTimeout(function () { window.location.reload(false); }, 900000);

    if (f) {
        try {
            if (f.indexOf("-") >= 0 || f.indexOf("[") < 0) f = atob(f.replace(/-/gi, "="));
            f = JSON.parse(f);
            if (f && f.length > 0) localStorage.setItem(favsKey, JSON.stringify(f));
        }
        catch (ex) {
            console.error(ex);
        }
    }
    if (id) statsCampaignId = id;

    httpr(VctaAPIUrl + statsKey + '/' + statsCampaignId, function (data) {
        apiData[statsKey] = data;

        if (data == -1) {
            addOverlayMessage(genericError, "");
            return;
        }

        let show = urlParam("show");
        let by = urlParam("by");
        let filter = urlParam("filter");
        let sort = urlParam("sort");

        if (!show) {
            show = "companies";
        }
        if (!sort) {
            sort = data.totals.Total.d > 0 ? "3,1" : "2,1";
        }

        let showEl = document.querySelector("select[name='show']");
        let byEl = document.querySelector("select[name='by']");
        let sortEl = document.querySelector("select[name='sort']");

        //if (Object.keys(data.groups).length === 1) {
        //    byEl.removeChild(byEl.querySelector("option[value='groups']"));
        //    showEl.removeChild(showEl.querySelector("option[value='groups']"));
        //}

        if (data.campaignConfigId) {
            let groupText = localText('General.WorkplaceGroup', false, data.campaignConfigId);
            let workplaceText = localText('General.Workplace', false, data.campaignConfigId);

            byEl.querySelector("option[value='companies']").innerHTML = workplaceText;
            showEl.querySelector("option[value='companies']").innerHTML = workplaceText;

            let byGroupEl = byEl.querySelector("option[value='groups']");
            let showGroupEl = showEl.querySelector("option[value='groups']");
            if (byGroupEl) byGroupEl.innerHTML = groupText;
            if (showGroupEl) showGroupEl.innerHTML = groupText;
        }
        if (!data.hasPlay) {
            let sr = document.getElementById("statsRow");
            if (sr) addClass(sr, "neverplay");
        }

        sortEl.addEventListener("change", function (e) {
            showStatsTable();
        });

        showEl.addEventListener("change", function (e) {
            let v = e.target.value;
            if (v === "teams") {
                removeClass(document.getElementById("bySelect"), "hidden");
            }
            else {
                if (v !== "totals") {
                    if (!(byEl.value === "groups" && v === "companies")) byEl.value = v;
                    setFilterData(v);
                }
                addClass(document.getElementById("bySelect"), "hidden");
            }
            showStatsTable();
        });

        byEl.addEventListener("change", function (e) {
            let by = document.querySelector("select[name='by']").value;
            setFilterData(by);
        });

        if (show) showEl.value = show;

        if (filter) document.querySelector("input[name='filter']").value = filter;
        if (sort) sortEl.value = sort;

        if (by) {
            byEl.value = by;
            sendEvent(byEl, "change");
        }
        else {
            setFilterData(document.querySelector("select[name='by']").value);
        }

        sendEvent(showEl, "change");
        showFavTable();
        //showStatsTable();

        addClass(document.getElementById("statloading"), "hidden");
        removeClass(document.getElementById("statfavorites"), "hidden");
        removeClass(document.getElementById("statfilter"), "hidden");
    })
    .then(() => { }).catch((ex) => { showApiError(genericError); });

    sf.querySelector("form").addEventListener("submit", function (e) {
        showStatsTable();
        stopAll(e);
    });
}

function addFavorite(id) {
    let favs = getFavorites();
    if (favs.indexOf(id) < 0) favs.push(id);
    if (favs.length > maxFavorites) favs.shift();
    let newFavsString = JSON.stringify(favs);
    localStorage.setItem(favsKey, newFavsString);
    let lsNewFavsString = localStorage.getItem(favsKey);
    if (lsNewFavsString !== newFavsString) {
        addOverlayMessage("Vi kan ikke gemme din favorit i din browser, måske er der lukket for brug af Local Storage?");
    }
    else {
        addBrief("Tilføjet til favoritter, du kan se dem på toppen af siden.");
        showFavTable();
    }
}

function removeFavorite(id) {
    let favs = getFavorites();
    if (favs.length > 0) {
        let newFavs = [];
        forEach(favs, function (f) {
            console.log({f}, {id}, id !== f);
            if (id !== f) newFavs.push(f);
        });
        let newFavsString = JSON.stringify(newFavs);
        localStorage.setItem(favsKey, newFavsString);
        let lsNewFavsString = localStorage.getItem(favsKey);
        if (lsNewFavsString !== newFavsString) {
            addOverlayMessage("Vi kan ikke fjerne din favorit fra din browser, måske er der lukket for brug af Local Storage?");
        }
        else {
            showFavTable();
        }
    }
}

function getFavorites() {
    let favs = false;
    if (localStorage) favs = JSON.parse(localStorage.getItem(favsKey));
    return Array.isArray(favs) ? favs : [];
}

function loadStatRows(arr) {
    let o = {
        rs: [],
        mm: {
            minD: 0,
            maxD: 0,
            minK: 0,
            maxK: 0,
            minSD: 0,
            maxSD: 0,
            minSK: 0,
            maxSK: 0
        }
    };

    if (isPersonal) {
        let favs = {};
        if (arr && arr.length > 0) {
            forEach(arr, function (i) {
                let j = parseInt(i);
                if (j > 0) favs[j] = 1;
            });
        }

        let i = 0;
        forEach(apiData[statsKey].riders, function (p) {
            if (i < maxFavorites && favs[p.pi]) {
                i++;
                if (o.mm.maxD < p.d) o.mm.maxD = p.d;
                if (o.mm.minD > p.d) o.mm.minD = p.d;
                if (o.mm.maxK < p.k) o.mm.maxK = p.k;
                if (o.mm.minK > p.k) o.mm.minK = p.k;
                if (o.mm.maxPD < p.pd) o.mm.maxD = p.pd;
                if (o.mm.minPD > p.pd) o.mm.minD = p.pd;
                if (o.mm.maxPK < p.pk) o.mm.maxK = p.pk;
                if (o.mm.minPK > p.pk) o.mm.minK = p.pk;
                o.rs.push([p.pi, p.n, p.d, p.k, p.pd, p.pk, p.tn, p.r, p.m, p.z, p.g, p.c]);
            }
        });
    }
    else {
        forEach(arr, function (f) {
            let fa = f.split('|');
            let type = fa[0];
            let id = fa[1];

            if (type === "teams") {
                let ts = apiData[statsKey][type];
                if (ts) {
                    id = parseInt(id);
                    for (let i = 0; i < ts.length; i++) {
                        if (ts[i].ti === id) {
                            let t = ts[i];
                            let sd = t.d / t.s;
                            let sk = t.k / t.s;
                            if (o.mm.maxD < t.d) o.mm.maxD = t.d;
                            if (o.mm.minD > t.d) o.mm.minD = t.d;
                            if (o.mm.maxK < t.k) o.mm.maxK = t.k;
                            if (o.mm.minK > t.k) o.mm.minK = t.k;
                            if (o.mm.maxSD < sd) o.mm.maxSD = sd;
                            if (o.mm.minSD > sd) o.mm.minSD = sd;
                            if (o.mm.maxSK < sk) o.mm.maxSK = sk;
                            if (o.mm.minSK > sk) o.mm.minSK = sk;

                            let psd = t.pd / t.s;
                            let psk = t.pk / t.s;
                            if (o.mm.maxPD < t.pd) o.mm.maxPD = t.pd;
                            if (o.mm.minPD > t.pd) o.mm.minPD = t.pd;
                            if (o.mm.maxPK < t.pk) o.mm.maxPK = t.pk;
                            if (o.mm.minPK > t.pk) o.mm.minPK = t.pk;
                            if (o.mm.maxPSD < psd) o.mm.maxPSD = psd;
                            if (o.mm.minPSD > psd) o.mm.minPSD = psd;
                            if (o.mm.maxPSK < psk) o.mm.maxPSK = psk;
                            if (o.mm.minPSK > psk) o.mm.minPSK = psk;

                            o.rs.push([f, t.n, t.s, t.d, t.k, sd, sk, t.pd, t.pk, psd, psk, t.g, t.c, t.z, type]);
                            break;
                        }
                    }
                }
            }
            else {
                let v = apiData[statsKey][type][id];
                if (v) {
                    let sd = v.d / v.s;
                    let sk = v.k / v.s;
                    if (o.mm.maxD < v.d) o.mm.maxD = v.d;
                    if (o.mm.minD > v.d) o.mm.minD = v.d;
                    if (o.mm.maxK < v.k) o.mm.maxK = v.k;
                    if (o.mm.minK > v.k) o.mm.minK = v.k;
                    if (o.mm.maxSD < sd) o.mm.maxSD = sd;
                    if (o.mm.minSD > sd) o.mm.minSD = sd;
                    if (o.mm.maxSK < sk) o.mm.maxSK = sk;
                    if (o.mm.minSK > sk) o.mm.minSK = sk;

                    let gc = id.split("\u0007");
                    let c = gc.length > 1 ? (gc[0] !== gc[1] ? gc[0] + '<br />' + gc[1] : gc[1]) : id;

                    let psd = v.pd / v.s;
                    let psk = v.pk / v.s;
                    if (o.mm.maxPD < v.pd) o.mm.maxPD = v.pd;
                    if (o.mm.minPD > v.pd) o.mm.minPD = v.pd;
                    if (o.mm.maxPK < v.pk) o.mm.maxPK = v.pk;
                    if (o.mm.minPK > v.pk) o.mm.minPK = v.pk;
                    if (o.mm.maxPSD < psd) o.mm.maxPSD = psd;
                    if (o.mm.minPSD > psd) o.mm.minPSD = psd;
                    if (o.mm.maxPSK < psk) o.mm.maxPSK = psk;
                    if (o.mm.minPSK > psk) o.mm.minPSK = psk;

                    o.rs.push([f, c, v.s, v.d, v.k, sd, sk, v.pd, v.pk, psd, psk, type]);
                }
            }
        });
    }

    return o;
}

function showFavTable() {
    let favs = getFavorites();
    let favEl = document.getElementById("statfavorites");
    if (favs.length > 0) {
        let favStats = loadStatRows(favs);
        // TODO: get rows correctly, show table correctly, need ParticipantID in data


        if (isPersonal) {
            let b64favs = btoa(localStorage.getItem(favsKey)).replace(/=/gi, "-");

            let s = '<h2 class="hcv">Favoritter (max ' + maxFavorites + ')</h2>' +
                '<p class="toggler small off" id="shareFavs">Del dine favoritter</p>' +
                '<div class="cf"><p>Kopier linket her og send det til dem du vil dele dine favoritter med</p><textarea style="width: 100%; max-width: 100%; font-size: 12px;">' + getStatsLink().split("&")[0] + '&f=' + b64favs + '</textarea><br /></div>' +
                '<table data-max="600" class="individuals favorites rscaled colorBars"><tr><th>Navn</th><th>Dage</th><th>KM</th><th>Fritid<br>Dage</th><th><br>KM</th><th>Samlet<br>KM</th><th></th></tr>';
            for (let i = 0; i < favStats.rs.length; i++) {
                let r = favStats.rs[i];

                let itag = '<br><i>Hold: ' + r[6] + '</i><i>' + (r[10] !== r[11] ? r[10] + "</i><i>" : "") + r[11] + '</i><i>postnr: ' + r[9] + '</i>';
                s += '<tr data-id="' + r[0] + '"><td>' + r[1] + itag + '</td><td>' + drawBar(r[2], tableData.maxD, false, extraE(' dag', r[2])) + '</td><td>' + drawBar(r[3], tableData.maxK, false, ' km') +
                    '</td><td>' + drawBar(r[4], tableData.maxPD, false, extraE(' dag', r[4])) + '</td><td>' + drawBar(r[5], tableData.maxPK, false, ' km') + '</td>' +
                    '<td>' + drawBar(r[3] + r[5], tableData.maxK + tableData.maxPK, false, ' km') + '</td><td><a class="fav rem">-</a></td></tr>';
            }

            favEl.innerHTML = s + "</table>";

            let share = document.getElementById("shareFavs");
            if (share) {
                share.addEventListener("click", function (e) {
                    toggle(e);
                });
            }

            addEvents("#statfavorites a.fav", "click", function (e) {
                stopAll(e);
                let tr = e.target.closest("tr");
                let id = tr.getAttribute("data-id");
                removeFavorite(id);
            });
        }
        else {
            if (!miniView) {
                let simple = hasClass(document.getElementById("statfilter"), "simple");

                let b64favs = btoa(localStorage.getItem(favsKey)).replace(/=/gi, "-");

                let s = '<h2 class="hcv">Favoritter (max ' + maxFavorites + ')</h2>' +
                    '<p class="toggler small off" id="shareFavs">Del dine favoritter</p>' +
                    '<div class="cf"><p>Kopier linket her og send det til dem du vil dele dine favoritter med</p><textarea style="width: 100%; max-width: 100%; font-size: 12px;">' + getStatsLink().split("&")[0] + '&f=' + b64favs + '</textarea><br /></div>' +
                    `<table data-max="900" class="teams favorites rscaled colorBars">
                    <tr><th>Navn<br><br></th><th>Deltagere<br><br></th><th><br>Dage<br><br></th><th>KM<br />(kg CO<sub>2</sub> sparet)</th><th>Dage<br>/deltager</th><th>KM<br>/deltager</th>` +
                    (simple ? '</tr>' : `<th>Fritid<br>Dage<br><br></th><th>KM<br><br></th><th>dage<br>/deltager</th><th>KM<br>/deltager</th><th>Samlet<br>KM<br><br></th><th>KM<br>/deltager</th><th></th></tr>`);

                for (let i = 0; i < favStats.rs.length; i++) {
                    let itag = '';
                    let r = favStats.rs[i];

                    if (r.length >= 14 && r[14] === "teams") itag = '<br><i>' + (r[11] !== r[12] ? r[11] + "</i><i>" : "") + r[12] + '</i><i>postnr: ' + r[13] + '</i>';
                    let n = escapeHTML(r[1].replace(/<br \/>/gi, "\n")).replace(/\n/gi, "<br />");
                    s += '<tr data-id="' + r[0] + '"><td>' +
                        (window.campaignConfigId != 1 ? '<a target="_blank" href="' + pdfUrl + cleanEncodeURIComponent(r[1]) + '&url=' + cleanEncodeURIComponent(selfHost() + '/csr?pdf=1&cid=' + statsCampaignId + '&id=' + r[0] + '||totals|Total') + '">' + n + '</a>' : '<strong class="name">' + n + '</strong>') + itag + '</td>' +
                        '<td>' + r[2] + '</td><td>' + drawBar(r[3], favStats.mm.maxD, false, extraE(' dag', r[3])) + '</td><td>' + drawBar(r[4], favStats.mm.maxK, false, ' km <i>(' + toComma(r[4] * co2factor, true) + ' kg CO<sub>2</sub>)</i>') +
                        '</td><td>' + drawBar(r[5], favStats.mm.maxSD, false, extraE(' dag', r[5])) + '</td><td>' + drawBar(r[6], favStats.mm.maxSK, false, ' km') + '</td>' +
                        (simple ? '</tr>' : '<td>' + drawBar(r[7], tableData.maxPD, false, extraE(' dag', r[7])) + '</td><td>' + drawBar(r[8], tableData.maxPK, false, ' km') + '</td>' +
                            '<td>' + drawBar(r[9], tableData.maxPSD, false, extraE(' dag', r[9])) + '</td><td>' + drawBar(r[10], tableData.maxPSK, false, ' km') + '</td>' +
                            '<td>' + drawBar(r[4] + r[8], tableData.maxK + tableData.maxPK, false, ' km') + '</td><td>' + drawBar(r[6] + r[10], tableData.maxSK + tableData.maxPSK, false, ' km') + '</td><td><a class="fav rem">-</a></td></tr>');
                }

                let vs = getVSHtml(favStats);

                favEl.innerHTML = s + "</table>" + vs;

                let share = document.getElementById("shareFavs");
                if (share) {
                    share.addEventListener("click", function (e) {
                        toggle(e);
                    });
                }

                addEvents("#statfavorites a.fav", "click", function (e) {
                    stopAll(e);
                    let tr = e.target.closest("tr");
                    let id = tr.getAttribute("data-id");
                    removeFavorite(id);
                });
            }
            else {
                let s = '';
                for (let i = 0; i < favStats.rs.length; i++) {
                    let r = favStats.rs[i];
                    s += '<h4>' + r[1] + ' ' + toComma(r[2], true) + ' deltagere</h4><p>' + toComma(r[4], true) + ' km og ' + toComma(r[3], true) + ' cykeldag' + (r[3] == 1 ? '' : 'e') + '</p>';
                }
                favEl.innerHTML = s;
            }
        }

        if (favStats.rs.length === 0) {
            favEl.innerHTML = "";
        }
    }
    else {
        favEl.innerHTML = "";
    }
    window.setDataScale();
}

function extraE(s, n) {
    return s + (n === 1 ? '' : 'e');
}

function getVSHtml(fs) {
    if (window.campaignConfigId == 1) return "";
    let s = '<div class="' + (fs.rs.length > 1 ? 'rscaled ' : '') + 'vs vs' + fs.rs.length + '" data-max="1170">';
    if (fs.rs.length === 1) {
        let r = fs.rs[0];
        s += '<div class="heading"><div class="badge">' + allSVGs["vsalt"] + '</div><strong>' + r[1] + '</strong><br /><small>(' + r[2] + ' deltagere)</small><div class="badge">' + allSVGs["vsalt"] + '</div></div><div class="content"><div class="co c4 r">' +
            '<div class="c"><h3>Cykeldage pr. deltager</h3>' + drawBar(r[5], fs.mm.maxD, false, extraE(' dag', r[5]), allSVGs["mbike"]) + '</div>' +
            '<div class="c"><h3>Cykeldage alle deltagere</h3>' + drawBar(r[3], fs.mm.maxD, false, extraE(' dag', r[5]), allSVGs["mbike"]) + '</div>' +
            '<div class="c"><h3>km pr. deltager</h3>' + drawBar(r[6], fs.mm.maxK, false, 'km', allSVGs["mbike"]) + '</div>' +
            '<div class="c"><h3>km alle deltagere</h3>' + drawBar(r[4], fs.mm.maxK, false, 'km', allSVGs["mbike"]) + '</div>' +
            '</div><h3>Så meget sparer I tilsammen ved at cykle fremfor at køre i bil i henholdsvis kg CO2, antal sygedage og samfundsøkonomisk gevinst</h3><div class="co c3">' +
            '<div class="c"><div>' + allSVGs["tree"] + '</div><span>' + toComma(r[4] * co2factor, true) + ' kg CO<sub>2</sub></span></div>' +
            '<div class="c"><div>' + allSVGs["heart"] + '</div><span>' + toComma(r[4] / daysSavedFactor, true) + extraE(' dag', r[4] / daysSavedFactor) + '</span></div>' +
            '<div class="c"><div>' + allSVGs["bank"] + '</div><span>' + toComma(r[4] * krSavedFactor, true) + ' DKK</span></div>' +
            '</div></div>';
    }
    else {
        s += '<div><div class="th">';
        forEach(fs.rs, function (r, i) {
            s += '<div>' + (i > 0 ? '<div class="badge">' + allSVGs["vs"] + '</div>' : '') + '<strong>' + r[1] + '</strong><br /><small>(' + r[2] + ' deltagere)</small></div>';
        });
        s += '</div><div><div class="all"><h3 class="close">Cykeldage pr. deltager</h3></div></div><div>';

        forEach(fs.rs, function (r, i) {
            s += '<div><div class="barmax">' + drawBar(r[5], fs.mm.maxSD, false, extraE(' dag', r[5]), allSVGs["mbike"]) + '</div></div>';
        });
        s += '</div><div><div class="all"><h3 class="close">Cykeldage alle deltagere</h3></div></div><div>';

        forEach(fs.rs, function (r, i) {
            s += '<div><div class="barmax">' + drawBar(r[3], fs.mm.maxD, false, extraE(' dag', r[5]), allSVGs["mbike"]) + '</div></div>';
        });

        s += '</div><div><div class="all"><h3 class="close">km pr. deltager</h3></div></div><div>';
        forEach(fs.rs, function (r, i) {
            s += '<div><div class="barmax">' + drawBar(r[6], fs.mm.maxSK, false, 'km', allSVGs["mbike"]) + '</div></div>';
        });

        s += '</div><div><div class="all"><h3 class="close">km alle deltagere</h3></div></div><div>';
        forEach(fs.rs, function (r, i) {
            s += '<div><div class="barmax">' + drawBar(r[4], fs.mm.maxK, false, 'km', allSVGs["mbike"]) + '</div></div>';
        });

        s += '</div><div><div class="all"><h3>Så mange kg co2 har I sammen sparet ved at cykle fremfor at køre i bil</h3></div></div><div>';
        forEach(fs.rs, function (r, i) {
            s += '<div><div class="scaled"><div style="height: ' + (10 + (r[4] > 0 ? r[4] / fs.mm.maxK : 0) * 90) + 'px">' + allSVGs["tree"] + '</div></div><span class="num">' + toComma(r[4] * co2factor, true) + ' kg CO<sub>2</sub></span></div>';
        });

        s += '</div><div><div class="all"><h3>I sparer også sygedage</h3></div></div><div>';
        forEach(fs.rs, function (r, i) {
            s += '<div><div class="scaled"><div style="height: ' + (10 + (r[4] > 0 ? r[4] / fs.mm.maxK : 0) * 90) + 'px">' + allSVGs["heart"] + '</div></div><span class="num">' + toComma(r[4] / daysSavedFactor, true) + extraE(' dag', r[4] / daysSavedFactor) + '</span></div>';
        });

        s += '</div><div><div class="all"><h3>…og skaber en samfundsøkonomisk gevinst</h3></div></div><div>';
        forEach(fs.rs, function (r, i) {
            s += '<div><div class="scaled"><div style="height: ' + (10 + (r[4] > 0 ? r[4] / fs.mm.maxK : 0) * 90) + 'px">' + allSVGs["bank"] + '</div></div><span class="num">' + toComma(r[4] * krSavedFactor, true) + ' DKK</span></div>';
        });
    }

    return s + '</div>';
}

function sendEvent(el, e) {
    let event;
    if (typeof (Event) === 'function') {
        event = new Event(e);
    } else {
        event = new Event(e, { bubbles: true, cancelable: true });
    }

    el.dispatchEvent(event);
}

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

function setFilterData(by) {
    if (isPersonal) {
        let dl = document.getElementById("filterdata");
        let s = "";
        if (by) {
            let dict = apiData[statsKey][by];
            if (!dict) {
                dict = {};
                apiData[statsKey][by] = dict;
                forEach(apiData[statsKey]["riders"], function (r) {
                    if (!dict[r[by]]) dict[r[by]] = 1;
                });
            }
            Object.keys(dict).forEach(function (key) {
                s += '<option>' + key + '</option>';
            });
        }
        dl.innerHTML = s;
    }
    else {
        let show = document.querySelector("select[name='show']").value;
        let dl = document.getElementById("filterdata");
        let s = "";
        if (by && show !== "totals") {
            let dict = apiData[statsKey][by];
            Object.keys(dict).forEach(function (key) {
                if (key.indexOf("\u0007") > 0) {
                    let parts = key.split("\u0007");
                    if (parts.length > 1) s += '<option>' + parts[1] + '</option>';
                }
                else {
                    s += '<option>' + key + '</option>';
                }
            });
        }
        dl.innerHTML = s;
    }
}

function sortByColumn(a, index, order) {
    a.sort(sortFunction);

    function sortFunction(a, b) {
        let c = a[index];
        let d = b[index];
        if (c < d) {
            return order === 0 ? -1 : 1;
        }
        if (c > d) {
            return order === 0 ? 1 : -1;
        }
        return 0;
    }

    return a;
}

function dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    };
}

function dynamicSortMultiple() {
    const props = arguments;
    return function (obj1, obj2) {
        let i = 0, result = 0;
        const numberOfProperties = props.length;
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i])(obj1, obj2);
            i++;
        }
        return result;
    }
}


function goCompanies() {
    document.querySelector("select[name='by']").value = "companies";
    let sw = document.querySelector("select[name='show']");
    sw.value = "companies";
    sendEvent(sw, "change");
}

function goTeams() {
    document.querySelector("select[name='by']").value = "teams";
    let sw = document.querySelector("select[name='show']");
    sw.value = "teams";
    sendEvent(sw, "change");
}

function showStatsTable(all) {
    if (isPersonal) {
        showPersonalStatsTable(all);
    }
    else {
        showTeamStatsTable(all);
    }
}
function showTeamStatsTable(all) {
    let rs = [];
    let show = document.querySelector("select[name='show']").value;
    let by = document.querySelector("select[name='by']").value;
    let filter = document.querySelector("input[name='filter']").value;

    let searchLinks = document.getElementById("searchLinks");
    let filterExact = filter.endsWith('$');
    if (filterExact) filter = filter.substring(0, filter.length - 1);
    if (filter) {
        if (show === "teams" && by === "teams") {
            searchLinks.innerHTML = '<a class="link" href="#" onclick="goCompanies(); return false;">Søg efter "' + escapeHTML(filter) + '" i ' + localText("General.Workplace", true, apiData[statsKey].campaignConfigId) + '</a>';
            removeClass(searchLinks, "hidden");
        }
        else if (show === "companies") {
            searchLinks.innerHTML = '<a class="link" href="#" onclick="goTeams();  return false;">Søg efter "' + escapeHTML(filter) + '" i hold</a>';
            removeClass(searchLinks, "hidden");
        }
        else {
            addClass(searchLinks, "hidden");
        }

        filter = filter.toLowerCase();
    }
    else {
        addClass(searchLinks, "hidden");
    }
    if (all) {
        rs = tableData.rows;
    }
    else {
        let sort = document.querySelector("select[name='sort']").value;

        let loc = document.location;
        // TODO: does this line save current location to history before changing?
        // window.history.pushState({}, document.title, document.location);
        window.history.replaceState({}, document.title, loc.protocol + "//" + loc.host + loc.pathname + "?id=" + statsCampaignId + "&show=" + encodeURIComponent(show) +
            "&filter=" + encodeURIComponent(filter) + (filterExact ? '$' : '') + "&by=" + encodeURIComponent(by) +
            "&s=" + (urlParam("s") === "1" ? "1" : "") + "&r=" + (urlParam("r") === "1" ? "1" : "") +
            "&cv=" + (urlParam("cv") !== null && urlParam("cv") !== 0 ? urlParam("cv") : "") + "&sort=" + sort);

        tableData.sort = parseInt(sort.split(",")[0]);
        tableData.order = parseInt(sort.split(",")[1]);
        tableData.maxD = 0;
        tableData.minD = 0;
        tableData.maxK = 0;
        tableData.minK = 0;
        tableData.maxSD = 0;
        tableData.minSD = 0;
        tableData.maxSK = 0;
        tableData.minSK = 0;

        tableData.maxPD = 0;
        tableData.minPD = 0;
        tableData.maxPK = 0;
        tableData.minPK = 0;
        tableData.maxPSD = 0;
        tableData.minPSD = 0;
        tableData.maxPSK = 0;
        tableData.minPSK = 0;
        if (show === "teams") {
            let hash = {};
            let useHash = false;
            if (by && by !== "teams") {
                useHash = true;
                let ids = [];
                let dict = apiData[statsKey][by];
                Object.keys(dict).forEach(function (key) {
                    let v = dict[key];
                    let klc = key.toLowerCase();
                    if (!filter || (filterExact ?
                        (klc === filter || (by === "companies" && klc.indexOf(`\x07${filter}\x07`) >= 0) || (by === "groups" && klc.indexOf(`${filter}\x07`) === 0))
                        : klc.indexOf(filter) >= 0)) {
                        ids = ids.concat(v.tis);
                    }
                });
                forEach(ids, function (id) {
                    hash[id] = 0;
                });
            }
            forEach(apiData[statsKey][show], function (t) {
                if ((useHash && hash.hasOwnProperty(t.ti)) || (!useHash && (!filter || (filterExact ? t.n.toLowerCase() === filter : t.n.toLowerCase().indexOf(filter) >= 0)))) {
                    let sd = t.d / t.s;
                    let sk = t.k / t.s;
                    if (tableData.maxD < t.d) tableData.maxD = t.d;
                    if (tableData.minD > t.d) tableData.minD = t.d;
                    if (tableData.maxK < t.k) tableData.maxK = t.k;
                    if (tableData.minK > t.k) tableData.minK = t.k;
                    if (tableData.maxSD < sd) tableData.maxSD = sd;
                    if (tableData.minSD > sd) tableData.minSD = sd;
                    if (tableData.maxSK < sk) tableData.maxSK = sk;
                    if (tableData.minSK > sk) tableData.minSK = sk;

                    let psd = t.pd / t.s;
                    let psk = t.pk / t.s;
                    if (tableData.maxPD < t.pd) tableData.maxPD = t.pd;
                    if (tableData.minPD > t.pd) tableData.minPD = t.pd;
                    if (tableData.maxPK < t.pk) tableData.maxPK = t.pk;
                    if (tableData.minPK > t.pk) tableData.minPK = t.pk;
                    if (tableData.maxPSD < psd) tableData.maxPSD = psd;
                    if (tableData.minPSD > psd) tableData.minPSD = psd;
                    if (tableData.maxPSK < psk) tableData.maxPSK = psk;
                    if (tableData.minPSK > psk) tableData.minPSK = psk;

                    rs.push([t.ti, escapeHTML(t.n), t.s, t.d, t.k, sd, sk, t.pd, t.pk, psd, psk, t.g, t.c, t.z, t.k + t.pk, sk + psk]);
                }
            });
        }
        else if (show === "companies") {
            let dict = apiData[statsKey][show];
            Object.keys(dict).forEach(function (key) {
                let v = dict[key];
                let klc = key.toLowerCase();

                if (!filter
                    || (filterExact ? (klc === filter || (by === "companies" && klc.indexOf(`\x07${filter}\x07`) >= 0) || (by === "groups" && klc.indexOf(`${filter}\x07`) === 0)) : klc.indexOf(filter) >= 0)
                    || v.r.toLowerCase() === filter
                    || v.m.toLowerCase() === filter
                ) {

                    let gc = key.split("\u0007");
                    let c = gc[0].toLowerCase() !== gc[1].toLowerCase() ? escapeHTML(gc[0]) + '<br />' + escapeHTML(gc[1]) : escapeHTML(gc[1]);
                    c += "<br /><i>postnr: " + gc[2] + "</i>";

                    let sd = v.d / v.s;
                    let sk = v.k / v.s;
                    if (tableData.maxD < v.d) tableData.maxD = v.d;
                    if (tableData.minD > v.d) tableData.minD = v.d;
                    if (tableData.maxK < v.k) tableData.maxK = v.k;
                    if (tableData.minK > v.k) tableData.minK = v.k;
                    if (tableData.maxSD < sd) tableData.maxSD = sd;
                    if (tableData.minSD > sd) tableData.minSD = sd;
                    if (tableData.maxSK < sk) tableData.maxSK = sk;
                    if (tableData.minSK > sk) tableData.minSK = sk;

                    let psd = v.pd / v.s;
                    let psk = v.pk / v.s;
                    if (tableData.maxPD < v.pd) tableData.maxPD = v.pd;
                    if (tableData.minPD > v.pd) tableData.minPD = v.pd;
                    if (tableData.maxPK < v.pk) tableData.maxPK = v.pk;
                    if (tableData.minPK > v.pk) tableData.minPK = v.pk;
                    if (tableData.maxPSD < psd) tableData.maxPSD = psd;
                    if (tableData.minPSD > psd) tableData.minPSD = psd;
                    if (tableData.maxPSK < psk) tableData.maxPSK = psk;
                    if (tableData.minPSK > psk) tableData.minPSK = psk;

                    rs.push([key, c, v.s, v.d, v.k, sd, sk, v.pd, v.pk, psd, psk, null, null, null, v.k + v.pk, sk + psk]);
                }
            });
        }
        else {
            let dict = apiData[statsKey][show];
            Object.keys(dict).forEach(function (key) {
                let v = dict[key];
                let klc = key.toLowerCase();
                if (!filter
                    || (filterExact ? (klc.indexOf(`\x07`) > 0 ? klc.indexOf(`\x07${filter}\x07`) >= 0 : klc === filter) : klc.indexOf(filter) >= 0)
                    || (show === "municipalities" && filterExact ? v.r?.toLowerCase() === filter : v.r?.toLowerCase().indexOf(filter) >= 0)) {
                    let sd = v.d / v.s;
                    let sk = v.k / v.s;
                    if (tableData.maxD < v.d) tableData.maxD = v.d;
                    if (tableData.minD > v.d) tableData.minD = v.d;
                    if (tableData.maxK < v.k) tableData.maxK = v.k;
                    if (tableData.minK > v.k) tableData.minK = v.k;
                    if (tableData.maxSD < sd) tableData.maxSD = sd;
                    if (tableData.minSD > sd) tableData.minSD = sd;
                    if (tableData.maxSK < sk) tableData.maxSK = sk;
                    if (tableData.minSK > sk) tableData.minSK = sk;

                    let psd = v.pd / v.s;
                    let psk = v.pk / v.s;
                    if (tableData.maxPD < v.pd) tableData.maxPD = v.pd;
                    if (tableData.minPD > v.pd) tableData.minPD = v.pd;
                    if (tableData.maxPK < v.pk) tableData.maxPK = v.pk;
                    if (tableData.minPK > v.pk) tableData.minPK = v.pk;
                    if (tableData.maxPSD < psd) tableData.maxPSD = psd;
                    if (tableData.minPSD > psd) tableData.minPSD = psd;
                    if (tableData.maxPSK < psk) tableData.maxPSK = psk;
                    if (tableData.minPSK > psk) tableData.minPSK = psk;

                    rs.push([key, key, v.s, v.d, v.k, sd, sk, v.pd, v.pk, psd, psk, null, null, null, v.k + v.pk, sk + psk]);
                }
            });
        }
        rs = sortByColumn(rs, tableData.sort, tableData.order);

        tableData.rows = rs;
    }
    let max = all ? rs.length : rs.length > 100 ? 100 : rs.length;
    let simple = hasClass(document.getElementById("statfilter"), "simple");

    if (miniView) {

        let s = '<h4>Hold</h4>';
        let table = document.querySelector("#stattable");

        for (let i = 0; i < max; i++) {
            let r = rs[i];
            s += '<p class="close">' + r[1] + '<br />' + toComma(r[2], true) + ' deltagere ' + toComma(r[4], true) + ' km og ' + toComma(r[3], true) + ' cykeldag' + (r[3] == 1 ? '' : 'e') + '</p>';
        }

        table.innerHTML = s;
    }
    else {
        let table = document.querySelector("#stattable table");
        table.classList.add("teams");
        let s = '<tr><th><a><br>Navn<br><br></a></th><th><a>Deltagere<br><br></a></th><th><a>Dage<br><br></a></th><th><a>KM<br />(kg CO<sub>2</sub> sparet)</a></th><th><a>Dage<br>/deltager</a></th><th><a>KM<br>/deltager</a></th>' +
            (simple ? '</tr>' : '<th><a>Fritid<br>Dage<br><br></a></th><th><a>KM<br><br></a></th><th><a>Dage<br>/deltager</a></th><th><a>KM<br>/deltager</a></th><th><a data-sort="14">Samlet<br>KM<br><br></a></th><th><a data-sort="15">KM<br>/deltager</a></th><th></th></tr>');
        let linkName = show === "totals" || (show === "teams" && window.campaignConfigId == 1) ? false : true;

        for (let i = 0; i < max; i++) {
            let itag = '';
            let r = rs[i];
            let name = linkName ? '<a class="name">' + r[1] + '</a>' : `<strong class="name">${r[1]}</strong>`;
            if (show === "teams") itag = '<br><i>' + (r[11] !== r[12] ? r[11] + "</i><i>" : "") + r[12] + '</i><i>postnr: ' + r[13] + '</i>';
            s += '<tr data-id="' + r[0] + '"><td>' + name + itag + '</td><td>' + r[2] + '</td><td>' + drawBar(r[3], tableData.maxD, false, extraE(' dag', r[3])) + '</td><td>' + drawBar(r[4], tableData.maxK, false, ' km <i>(' + toComma(r[4] * co2factor, true) + ' kg CO<sub>2</sub>)</i>') +
                '</td><td>' + drawBar(r[5], tableData.maxSD, false, extraE(' dag', r[5])) + '</td><td>' + drawBar(r[6], tableData.maxSK, false, ' km') + '</td>' +
                (simple ? '</tr>' : '<td>' + drawBar(r[7], tableData.maxPD, false, extraE(' dag', r[7])) + '</td><td>' + drawBar(r[8], tableData.maxPK, false, ' km') + '</td>' +
                    '<td>' + drawBar(r[9], tableData.maxPSD, false, extraE(' dag', r[9])) + '</td><td>' + drawBar(r[10], tableData.maxPSK, false, ' km') + '</td>' +
                    '<td>' + drawBar(r[4] + r[8], tableData.maxK + tableData.maxPK, false,' km') + '</td><td>' + drawBar(r[6] + r[10], tableData.maxSK + tableData.maxPSK, false,' km') + '</td>' +
                    '<td><a class="fav">+</a></td></tr>');
        }

        table.setAttribute("data-show", show);
        table.innerHTML = s;

        let statinfo = document.querySelector("#statinfo");
        s = "";
        if (max < rs.length) {
            s += '<p>Viser de første 100 resultater<br /><a href="#" class="showall">Vis alle ' + rs.length + ' resultater</a></p>';
        }
        else {
            s += '<p>' + rs.length + " resultat" + (rs.length !== 1 ? "er" : "") + '</p>';
        }
        if (window.campaignConfigId != 1 && (urlParam("cv") === null || urlParam("cv") === 0)) {
            s += '<p><a href="' + VctaAPIUrl + 'teams/' + statsCampaignId + '/true" target="_blank">Hent statistik for hele kampagnen som CSV fil til Excel</a></p>';

            if (by === "groups" || (show === "groups" && hasClass(by.closest("div"), "hidden"))) {
                if (JSON.stringify(getFavorites()).toLowerCase().indexOf('"groups|' + filter.toLowerCase() + '"') >= 0) {
                    let loc = getStatsLink();
                    let linkTeamsLatest = loc + "sort=0,1" + "&f=" + encodeURIComponent(JSON.stringify(getFavorites()));
                    let linkTeamsMost = loc + "sort=3,1" + "&f=" + encodeURIComponent(JSON.stringify(getFavorites()));
                    s += '<p><a href="' + linkTeamsLatest.replace("&cv=&", "&cv=1&") + '">Link til organisationen vist med seneste hold først (stor skærm)</a></p>';
                    s += '<p><a href="' + linkTeamsLatest.replace("&cv=&", "&cv=2&") + '">Link til organisationen vist med seneste hold først (lille skærm)</a></p>';
                    s += '<p><a href="' + linkTeamsMost.replace("&cv=&", "&cv=1&") + '">Link til organisationen vist med holdet med flest cykeldage først (stor skærm)</a></p>';
                    s += '<p><a href="' + linkTeamsMost.replace("&cv=&", "&cv=2&") + '">Link til organisationen vist med holdet med flest cykeldage først (lille skærm)</a></p>';
                }
            }
        }

        statinfo.innerHTML = s;

        setStatsTableDataMax();

        let ths = table.querySelectorAll("th");
        forEach(ths, function (el, i) {
            let a = el.querySelector("a");
            if (a) {
                if (!a.dataset.sort) a.setAttribute("data-sort", i + 1);
                a.addEventListener("click", function (e) {
                    let sort = document.querySelector("select[name='sort']");
                    let s = parseInt(e.target.getAttribute("data-sort"));
                    let o = s !== tableData.sort ? (s === 1 ? 0 : 1) : (tableData.order === 0 ? 1 : 0);
                    sort.value = s + "," + o;
                    sendEvent(sort, "change");
                    stopAll(e);
                });
            }
            if ((!a && i === tableData.sort - 1) || (a && a.dataset.sort == tableData.sort)) {
                addClass(el, "sort");
                if (tableData.order === 0) {
                    removeClass(el, "down");
                }
                else {
                    addClass(el, "down");
                }
            }
            else {
                removeClass(el, "sort");
            }
        });

        addEvents("#stattable a.name", "click", function (e) {
            stopAll(e);
            let ds = document.querySelector("#stattable table").getAttribute("data-show");
            let v = e.target.textContent.split('\n')[0];
            let sw = document.querySelector("select[name='show']");
            if (sw.value === "regions") {
                document.querySelector("select[name='by']").value = "municipalities";
                document.querySelector("input[name='filter']").value = v + '$';
                sw.value = "municipalities";
            }
            else if (sw.value === "municipalities") {
                document.querySelector("select[name='by']").value = "companies";
                document.querySelector("input[name='filter']").value = v + '$';
                sw.value = "companies";
            }
            else if (sw.value === "groups") {
                document.querySelector("select[name='by']").value = "groups";
                document.querySelector("input[name='filter']").value = v + '$';
                sw.value = "companies";
            }
            else if (sw.value === "companies") {
                let a = [];
                const iterator = document.createNodeIterator(
                    e.target,
                    NodeFilter.SHOW_TEXT,
                    null
                );
                let node;
                while (node = iterator.nextNode()) { a.push(node.textContent) }
                document.querySelector("select[name='by']").value = "companies";
                document.querySelector("input[name='filter']").value = (a.length > 2 ? a[1] : a[0]) + '$';
                sw.value = "teams";
            }
            else if (sw.value === "zips") {
                document.querySelector("select[name='by']").value = "zips";
                document.querySelector("input[name='filter']").value = v;
                sw.value = "companies";
            }
            else if (sw.value === "teams" && window.campaignConfigId != 1) {
                let loc = "/pstats?id=" + statsCampaignId + "&by=tn&filter=" + v + '$'
                window.open(loc);
            }
            else {
                document.querySelector("select[name='by']").value = ds;
                document.querySelector("input[name='filter']").value = v + '$';
                sw.value = "teams";
            }
            sendEvent(sw, "change");
        });

        addEvents("#stattable a.fav", "click", function (e) {
            stopAll(e);
            let tr = e.target.closest("tr");
            let id = tr.getAttribute("data-id");
            let show = tr.closest("table").getAttribute("data-show");
            addFavorite(show + "|" + id);
        });

        let showAll = document.querySelector("a.showall");
        if (showAll) {
            showAll.addEventListener("click", function (e) {
                if (tableData.rows.length > 1000) {
                    addBrief("Det kan tage nogle sekunder at tegne tabellen når der er mange resultater.");
                    setTimeout(function () { showStatsTable(true); }, 200);
                }
                else {
                    showStatsTable(true);
                }
                stopAll(e);
            });
        }
    }
}


function showPersonalStatsTable(all) {
    let rs = [];
    let by = document.querySelector("select[name='by']").value;
    let filter = document.querySelector("input[name='filter']").value;
    let filterExact = filter.endsWith('$');
    if (filterExact) filter = filter.substring(0, filter.length - 1);
    if (filter) {
        filter = filter.toLowerCase();
    }
    if (all) {
        rs = tableData.rows;
    }
    else {
        let sort = document.querySelector("select[name='sort']").value;

        let loc = document.location;
        window.history.replaceState({}, document.title, loc.protocol + "//" + loc.host + loc.pathname + "?id=" + statsCampaignId +
            "&filter=" + encodeURIComponent(filter) + (filterExact ? '$' : '') + "&by=" + encodeURIComponent(by) + "&sort=" + sort);

        tableData.sort = parseInt(sort.split(",")[0]);
        tableData.order = parseInt(sort.split(",")[1]);
        tableData.maxD = 0;
        tableData.minD = 0;
        tableData.maxK = 0;
        tableData.minK = 0;

        tableData.maxPD = 0;
        tableData.minPD = 0;
        tableData.maxPK = 0;
        tableData.minPK = 0;

        forEach(apiData[statsKey].riders, function (p) {
            if (!filter || (filter && (by == "z" ? p[by] == filter : p[by] && filterExact ? p[by].toLowerCase() === filter : p[by].toLowerCase().indexOf(filter) >= 0))) {
                if (tableData.maxD < p.d) tableData.maxD = p.d;
                if (tableData.minD > p.d) tableData.minD = p.d;
                if (tableData.maxK < p.k) tableData.maxK = p.k;
                if (tableData.minK > p.k) tableData.minK = p.k;
                if (tableData.maxPD < p.pd) tableData.maxPD = p.pd;
                if (tableData.minPD > p.pd) tableData.minPD = p.pd;
                if (tableData.maxPK < p.pk) tableData.maxPK = p.pk;
                if (tableData.minPK > p.pk) tableData.minPK = p.pk;
                rs.push([p.pi, p.n, p.d, p.k, p.pd, p.pk, p.tn, p.r, p.m, p.z, p.g, p.c, p.k + p.pk]);
            }
        });

        rs = sortByColumn(rs, tableData.sort, tableData.order);

        tableData.rows = rs;
    }
    let max = all ? rs.length : rs.length > 100 ? 100 : rs.length;

    let table = document.querySelector("#stattable table");
    table.classList.add("individuals");

    let s = '<tr><th><a>Navn</a></th><th><a>Dage</a></th><th><a>KM</th><th><a>Fritid<br>Dage</a></th><th><a>KM</a></th><th><a data-sort="12">Samlet<br>KM</a></th><th></th></tr>';

    for (let i = 0; i < max; i++) {
        let r = rs[i];
        let name = escapeHTML(r[1]);
        let itag = '<br><i>Hold: ' + r[6] + '</i><br /><i>' + (r[10] !== r[11] ? r[10] + "</i><i>" : "") + r[11] + '</i><i>postnr: ' + r[9] + '</i>';
        s += '<tr data-id="' + r[0] + '"><td>' + name + itag + '</td><td>' + drawBar(r[2], tableData.maxD, false, extraE(' dag', r[2])) + '</td><td>' + drawBar(r[3], tableData.maxK, false, ' km') +
            '</td><td>' + drawBar(r[4], tableData.maxPD, false, extraE(' dag', r[4])) + '</td><td>' + drawBar(r[5], tableData.maxPK, false, ' km') + '</td>' +
            '<td>' + drawBar(r[3] + r[5], tableData.maxK + tableData.maxPK, false, ' km') + '</td><td><a class="fav">+</a></td></tr>';
    }

    table.innerHTML = s;

    let statinfo = document.querySelector("#statinfo");
    s = "";
    if (max < rs.length) {
        s += '<p>Viser de første 100 resultater<br /><a href="#" class="showall">Vis alle ' + rs.length + ' resultater</a></p>';
    }
    else {
        s += '<p>' + rs.length + " resultat" + (rs.length !== 1 ? "er" : "") + '</p>';
    }
    if (window.campaignConfigId != 1 && urlParam("cv") === null || urlParam("cv") === 0) {
        //s += '<p><a href="' + VctaAPIUrl + 'participants/' + statsCampaignId + '/true" target="_blank">Hent statistik for hele kampagnen som CSV fil til Excel</a></p>';

        if (by === "g") {
            if (JSON.stringify(getFavorites()).toLowerCase().indexOf('"groups|' + filter.toLowerCase() + '"') >= 0) {
                let loc = getStatsLink();
                let linkTeamsMost = loc + "sort=5,1" + "&f=" + encodeURIComponent(JSON.stringify(getFavorites()));
                s += '<p><a href="' + linkTeamsMost.replace("&cv=&", "&cv=1&") + '">Link til organisationen vist med deltageren med flest cykeldage først</a></p>';
            }
        }
    }

    statinfo.innerHTML = s;

    setStatsTableDataMax();

    let ths = table.querySelectorAll("th");
    forEach(ths, function (el, i) {
        let a = el.querySelector("a");
        if (a) {
            if (!a.dataset.sort) a.setAttribute("data-sort", i + 1);
            a.addEventListener("click", function (e) {
                let sort = document.querySelector("select[name='sort']");
                let s = parseInt(e.target.getAttribute("data-sort"));
                let o = s !== tableData.sort ? (s === 1 ? 0 : 1) : (tableData.order === 0 ? 1 : 0);
                sort.value = s + "," + o;
                sendEvent(sort, "change");
                stopAll(e);
            });
        }
        if ((!a && i === tableData.sort - 1) || (a && a.dataset.sort == tableData.sort)) {
            addClass(el, "sort");
            if (tableData.order === 0) {
                removeClass(el, "down");
            }
            else {
                addClass(el, "down");
            }
        }
        else {
            removeClass(el, "sort");
        }
    });

    addEvents("#stattable a.fav", "click", function (e) {
        stopAll(e);
        let tr = e.target.closest("tr");
        let id = tr.getAttribute("data-id");
        addFavorite(id);
    });

    let showAll = document.querySelector("a.showall");
    if (showAll) {
        showAll.addEventListener("click", function (e) {
            if (tableData.rows.length > 1000) {
                addBrief("Det kan tage nogle sekunder at tegne tabellen når der er mange resultater.");
                setTimeout(function () { showStatsTable(true); }, 200);
            }
            else {
                showStatsTable(true);
            }
            stopAll(e);
        });
    }
}


function getStatsLink() {
    return document.location.toString().split("sort=")[0].replace("&s=&", "&s=1&").replace("&r=&", "&r=1&").replace("show=groups", "show=teams");
}

function drawBar(v, max, notext, extra, graphic, height) {
    if (!height) height = 30;
    height -= 10;
    let scale = v > 0 ? v / max : 0;
    return (graphic ? '<span class="baricon" style="height: ' + (10 + height * scale) + 'px">' + graphic + '</span>' : '') + '<span class="bar"><span' + (v === max ? ' class="max"' : '') + ' style="width: ' + (scale * 100) + '%"></span></span>' + (notext ? "" : '<u>' + toComma(v, true)) + (extra ? extra : '') + '</u>';
}
document.addEventListener("readystatechange", (e) => {
    let count = window.domReadyEventListeners.length;
    if (document.readyState !== "loading") {
        window.domReadyEventListeners.forEach((l) => l());
        window.domReadyEventListeners = [];
    }
    console.log("rsc", document.readyState, count);
});

console.log("zl");
document.querySelector("html").classList.remove("jsshow");
